"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[29705],{

/***/ 28565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94455);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        banner: _defineProperty({
            height: 40,
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            backgroundColor: theme.palette.primary.main,
            justifyContent: 'center',
            color: theme.palette.common.white,
            '& a': {
                color: theme.palette.common.white,
                textDecoration: 'underline'
            }
        }, theme.breakpoints.down('md'), {
            height: 60,
            padding: theme.spacing(2),
            textAlign: 'center'
        })
    });
});
var Banner = function(param) {
    var banner = param.banner, t = param.t;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "banner ".concat(classes.banner),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            variant: 'h5',
            component: 'div',
            children: banner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                data: banner.data.text,
                defaultText: t('texts:banner:text')
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Banner);


/***/ }),

/***/ 41097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Basket_Basket; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(49161);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Drawer/Drawer.js
var Drawer = __webpack_require__(39636);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Backdrop/Backdrop.js
var Backdrop = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fab/Fab.js
var Fab = __webpack_require__(33758);
// EXTERNAL MODULE: ./components/Shop/QuantitySelector.tsx
var QuantitySelector = __webpack_require__(83230);
// EXTERNAL MODULE: ./typings/base.ts
var base = __webpack_require__(88039);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/DeleteForever.js
var DeleteForever = __webpack_require__(26688);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./utils/addToCart.tsx
var addToCart = __webpack_require__(63226);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
// EXTERNAL MODULE: ./components/ImgKitHandler/ImgKitHandler.tsx
var ImgKitHandler = __webpack_require__(26137);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./hooks/useTakeback.ts
var useTakeback = __webpack_require__(78931);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./components/Shop/TaxonPromotionBadge.tsx
var TaxonPromotionBadge = __webpack_require__(96780);
// EXTERNAL MODULE: ./redux/actions/basket.ts
var basket = __webpack_require__(4281);
;// CONCATENATED MODULE: ./components/Shop/BasketProductRow.tsx






















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var IMG_WIDTH = 95;
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1],
            margin: theme.spacing(1, 0),
            padding: theme.spacing(1)
        },
        notAvailable: {
            background: theme.extraColors.greyLight,
            border: "2px solid ".concat(theme.palette.error.main)
        },
        columnMedia: {
            flex: "0 0 ".concat(IMG_WIDTH, "px")
        },
        columnContent: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        isSize: (_obj = {}, _defineProperty(_obj, theme.breakpoints.down('sm'), {
            display: 'block'
        }), _defineProperty(_obj, '&>img', _defineProperty({}, theme.breakpoints.up('sm'), {
            width: 164,
            height: 164
        })), _obj),
        image: {
            display: 'block',
            width: 70,
            height: 70,
            objectFit: 'contain',
            overflow: 'hidden',
            borderRadius: theme.shape.borderRadius,
            '[data-ratio] &': {
                objectFit: 'contain'
            }
        },
        details: {
            flexGrow: 1,
            padding: theme.spacing(0, 0, 0, 0.5),
            '& > * + *': {
                marginTop: theme.spacing(1)
            }
        },
        detailsHead: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
        },
        row: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '& > * + *': {
                marginLeft: theme.spacing(1)
            }
        },
        productName: {
            textTransform: 'capitalize'
        },
        dailyPrice: {
            color: theme.palette.common.black,
            fontWeight: 'normal',
            padding: theme.spacing(0, 1)
        },
        availability: {
            margin: 0,
            color: theme.palette.error.main,
            '&.enought': {
                color: theme.palette.success.main
            }
        },
        sizes: {
            marginTop: theme.spacing(1)
        },
        sizesList: {
            border: "1px solid ".concat(theme.extraColors.grey),
            padding: theme.spacing(0.5),
            borderRadius: theme.shape.borderRadius,
            '&>.MuiButton-root': {
                padding: theme.spacing(1, 2),
                margin: theme.spacing(0.5),
                backgroundColor: theme.extraColors.greyLight,
                '&:hover, &:focus': {
                    backgroundColor: theme.extraColors.grey
                },
                '&.selected': {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover, &:focus': {
                        color: theme.palette.common.white,
                        backgroundColor: theme.palette.primary.main
                    }
                },
                '&.sold-out': {
                    opacity: 0.5,
                    color: theme.palette.error.main
                }
            }
        },
        isNotGender: {
            '&>div>div>.MuiButton-root': {
                padding: theme.spacing(1),
                minWidth: 34,
                width: 'auto',
                height: 34,
                lineHeight: '34px'
            }
        },
        basketSizes: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        basketSizesList: {
            maxWidth: 75,
            lineHeight: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        basketSizesLabel: {
            display: 'block',
            width: '100%',
            fontSize: 12,
            color: theme.extraColors.greyText
        },
        basketSizesItem: {
            lineHeight: 1,
            '&+span': {
                marginLeft: theme.spacing(1)
            }
        },
        nameProduct: {
            minHeight: 31,
            '&> span': {
                color: theme.palette.secondary.main,
                fontWeight: 400
            }
        },
        quantitySelector: {},
        smallText: {
            fontSize: 11,
            lineHeight: 1.1
        },
        smallTextGrey: {
            fontSize: 11,
            color: theme.extraColors.grey,
            display: 'inline-block'
        },
        smallMarginTop: {},
        delete: {
            width: 20,
            height: 20,
            minHeight: 20,
            padding: 0,
            boxShadow: 'none',
            background: 'none',
            '&:hover, &:focus': {
                color: theme.palette.error.main,
                background: 'none'
            },
            '& .MuiSvgIcon-root': {
                height: '.75em',
                width: '.75em'
            }
        },
        total: {},
        totalTryOut: {
            marginTop: theme.spacing(1.5)
        },
        valign: {
            display: 'flex',
            alignItems: 'center',
            '& .MuiGrid-container': {
                alignItems: 'center'
            }
        },
        priceContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 5
        },
        oldPrice: {
            textDecoration: 'line-through',
            opacity: 0.6
        },
        promoPrice: {
            display: 'flex',
            flexDirection: 'column'
        }
    });
});
var mapDispatchToProps = {
    setShowBasket: basket/* setShowBasket */.az
};
var BasketProductRow = function(param) {
    var id = param.id, name = param.name, stock1 = param.stock, photoThumb = param.photoThumb, priceRental = param.priceRental, basket = param.basket, availability = param.availability, parameters = param.parameters, isAvailable = param.isAvailable, buyAble = param.buyAble, cart = param.cart, variant = param.variant, dayRange = param.dayRange, isSki = param.isSki, isTryOut = param.isTryOut, locked = param.locked, loading = param.loading, hidePrice = param.hidePrice, showSizes = param.showSizes, settings = param.settings, _isSecondHand = param.isSecondHand, isSecondHand = _isSecondHand === void 0 ? false : _isSecondHand, unit = param.unit, units = param.units, takeback = param.takeback, takeBackStock = param.takeBackStock, productCode = param.productCode, productTaxons = param.productTaxons, promotions = param.promotions, setShowBasket1 = param.setShowBasket;
    var ref20, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var ref16 = (0,useCart/* useCart */.j)(), changeProductQuantityInCart = ref16.changeProductQuantityInCart, removeProductFromCart = ref16.removeProductFromCart, addProductToCart = ref16.addProductToCart;
    var classes = useStyles();
    var ref17 = (0,useMatomo/* default */.Z)(), trackEvent = ref17.trackEvent, pushInstruction = ref17.pushInstruction;
    var router = (0,next_router.useRouter)();
    var productCheckState = (0,useTakeback/* useTakeback */.C)().productCheckState;
    var ref18 = (0,react.useState)(0), variantPrice = ref18[0], setVariantPrice = ref18[1];
    var taxonPromotion = (0,utils/* getProductTaxonPromotion */.jt)(promotions, productTaxons);
    var displayFlexPrice = settings === null || settings === void 0 ? void 0 : settings.display_flex_price_a_day;
    var thumbRatio = (0,utils/* thumbnailRatio */.pm)(settings === null || settings === void 0 ? void 0 : settings.thumbnail_ratio);
    var states = productCheckState(takeback === null || takeback === void 0 ? void 0 : takeback.data);
    var disableDelete = basket === null || basket === void 0 ? void 0 : (ref20 = basket.data) === null || ref20 === void 0 ? void 0 : ref20.disable_product_removal;
    var disableQtySelector = basket === null || basket === void 0 ? void 0 : (ref1 = basket.data) === null || ref1 === void 0 ? void 0 : ref1.disable_quantity_change;
    (0,react.useEffect)(function() {
        !buyAble ? setVariantPrice(isTryOut ? variant.tryingOnPrice : variant.price.current) : setVariantPrice(variant.purchasePrice);
    }, []);
    var isSubscription =  false || "date_to_date" === 'classic_subscription';
    var isClassicSub = "date_to_date" === 'classic_subscription';
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var hidePriceInCart = basket === null || basket === void 0 ? void 0 : (ref2 = basket.data) === null || ref2 === void 0 ? void 0 : ref2.hide_price_per_day_in_cart;
    // Adolfo Dominguez: hide the "/dia" suffix on the per-line daily price in the cart
    var hideDayLabelInCart = "millet" === 'adolfo-dominguez';
    // For second-hand: use the first unit from the grouped units array
    // All units in the group have the same quality/condition
    var secondHandUnit = (units === null || units === void 0 ? void 0 : units[0]) || unit;
    var secondHandQuantity = (units === null || units === void 0 ? void 0 : units.length) || (unit ? 1 : 0);
    // Calculate total price for second-hand items in this group
    var secondHandTotalPrice = (0,react.useMemo)(function() {
        if (!isSecondHand) return {
            ht: 0,
            ttc: 0
        };
        // If grouped units are provided, sum their prices
        if (units === null || units === void 0 ? void 0 : units.length) {
            return units.reduce(function(total, u) {
                return {
                    ht: total.ht + (u.price_ht || 0),
                    ttc: total.ttc + (u.price || 0)
                };
            }, {
                ht: 0,
                ttc: 0
            });
        }
        // Fallback to single unit price (default behavior)
        return {
            ht: (unit === null || unit === void 0 ? void 0 : unit.price_ht) || 0,
            ttc: (unit === null || unit === void 0 ? void 0 : unit.price) || 0
        };
    }, [
        isSecondHand,
        units,
        unit
    ]);
    // const dispatch = useDispatch();
    var quantity1 = cart && (cart === null || cart === void 0 ? void 0 : (ref3 = cart.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.items) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && typeof cart.item.items.find(function(el) {
        return el.id === id;
    }) !== 'undefined' ? cart.item.items.find(function(el) {
        return el.id === id;
    }).quantity : 0;
    var productInCart = cart && cart.item && cart.item.items.length > 0 && typeof cart.item.items.find(function(el) {
        return el.product.variants[0].code === variant.code;
    }) !== 'undefined' && cart.item.items.find(function(el) {
        return el.product.variants[0].code === variant.code;
    });
    // Calculate available stock for second-hand items of the same quality
    var secondHandAvailableStock = (0,react.useMemo)(function() {
        var ref, ref19;
        if (!isSecondHand || !takeBackStock || !(secondHandUnit === null || secondHandUnit === void 0 ? void 0 : secondHandUnit.productCondition)) return 0;
        // Find the stock for this variant's SKU
        var stockForSku = takeBackStock.find(function(stock) {
            return stock.lizeeSKU === variant.sku;
        });
        if (!stockForSku) return 0;
        // Find products of the same quality
        var qualityStock = stockForSku.productsByQuality.find(function(q) {
            return q.quality === secondHandUnit.productCondition;
        });
        if (!qualityStock) return 0;
        // Get puids already in cart for this quality
        var puidsInCart = ((ref19 = productInCart === null || productInCart === void 0 ? void 0 : (ref = productInCart.units) === null || ref === void 0 ? void 0 : ref.filter(function(u) {
            return u.productCondition === secondHandUnit.productCondition;
        })) === null || ref19 === void 0 ? void 0 : ref19.map(function(u) {
            return u.puid;
        })) || [];
        // Available = total products of this quality - items already in cart
        var availableProducts = qualityStock.products.filter(function(p) {
            return !puidsInCart.includes(p.puid);
        });
        return availableProducts.length;
    }, [
        isSecondHand,
        takeBackStock,
        variant.sku,
        secondHandUnit === null || secondHandUnit === void 0 ? void 0 : secondHandUnit.productCondition,
        productInCart, 
    ]);
    // Handle second-hand quantity change (add or remove one item at a time)
    var onSecondHandQuantityChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(newQuantity) {
            var currentQuantity, ref, stockForSku, qualityStock, puidsInCart, availablePuid, data, lastUnit, secondHandParams;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        currentQuantity = secondHandQuantity;
                        if (!(newQuantity > currentQuantity)) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        if (!(secondHandAvailableStock <= 0)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        stockForSku = takeBackStock === null || takeBackStock === void 0 ? void 0 : takeBackStock.find(function(stock) {
                            return stock.lizeeSKU === variant.sku;
                        });
                        qualityStock = stockForSku === null || stockForSku === void 0 ? void 0 : stockForSku.productsByQuality.find(function(q) {
                            return q.quality === secondHandUnit.productCondition;
                        });
                        puidsInCart = (productInCart === null || productInCart === void 0 ? void 0 : (ref = productInCart.units) === null || ref === void 0 ? void 0 : ref.map(function(u) {
                            return u.puid;
                        })) || [];
                        availablePuid = qualityStock === null || qualityStock === void 0 ? void 0 : qualityStock.products.find(function(p) {
                            return !puidsInCart.includes(p.puid);
                        });
                        if (availablePuid) {
                            data = {
                                productCode: productCode,
                                secondHand: 'true',
                                units: [
                                    {
                                        puid: availablePuid.puid,
                                        condition: secondHandUnit.productCondition
                                    }, 
                                ]
                            };
                            addProductToCart(data);
                        }
                        _ctx.next = 13;
                        break;
                    case 12:
                        if (newQuantity < currentQuantity) {
                            lastUnit = (units === null || units === void 0 ? void 0 : units[units.length - 1]) || unit;
                            secondHandParams = {
                                puid: lastUnit.puid,
                                condition: lastUnit.productCondition
                            };
                            removeProductFromCart(productInCart, secondHandParams, 1);
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSecondHandQuantityChange(newQuantity) {
            return _ref.apply(this, arguments);
        };
    }();
    var onQuantityChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(quantity) {
            var inStock, variantKey, response, ref, ref21, ref22, ref23, ref24, price, unitaryPrice, totalPrice, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        inStock = 0;
                        if (productInCart) {
                            inStock = (0,utils/* checkStockQuantityByItemType */.qe)(stock1, productInCart.product.variants[0], isSecondHand ? 'SECOND_HAND' : 'RENTAL', 'basket');
                        }
                        variantKey = Object.keys(productInCart.product.variants)[0];
                        response = (0,addToCart/* addToCartUtility */.$)(variantKey !== '0' ? variantKey : productInCart.product.variants[0].code, quantity, cart, parameters, productInCart, false, inStock);
                        trackEvent({
                            category: 'Basket',
                            action: "Quantity changed for product in basket"
                        });
                        if (!(availability || isSecondHand && (settings === null || settings === void 0 ? void 0 : settings.second_hand_has_quantity_selector))) {
                            _ctx.next = 30;
                            break;
                        }
                        ;
                        price = isSecondHand ? (ref21 = productInCart === null || productInCart === void 0 ? void 0 : (ref = productInCart.product) === null || ref === void 0 ? void 0 : ref.variants[0]) === null || ref21 === void 0 ? void 0 : ref21.resalePrice[base/* SecondHandCondition.PERFECT_CONDITION */.pJ.PERFECT_CONDITION] : (ref23 = productInCart === null || productInCart === void 0 ? void 0 : (ref22 = productInCart.product) === null || ref22 === void 0 ? void 0 : ref22.variants[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.price) === null || ref24 === void 0 ? void 0 : ref24.current;
                        unitaryPrice = (0,utils/* numberToPrice */.e8)(price);
                        totalPrice = (0,utils/* numberToPrice */.e8)(unitaryPrice * quantity);
                        _ctx.t0 = response.message;
                        _ctx.next = _ctx.t0 === 'limit' ? 13 : _ctx.t0 === 'max' ? 13 : _ctx.t0 === 'add' ? 13 : _ctx.t0 === 'remove' ? 17 : _ctx.t0 === 'delete' ? 23 : 29;
                        break;
                    case 13:
                        ;
                        trackEvent({
                            category: 'Add to Cart',
                            action: "".concat(productInCart === null || productInCart === void 0 ? void 0 : (ref25 = productInCart.product) === null || ref25 === void 0 ? void 0 : ref25.name),
                            name: "".concat(router.pathname),
                            value: totalPrice
                        });
                        if (response.productInCart) {
                            ;
                            changeProductQuantityInCart(productInCart.id, {
                                quantity: quantity
                            }, base/* GAEvent.ADD_TO_CART */.gB.ADD_TO_CART, inStock);
                            pushInstruction('addEcommerceItem', (ref27 = productInCart === null || productInCart === void 0 ? void 0 : (ref26 = productInCart.product) === null || ref26 === void 0 ? void 0 : ref26.variants[0]) === null || ref27 === void 0 ? void 0 : ref27.sku, productInCart === null || productInCart === void 0 ? void 0 : (ref28 = productInCart.product) === null || ref28 === void 0 ? void 0 : ref28.name, productInCart === null || productInCart === void 0 ? void 0 : (ref29 = productInCart.product) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.taxons) === null || ref30 === void 0 ? void 0 : ref30.main, unitaryPrice, quantity);
                            pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref31 = cart.item) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.totals) === null || ref32 === void 0 ? void 0 : ref32.total));
                        }
                        return _ctx.abrupt("break", 30);
                    case 17:
                        ;
                        trackEvent({
                            category: 'Remove from Cart',
                            action: "".concat(productInCart === null || productInCart === void 0 ? void 0 : (ref33 = productInCart.product) === null || ref33 === void 0 ? void 0 : ref33.name),
                            name: "".concat(router.pathname),
                            value: totalPrice
                        });
                        changeProductQuantityInCart(productInCart.id, {
                            quantity: quantity
                        }, base/* GAEvent.REMOVE_FROM_CART */.gB.REMOVE_FROM_CART, inStock);
                        pushInstruction('addEcommerceItem', (ref35 = productInCart === null || productInCart === void 0 ? void 0 : (ref34 = productInCart.product) === null || ref34 === void 0 ? void 0 : ref34.variants[0]) === null || ref35 === void 0 ? void 0 : ref35.sku, productInCart === null || productInCart === void 0 ? void 0 : (ref36 = productInCart.product) === null || ref36 === void 0 ? void 0 : ref36.name, productInCart === null || productInCart === void 0 ? void 0 : (ref37 = productInCart.product) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.taxons) === null || ref38 === void 0 ? void 0 : ref38.main, unitaryPrice, quantity);
                        pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
                        return _ctx.abrupt("break", 30);
                    case 23:
                        ;
                        trackEvent({
                            category: 'Delete from Cart',
                            action: "".concat(productInCart === null || productInCart === void 0 ? void 0 : (ref39 = productInCart.product) === null || ref39 === void 0 ? void 0 : ref39.name),
                            name: "".concat(router.pathname),
                            value: totalPrice
                        });
                        removeProductFromCart(productInCart);
                        pushInstruction('removeEcommerceItem', (ref41 = productInCart === null || productInCart === void 0 ? void 0 : (ref40 = productInCart.product) === null || ref40 === void 0 ? void 0 : ref40.variants[0]) === null || ref41 === void 0 ? void 0 : ref41.sku);
                        pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
                        return _ctx.abrupt("break", 30);
                    case 29:
                        return _ctx.abrupt("break", 30);
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onQuantityChange(quantity) {
            return _ref.apply(this, arguments);
        };
    }();
    function deleteItem() {
        return _deleteItem.apply(this, arguments);
    }
    function _deleteItem() {
        _deleteItem = _asyncToGenerator(runtime_default().mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, u, data, data1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(isSecondHand && (units === null || units === void 0 ? void 0 : units.length))) {
                            _ctx.next = 28;
                            break;
                        }
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _ctx.prev = 2;
                        _iterator = units[Symbol.iterator]();
                    case 4:
                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _ctx.next = 12;
                            break;
                        }
                        u = _step.value;
                        data = {
                            puid: u.puid,
                            condition: u.productCondition
                        };
                        _ctx.next = 9;
                        return removeProductFromCart(productInCart, data, 1);
                    case 9:
                        _iteratorNormalCompletion = true;
                        _ctx.next = 4;
                        break;
                    case 12:
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](2);
                        _didIteratorError = true;
                        _iteratorError = _ctx.t0;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.prev = 19;
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    case 21:
                        _ctx.prev = 21;
                        if (!_didIteratorError) {
                            _ctx.next = 24;
                            break;
                        }
                        throw _iteratorError;
                    case 24:
                        return _ctx.finish(21);
                    case 25:
                        return _ctx.finish(18);
                    case 26:
                        _ctx.next = 29;
                        break;
                    case 28:
                        if (isSecondHand && unit) {
                            data1 = {
                                puid: unit.puid,
                                condition: unit.productCondition
                            };
                            removeProductFromCart(productInCart, data1, 1);
                        } else {
                            // Non-second-hand: remove all
                            removeProductFromCart(productInCart, undefined, productInCart.quantity);
                        }
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    14,
                    18,
                    26
                ],
                [
                    19,
                    ,
                    21,
                    25
                ]
            ]);
        }));
        return _deleteItem.apply(this, arguments);
    }
    var onGotoProduct = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event) {
            var path;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        trackEvent({
                            category: 'Basket',
                            action: "Go to product",
                            name: "".concat(productCode)
                        });
                        path = "/products/".concat(productCode);
                        // if path is the same as the current path, do nothing
                        setShowBasket1(false);
                        if (!(path !== window.location.pathname)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 7;
                        return router.push(path);
                    case 7:
                        router.reload();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onGotoProduct(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            className: (0,clsx_m/* default */.Z)('cart-item', classes.root, isAvailable && classes.notAvailable),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 1,
                wrap: "nowrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        className: (0,clsx_m/* default */.Z)('cart-item__media', classes.columnMedia),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            role: "button",
                            onClick: onGotoProduct,
                            style: {
                                cursor: 'pointer',
                                display: 'block'
                            },
                            href: "/products/".concat(productCode),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-ratio": 'ar-1-1',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                    classes: classes.image,
                                    alt: name,
                                    imagePaths: photoThumb,
                                    settings: {
                                        quality: 75,
                                        width: settings === null || settings === void 0 ? void 0 : settings.small_image_size,
                                        ar: thumbRatio === null || thumbRatio === void 0 ? void 0 : thumbRatio.substring(3),
                                        defaultImage: settings === null || settings === void 0 ? void 0 : settings.default_image
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        className: (0,clsx_m/* default */.Z)('cart-item__content', classes.columnContent, hidePrice && classes.valign, disableQtySelector && classes.valign),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                container: true,
                                spacing: 1,
                                wrap: "nowrap",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            role: "button",
                                            onClick: onGotoProduct,
                                            style: {
                                                cursor: 'pointer',
                                                textDecoration: 'none',
                                                color: 'inherit'
                                            },
                                            href: "/products/".concat(productCode),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "h6",
                                                    component: "div",
                                                    className: (0,clsx_m/* default */.Z)('basket__title', !disableQtySelector && classes.nameProduct),
                                                    children: [
                                                        name,
                                                        isSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                "\xa0 - \xa0 ",
                                                                variant.size,
                                                                "\xa0 - \xa0",
                                                                ' ',
                                                                (ref5 = states["".concat(secondHandUnit === null || secondHandUnit === void 0 ? void 0 : secondHandUnit.productCondition)]) === null || ref5 === void 0 ? void 0 : ref5.title
                                                            ]
                                                        }),
                                                        !isSecondHand && showSizes && variant.name !== 'undefined' && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: 'basket__variant',
                                                            children: [
                                                                (variant === null || variant === void 0 ? void 0 : variant.size) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        "\xa0 - \xa0 ",
                                                                        variant === null || variant === void 0 ? void 0 : variant.size
                                                                    ]
                                                                }),
                                                                isTryOut && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        "\xa0 - \xa0",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            asText: true,
                                                                            data: basket === null || basket === void 0 ? void 0 : (ref6 = basket.data) === null || ref6 === void 0 ? void 0 : ref6.try_out,
                                                                            defaultText: t('texts:basket:try_out')
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxonPromotionBadge/* default */.Z, {
                                                    percent: taxonPromotion
                                                })
                                            ]
                                        })
                                    }),
                                    !disableDelete && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                                            size: "small",
                                            className: classes.delete,
                                            onClick: deleteItem,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteForever/* default */.Z, {})
                                        })
                                    })
                                ]
                            }),
                            isSki && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                container: true,
                                spacing: 1,
                                wrap: "nowrap",
                                alignItems: "center",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "basket__time",
                                            children: quantity1 > 1 ? quantity1 + ' paires' : quantity1 + ' paire'
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: "auto",
                                        children: priceRental && !hidePriceInCart && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            className: "basket__time ".concat(classes.smallText),
                                            color: 'secondary',
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                    isShort: true,
                                                    showDayOrMonth: !hideDayLabelInCart,
                                                    amount: variantPrice * quantity1,
                                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                    buyAble: buyAble,
                                                    displayFlexPrice: displayFlexPrice
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: classes.smallTextGrey,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref7 = basket.data) === null || ref7 === void 0 ? void 0 : ref7.for_short,
                                                            defaultText: t('texts:basket:for_short')
                                                        }),
                                                        ' ',
                                                        dayRange,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: dayRange <= 1 ? basket === null || basket === void 0 ? void 0 : (ref8 = basket.data) === null || ref8 === void 0 ? void 0 : ref8.day_singular : basket === null || basket === void 0 ? void 0 : (ref9 = basket.data) === null || ref9 === void 0 ? void 0 : ref9.day_plural,
                                                            defaultText: dayRange <= 1 ? t('texts:general:day_singular') : t('texts:general:days_plural')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            !hidePrice && !disableQtySelector ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    container: true,
                                    spacing: 1,
                                    wrap: "nowrap",
                                    alignItems: "center",
                                    justify: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            xs: "auto",
                                            children: [
                                                locked && !isSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.quantitySelector,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                        value: quantity1,
                                                        align: 'left',
                                                        handleChange: onQuantityChange,
                                                        min: 0,
                                                        max: (variant === null || variant === void 0 ? void 0 : variant.maxStock) ? variant === null || variant === void 0 ? void 0 : variant.maxStock : null,
                                                        small: true,
                                                        loading: loading,
                                                        variantSku: variant.sku
                                                    })
                                                }),
                                                isSecondHand && (settings === null || settings === void 0 ? void 0 : settings.second_hand_has_quantity_selector) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.quantitySelector,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                        value: secondHandQuantity,
                                                        align: 'left',
                                                        handleChange: onSecondHandQuantityChange,
                                                        min: 0,
                                                        max: secondHandQuantity + secondHandAvailableStock,
                                                        small: true,
                                                        loading: loading,
                                                        variantSku: variant.sku
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            xs: "auto",
                                            children: [
                                                !isClassicSub && !isSubscription && !isTryOut && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        isSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            className: "basket__time ".concat(classes.smallText, " ").concat(classes.priceContainer),
                                                            color: 'secondary',
                                                            children: [
                                                                constants/* displayTtcAndHtPrice */.r4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        taxonPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: classes.oldPrice,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                                showDayOrMonth: false,
                                                                                amount: secondHandTotalPrice.ht,
                                                                                afterCurrency: ' ' + t('texts:general:vat:excluded')
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                            showDayOrMonth: false,
                                                                            amount: taxonPromotion ? secondHandTotalPrice.ht - secondHandTotalPrice.ht * taxonPromotion / 100 : secondHandTotalPrice.ht,
                                                                            afterCurrency: ' ' + t('texts:general:vat:excluded')
                                                                        })
                                                                    ]
                                                                }),
                                                                taxonPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: classes.oldPrice,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                        showDayOrMonth: false,
                                                                        amount: secondHandTotalPrice.ttc,
                                                                        afterCurrency: constants/* displayTtcAndHtPrice */.r4 ? ' ' + t('texts:general:vat:included') : null
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                    showDayOrMonth: false,
                                                                    amount: taxonPromotion ? secondHandTotalPrice.ttc - secondHandTotalPrice.ttc * taxonPromotion / 100 : secondHandTotalPrice.ttc,
                                                                    afterCurrency: constants/* displayTtcAndHtPrice */.r4 ? ' ' + t('texts:general:vat:included') : null
                                                                })
                                                            ]
                                                        }),
                                                        priceRental && !hidePriceInCart && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            className: "basket__time ".concat(classes.smallText, " ").concat(classes.priceContainer),
                                                            color: 'secondary',
                                                            children: [
                                                                !isSubscription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                        isShort: true,
                                                                        showDayOrMonth: !hideDayLabelInCart,
                                                                        amount: variantPrice * quantity1,
                                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                        buyAble: buyAble,
                                                                        displayFlexPrice: displayFlexPrice
                                                                    })
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                        isShort: true,
                                                                        showDayOrMonth: !hideDayLabelInCart,
                                                                        amount: variantPrice * quantity1,
                                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                        buyAble: buyAble,
                                                                        displayFlexPrice: displayFlexPrice
                                                                    })
                                                                }),
                                                                ' ',
                                                                !isSubscription && !buyAble && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: classes.smallTextGrey,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            asText: true,
                                                                            data: basket === null || basket === void 0 ? void 0 : (ref10 = basket.data) === null || ref10 === void 0 ? void 0 : ref10.for_short,
                                                                            defaultText: t('texts:basket:for_short')
                                                                        }),
                                                                        ' ',
                                                                        dayRange,
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            asText: true,
                                                                            data: dayRange <= 1 ? basket === null || basket === void 0 ? void 0 : (ref11 = basket.data) === null || ref11 === void 0 ? void 0 : ref11.day_singular : basket === null || basket === void 0 ? void 0 : (ref12 = basket.data) === null || ref12 === void 0 ? void 0 : ref12.day_plural,
                                                                            defaultText: dayRange <= 1 ? t('texts:general:day_singular') : t('texts:general:days_plural')
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                !isClassicSub && !isTryOut && !buyAble && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'h5',
                                                    component: 'div',
                                                    color: 'secondary',
                                                    align: "right",
                                                    className: (0,clsx_m/* default */.Z)('basket-product__total', classes.total),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: !isSubscription ? variantPrice * quantity1 * dayRange : variant.price.current * quantity1,
                                                            showDayOrMonth: false,
                                                            isShort: true,
                                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                            displayFlexPrice: displayFlexPrice
                                                        })
                                                    })
                                                }),
                                                isTryOut && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'h5',
                                                    component: 'div',
                                                    color: 'secondary',
                                                    align: "right",
                                                    className: (0,clsx_m/* default */.Z)('basket-product__total', classes.total, classes.totalTryOut),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                        amount: !isSubscription ? variantPrice * quantity1 : variant.price.current,
                                                        isShort: true,
                                                        showDayOrMonth: false,
                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                        displayFlexPrice: displayFlexPrice
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    container: true,
                                    spacing: 1,
                                    wrap: "nowrap",
                                    alignItems: "center",
                                    justify: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                            item: true,
                                            xs: "auto",
                                            children: quantity1 > 1 ? quantity1 + ' ' + t('texts:basket:products') : quantity1 + ' ' + t('texts:basket:product')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            xs: "auto",
                                            children: [
                                                !isClassicSub && !isSubscription && !isTryOut && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        isSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            className: "basket__time ".concat(classes.smallText),
                                                            color: 'secondary',
                                                            children: [
                                                                constants/* displayTtcAndHtPrice */.r4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        taxonPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: classes.oldPrice,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                                showDayOrMonth: false,
                                                                                amount: secondHandTotalPrice.ht,
                                                                                afterCurrency: ' ' + t('texts:general:vat:excluded')
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                            showDayOrMonth: false,
                                                                            amount: taxonPromotion ? secondHandTotalPrice.ht - secondHandTotalPrice.ht * taxonPromotion / 100 : secondHandTotalPrice.ht,
                                                                            afterCurrency: ' ' + t('texts:general:vat:excluded')
                                                                        })
                                                                    ]
                                                                }),
                                                                taxonPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: classes.oldPrice,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                        showDayOrMonth: false,
                                                                        amount: secondHandTotalPrice.ttc,
                                                                        afterCurrency: constants/* displayTtcAndHtPrice */.r4 ? ' ' + t('texts:general:vat:included') : null
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                    showDayOrMonth: false,
                                                                    amount: taxonPromotion ? secondHandTotalPrice.ttc - secondHandTotalPrice.ttc * taxonPromotion / 100 : secondHandTotalPrice.ttc,
                                                                    afterCurrency: constants/* displayTtcAndHtPrice */.r4 ? ' ' + t('texts:general:vat:included') : null
                                                                })
                                                            ]
                                                        }),
                                                        priceRental && !hidePriceInCart && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            className: "basket__time ".concat(classes.smallText),
                                                            color: 'secondary',
                                                            children: [
                                                                !isSubscription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                        isShort: true,
                                                                        showDayOrMonth: !hideDayLabelInCart,
                                                                        amount: variantPrice * quantity1,
                                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                        buyAble: buyAble,
                                                                        displayFlexPrice: displayFlexPrice
                                                                    })
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                        isShort: true,
                                                                        showDayOrMonth: !hideDayLabelInCart,
                                                                        amount: variantPrice * quantity1,
                                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                        buyAble: buyAble,
                                                                        displayFlexPrice: displayFlexPrice
                                                                    })
                                                                }),
                                                                ' ',
                                                                !isSubscription && !buyAble && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: classes.smallTextGrey,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            asText: true,
                                                                            data: basket === null || basket === void 0 ? void 0 : (ref13 = basket.data) === null || ref13 === void 0 ? void 0 : ref13.for_short,
                                                                            defaultText: t('texts:basket:for_short')
                                                                        }),
                                                                        ' ',
                                                                        dayRange,
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            asText: true,
                                                                            data: dayRange <= 1 ? basket === null || basket === void 0 ? void 0 : (ref14 = basket.data) === null || ref14 === void 0 ? void 0 : ref14.day_singular : basket === null || basket === void 0 ? void 0 : (ref15 = basket.data) === null || ref15 === void 0 ? void 0 : ref15.day_plural,
                                                                            defaultText: dayRange <= 1 ? t('texts:general:day_singular') : t('texts:general:days_plural')
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                !isClassicSub && !isTryOut && !buyAble && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'h5',
                                                    component: 'div',
                                                    color: 'secondary',
                                                    align: "right",
                                                    className: (0,clsx_m/* default */.Z)('basket-product__total', classes.total),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: !isSubscription ? variantPrice * quantity1 * dayRange : variant.price.current * quantity1,
                                                            showDayOrMonth: false,
                                                            isShort: true,
                                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                            displayFlexPrice: displayFlexPrice
                                                        })
                                                    })
                                                }),
                                                isTryOut && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'h5',
                                                    component: 'div',
                                                    color: 'secondary',
                                                    align: "right",
                                                    className: (0,clsx_m/* default */.Z)('basket-product__total', classes.total, classes.totalTryOut),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                        amount: !isSubscription ? variantPrice * quantity1 : variant.price.current,
                                                        isShort: true,
                                                        showDayOrMonth: false,
                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                        displayFlexPrice: displayFlexPrice
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
var mapStateToProps = function(state) {
    return {
        cart: state.cart,
        parameters: state.parameters,
        promotions: state.promotions
    };
};
/* harmony default export */ var Shop_BasketProductRow = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(BasketProductRow));

// EXTERNAL MODULE: ./components/Global/ConditionalWrap.tsx
var ConditionalWrap = __webpack_require__(5512);
// EXTERNAL MODULE: ./components/ShippingInfos/ShippingInfos.tsx
var ShippingInfos = __webpack_require__(49172);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Close.js
var Close = __webpack_require__(59544);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(55953);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/HighlightOff.js
var HighlightOff = __webpack_require__(35736);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(66037);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Info.js
var Info = __webpack_require__(18362);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(51115);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowUp.js
var KeyboardArrowUp = __webpack_require__(25281);
;// CONCATENATED MODULE: ./components/Shop/BasketShowDetails.tsx






var BasketShowDetails_useStyles = (0,makeStyles/* default */.Z)(function() {
    return (0,createStyles/* default */.Z)({
        showMore: {
            textAlign: 'center',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        verticalAlign: {
            alignContent: 'center'
        }
    });
});
var BasketShowDetails = function(param) {
    var basket = param.basket, t = param.t, isBuyAbleProducts = param.isBuyAbleProducts, setShowDetails = param.setShowDetails, showDetails = param.showDetails;
    var ref7, ref1;
    var classes = BasketShowDetails_useStyles();
    var ref2 = (0,react.useState)(true), showDetailsLink = ref2[0], setShowDetailsLink = ref2[1];
    (0,react.useEffect)(function() {
        var ref, ref3, ref4, ref5, ref6;
        setShowDetailsLink(!isBuyAbleProducts && (basket === null || basket === void 0 ? void 0 : (ref = basket.data) === null || ref === void 0 ? void 0 : ref.enable_total_price_per_day) || (basket === null || basket === void 0 ? void 0 : (ref3 = basket.data) === null || ref3 === void 0 ? void 0 : ref3.enable_total_without_shipping) || (basket === null || basket === void 0 ? void 0 : (ref4 = basket.data) === null || ref4 === void 0 ? void 0 : ref4.enable_total_weight) || !isBuyAbleProducts && (basket === null || basket === void 0 ? void 0 : (ref5 = basket.data) === null || ref5 === void 0 ? void 0 : ref5.enable_duration) || (basket === null || basket === void 0 ? void 0 : (ref6 = basket.data) === null || ref6 === void 0 ? void 0 : ref6.enable_assurance));
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showDetailsLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onClick: function() {
                return setShowDetails(!showDetails);
            },
            className: classes.showMore,
            children: [
                !showDetails ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUp/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: 'caption',
                    component: 'div',
                    className: classes.verticalAlign,
                    children: !showDetails ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: basket === null || basket === void 0 ? void 0 : (ref7 = basket.data) === null || ref7 === void 0 ? void 0 : ref7.showDetails,
                        defaultText: t('texts:basket:showDetails')
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: basket === null || basket === void 0 ? void 0 : (ref1 = basket.data) === null || ref1 === void 0 ? void 0 : ref1.hideDetails,
                        defaultText: t('texts:basket:hideDetails')
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var Shop_BasketShowDetails = (BasketShowDetails);

// EXTERNAL MODULE: ./components/Global/DownloadLink.tsx
var DownloadLink = __webpack_require__(84732);
;// CONCATENATED MODULE: ./components/Shop/BasketTotalsDad.tsx
/* provided dependency */ var process = __webpack_require__(34155);













var BasketTotalsDad_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        wrapperShipping: {
            margin: 0,
            padding: theme.spacing(1)
        },
        row: {
            display: 'flex',
            padding: theme.spacing(1, 0.5),
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        rowBorder: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: theme.spacing(1, 0.5),
            borderTop: "1px solid ".concat(theme.extraColors.greyLight)
        },
        giftCardExplanation: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 10,
            fontWeight: 500,
            padding: theme.spacing(0.4),
            borderRadius: theme.shape.borderRadius,
            color: 'white',
            backgroundColor: theme.palette.primary.main
        },
        giftCardIcon: {
            fontSize: 14,
            marginRight: theme.spacing(0.4)
        },
        rowNoBorder: {
            border: 0
        },
        rowHeavyBorder: {
            borderTopColor: theme.extraColors.grey
        },
        rowHeavyBorderBottom: {
            borderTop: 0,
            borderBottom: "1px solid ".concat(theme.extraColors.grey)
        },
        shipping: {
            fontSize: '80%',
            fontWeight: 400,
            color: "".concat(theme.extraColors.greyText)
        },
        left: {
            display: 'flex',
            flexDirection: 'row'
        },
        green: {
            color: theme.palette.success.main
        },
        deposit: {
            display: 'flex',
            alignItems: 'center'
        },
        delete: {
            width: 20,
            height: 20,
            minHeight: 20,
            padding: 0,
            boxShadow: 'none',
            background: 'none',
            '&:hover, &:focus': {
                color: theme.palette.error.main,
                background: 'none'
            },
            '& .MuiSvgIcon-root': {
                height: '.75em',
                width: '.75em'
            }
        }
    });
});
var BasketTotalsDad = function(param) {
    var cart = param.cart, basket = param.basket, dayRange = param.dayRange, mixedBasket = param.mixedBasket, isSecondHand = param.isSecondHand, t = param.t, showDetailsOnBuyAbleProducts = param.showDetailsOnBuyAbleProducts, isBuyAbleProducts = param.isBuyAbleProducts, settings = param.settings, user = param.user, parameters = param.parameters, funnel = param.funnel, deleteCoupon = param.deleteCoupon;
    var ref41, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37;
    var classes = BasketTotalsDad_useStyles();
    var router = (0,next_router.useRouter)();
    var ref38 = (0,react.useState)(0), totalWithoutBuyAble = ref38[0], setTotalWithoutBuyAble = ref38[1];
    var ref39 = (0,react.useState)(true), showDetails = ref39[0], setShowDetails = ref39[1];
    var isEndFunnel = router.route === '/shipping' || router.route === '/payment';
    var amountTotal = (0,react.useMemo)(function() {
        var ref, ref40;
        return isEndFunnel ? totalWithoutBuyAble + (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref40 = ref.totals) === null || ref40 === void 0 ? void 0 : ref40.shipping) : totalWithoutBuyAble;
    }, [
        isEndFunnel,
        totalWithoutBuyAble,
        cart === null || cart === void 0 ? void 0 : (ref41 = cart.item) === null || ref41 === void 0 ? void 0 : (ref1 = ref41.totals) === null || ref1 === void 0 ? void 0 : ref1.shipping
    ]);
    var notDisplayWithoutShipping = basket === null || basket === void 0 ? void 0 : (ref2 = basket.data) === null || ref2 === void 0 ? void 0 : ref2.not_display_without_shipping;
    var depositExplanation = basket === null || basket === void 0 ? void 0 : (ref3 = basket.data) === null || ref3 === void 0 ? void 0 : ref3.deposit_explanation;
    var deposit = (0,react.useMemo)(function() {
        return +parameters.items.deposit || +process.env.SWIKLY_DEPOSIT_PERCENTAGE || 0;
    }, [
        parameters.items.deposit
    ]);
    var depositAmount = (0,react.useMemo)(function() {
        var ref44;
        return (ref44 = cart.item) === null || ref44 === void 0 ? void 0 : ref44.items.reduce(function(acc, item) {
            var ref, ref42;
            var ref43;
            var originalPrice = (ref43 = (ref = item.product.variants[0]) === null || ref === void 0 ? void 0 : (ref42 = ref.originalPrice) === null || ref42 === void 0 ? void 0 : ref42.current) !== null && ref43 !== void 0 ? ref43 : 0;
            if (originalPrice) {
                return acc + originalPrice * item.quantity * deposit;
            }
            return acc;
        }, 0);
    }, [
        (ref4 = cart.item) === null || ref4 === void 0 ? void 0 : ref4.items
    ]);
    (0,react.useEffect)(function() {
        // calcul total without buyAbleProducts
        var total = (0,utils/* calculTotalWithBuyAbleProducts */.FL)(cart, isBuyAbleProducts);
        setTotalWithoutBuyAble(total);
    }, [
        cart
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)('shipping-infos__wrapper', classes.wrapperShipping),
            children: [
                !isBuyAbleProducts && showDetailsOnBuyAbleProducts && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketShowDetails, {
                            t: t,
                            basket: basket,
                            setShowDetails: setShowDetails,
                            showDetails: showDetails
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                            in: showDetails,
                            timeout: "auto",
                            unmountOnExit: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    !isBuyAbleProducts && (basket === null || basket === void 0 ? void 0 : (ref5 = basket.data) === null || ref5 === void 0 ? void 0 : ref5.enable_total_price_per_day) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.row,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref6 = basket.data) === null || ref6 === void 0 ? void 0 : ref6.kit_price,
                                                    defaultText: t('texts:basket:kit_price')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: totalWithoutBuyAble / dayRange,
                                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                            showDayOrMonth: true,
                                                            isShort: true
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    (basket === null || basket === void 0 ? void 0 : (ref7 = basket.data) === null || ref7 === void 0 ? void 0 : ref7.enable_total_without_shipping) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.row,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref8 = basket.data) === null || ref8 === void 0 ? void 0 : ref8.total_without_shipping,
                                                    defaultText: t('texts:basket:total_without_shipping')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: totalWithoutBuyAble,
                                                            showDayOrMonth: false,
                                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    (basket === null || basket === void 0 ? void 0 : (ref9 = basket.data) === null || ref9 === void 0 ? void 0 : ref9.enable_total_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.row,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref10 = basket.data) === null || ref10 === void 0 ? void 0 : ref10.total_weight,
                                                    defaultText: t('texts:basket:total_weight')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                        children: [
                                                            cart.item.productsTotalWeight,
                                                            " kg"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    !isBuyAbleProducts && (basket === null || basket === void 0 ? void 0 : (ref11 = basket.data) === null || ref11 === void 0 ? void 0 : ref11.enable_duration) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.rowBorder,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref12 = basket.data) === null || ref12 === void 0 ? void 0 : ref12.duration,
                                                        defaultText: t('texts:basket:duration')
                                                    }),
                                                    "\xa0"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                        children: [
                                                            dayRange,
                                                            ' ',
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: dayRange <= 1 ? basket === null || basket === void 0 ? void 0 : (ref13 = basket.data) === null || ref13 === void 0 ? void 0 : ref13.day_singular : basket === null || basket === void 0 ? void 0 : (ref14 = basket.data) === null || ref14 === void 0 ? void 0 : ref14.day_plural,
                                                                defaultText: dayRange <= 1 ? t('texts:general:day_singular') : t('texts:general:days_plural')
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    (basket === null || basket === void 0 ? void 0 : (ref15 = basket.data) === null || ref15 === void 0 ? void 0 : ref15.enable_assurance) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.rowBorder,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref16 = basket.data) === null || ref16 === void 0 ? void 0 : ref16.assurance,
                                                    defaultText: t('texts:basket:assurance')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref17 = basket.data) === null || ref17 === void 0 ? void 0 : ref17.free,
                                                            defaultText: t('texts:basket:free')
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    (basket === null || basket === void 0 ? void 0 : (ref18 = basket.data) === null || ref18 === void 0 ? void 0 : ref18.enable_shipping) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: isEndFunnel && !isSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.rowBorder,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref19 = basket.data) === null || ref19 === void 0 ? void 0 : ref19.shipping,
                                                        defaultText: t('texts:basket:shipping')
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.left,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: cart.item.totals.shipping === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: basket === null || basket === void 0 ? void 0 : (ref20 = basket.data) === null || ref20 === void 0 ? void 0 : ref20.free,
                                                                defaultText: t('texts:basket:free')
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                    amount: cart.item.totals.shipping,
                                                                    showDayOrMonth: false,
                                                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    (basket === null || basket === void 0 ? void 0 : (ref21 = basket.data) === null || ref21 === void 0 ? void 0 : ref21.enable_reduction) && (cart.item.totals.promotion !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.rowBorder,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref22 = basket.data) === null || ref22 === void 0 ? void 0 : ref22.reduction,
                                                        defaultText: t('texts:basket:reduction')
                                                    }),
                                                    "\xa0"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classes.left,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        className: (0,clsx_m/* default */.Z)('basket__discount', classes.green),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                amount: cart.item.totals.promotion,
                                                                showDayOrMonth: false,
                                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        item: true,
                                                        xs: "auto",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                                                            size: "small",
                                                            className: classes.delete,
                                                            onClick: deleteCoupon,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteForever/* default */.Z, {})
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.rowBorder,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'body2',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: basket === null || basket === void 0 ? void 0 : (ref23 = basket.data) === null || ref23 === void 0 ? void 0 : ref23.reduction_text_explication,
                                                defaultText: t('texts:basket:reduction_text_explication')
                                            })
                                        })
                                    })),
                                    (user === null || user === void 0 ? void 0 : (ref24 = user.balance) === null || ref24 === void 0 ? void 0 : ref24.balance) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classes.rowBorder,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref25 = basket.data) === null || ref25 === void 0 ? void 0 : ref25.gift_card_text,
                                                            defaultText: t('texts:basket:gift_card_text')
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classes.left,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'body2',
                                                            className: (0,clsx_m/* default */.Z)('basket__discount', classes.green),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                    amount: user === null || user === void 0 ? void 0 : (ref26 = user.balance) === null || ref26 === void 0 ? void 0 : ref26.balance,
                                                                    showDayOrMonth: false,
                                                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,clsx_m/* default */.Z)(classes.giftCardExplanation, 'basket-giftCard-explanation'),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                        fontSize: "small",
                                                        className: classes.giftCardIcon
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref27 = basket.data) === null || ref27 === void 0 ? void 0 : ref27.gift_card_explanation,
                                                        defaultText: t('texts:basket:gift_card_explanation')
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                (!showDetailsOnBuyAbleProducts || mixedBasket || !isSecondHand) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.rowBorder, classes.rowNoBorder),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    children: [
                                        (basket === null || basket === void 0 ? void 0 : (ref28 = basket.data) === null || ref28 === void 0 ? void 0 : ref28.total) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: basket === null || basket === void 0 ? void 0 : (ref29 = basket.data) === null || ref29 === void 0 ? void 0 : ref29.total,
                                            defaultText: t('texts:basket:total')
                                        }),
                                        "\xa0",
                                        isBuyAbleProducts ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref30 = basket.data) === null || ref30 === void 0 ? void 0 : ref30.buytotal,
                                                    defaultText: t('texts:basket:buyTotal')
                                                }),
                                                "\xa0",
                                                !isEndFunnel && !notDisplayWithoutShipping && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: classes.shipping,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref31 = basket.data) === null || ref31 === void 0 ? void 0 : ref31.without_shipping,
                                                        defaultText: t('texts:basket:withoutShipping')
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                !isSecondHand && mixedBasket && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref32 = basket.data) === null || ref32 === void 0 ? void 0 : ref32.renttotal,
                                                            defaultText: t('texts:basket:rentTotal')
                                                        }),
                                                        "\xa0"
                                                    ]
                                                }),
                                                !isEndFunnel && !notDisplayWithoutShipping && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: classes.shipping,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref33 = basket.data) === null || ref33 === void 0 ? void 0 : ref33.without_shipping,
                                                        defaultText: t('texts:basket:withoutShipping')
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.left,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        color: 'secondary',
                                        className: (0,clsx_m/* default */.Z)('cart__total'),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: !isBuyAbleProducts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: amountTotal,
                                                showDayOrMonth: false,
                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                            }) : mixedBasket ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: totalWithoutBuyAble,
                                                showDayOrMonth: false,
                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: amountTotal,
                                                showDayOrMonth: false,
                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        constants/* isB2B */.tP && isEndFunnel && (funnel === null || funnel === void 0 ? void 0 : (ref34 = funnel.b2b_shipping_costs) === null || ref34 === void 0 ? void 0 : ref34.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.rowBorder, classes.rowNoBorder),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadLink/* default */.Z, {
                                downloadLink: funnel === null || funnel === void 0 ? void 0 : (ref35 = funnel.b2b_shipping_costs) === null || ref35 === void 0 ? void 0 : ref35.url,
                                data: funnel === null || funnel === void 0 ? void 0 : (ref36 = funnel.b2b_shipping_costs) === null || ref36 === void 0 ? void 0 : ref36.data,
                                defaultText: t('texts:basket:b2b_shipping_costs_link')
                            })
                        }),
                        deposit > 0 && !constants/* hideBasketDeposit */.Uo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.rowBorder, classes.rowNoBorder),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    className: classes.deposit,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: basket === null || basket === void 0 ? void 0 : (ref37 = basket.data) === null || ref37 === void 0 ? void 0 : ref37.deposit,
                                            defaultText: t('texts:basket:deposit')
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                            title: (0,CMSText/* prismicText */.yz)(depositExplanation, t('texts:basket:deposit_explanation')),
                                            placement: "top",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.left,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: depositAmount,
                                                showDayOrMonth: false,
                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Shop_BasketTotalsDad = (BasketTotalsDad);

// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
;// CONCATENATED MODULE: ./components/Shop/BasketTotalsSub.tsx














var customParseFormat = __webpack_require__(10285);
dayjs_min_default().extend(customParseFormat);
var BasketTotalsSub_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        wrapperShipping: {
            margin: 0,
            padding: theme.spacing(1, 2)
        },
        row: {
            display: 'flex',
            padding: theme.spacing(1, 0.5),
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        rowBorder: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: theme.spacing(1, 0.5),
            borderTop: "1px solid ".concat(theme.extraColors.greyLight)
        },
        giftCardExplanation: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 10,
            padding: theme.spacing(0.4),
            borderRadius: theme.shape.borderRadius,
            color: 'white',
            backgroundColor: theme.palette.primary.main
        },
        giftCardIcon: {
            fontSize: 14,
            marginRight: theme.spacing(0.4)
        },
        rowHeavyBorder: {
            borderTopColor: theme.extraColors.grey
        },
        rowNoBorder: {
            border: 0
        },
        rowHeavyBorderBottom: {
            borderTop: 0,
            borderBottom: "1px solid ".concat(theme.extraColors.grey)
        },
        shipping: {
            fontSize: '80%',
            fontWeight: 400,
            color: "".concat(theme.extraColors.greyText)
        },
        left: {
            display: 'flex',
            flexDirection: 'row'
        },
        right: {
            whiteSpace: 'nowrap'
        },
        green: {
            color: theme.palette.success.main
        },
        linkToAccount: {
            textDecoration: 'underline',
            fontSize: 10
        },
        engagement: {
            color: theme.palette.primary.main,
            lineHeight: 1.2
        },
        priceMonth: {
            margin: theme.spacing(0, 2, 0, 0)
        },
        titleIcon: {
            display: 'flex',
            gap: theme.spacing(1),
            margin: theme.spacing(0, 0, 1),
            alignItems: 'center'
        },
        marginRight: {
            marginRight: 10
        },
        center: {
            textAlign: 'center',
            width: '100%'
        }
    });
});
var BasketTotalsSub_mapStateToProps = function(state) {
    return {
        contract: state.contract,
        cart: state.cart,
        promotions: state.promotions
    };
};
var BasketTotalsSub_mapDispatchToProps = {};
var BasketTotalsSub = function(param) {
    var basket = param.basket, t = param.t, cart = param.cart, contract = param.contract, isBuyAbleProducts = param.isBuyAbleProducts, showDetailsOnBuyAbleProducts = param.showDetailsOnBuyAbleProducts, _numberOfDaysLeftInCurrentSubscription = param.numberOfDaysLeftInCurrentSubscription, numberOfDaysLeftInCurrentSubscription = _numberOfDaysLeftInCurrentSubscription === void 0 ? 30 : _numberOfDaysLeftInCurrentSubscription, promotions = param.promotions, mixedBasket = param.mixedBasket, settings = param.settings, user = param.user;
    var ref92, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80, ref81, ref82;
    var classes = BasketTotalsSub_useStyles();
    var ref83 = (0,react.useState)(0), totalCurrent = ref83[0], setTotalCurrent = ref83[1];
    var router = (0,next_router.useRouter)();
    var isEndFunnel = router.route === '/shipping' || router.route === '/payment';
    var notDisplayWithoutShipping = basket === null || basket === void 0 ? void 0 : (ref92 = basket.data) === null || ref92 === void 0 ? void 0 : ref92.not_display_without_shipping;
    var displayFlexPrice = settings === null || settings === void 0 ? void 0 : settings.display_flex_price_a_day;
    var ref84 = (0,react.useState)(true), showDetails = ref84[0], setShowDetails = ref84[1];
    (0,react.useEffect)(function() {
        if (constants/* isFlex */.Lz) {
            var ref, ref85, ref86, ref87;
            if ((contract === null || contract === void 0 ? void 0 : (ref = contract.items) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref85 = contract === null || contract === void 0 ? void 0 : contract.items[0]) === null || ref85 === void 0 ? void 0 : ref85.orders) && ((ref86 = contract === null || contract === void 0 ? void 0 : contract.items[0]) === null || ref86 === void 0 ? void 0 : (ref87 = ref86.orders) === null || ref87 === void 0 ? void 0 : ref87.length) > 0) {
                setTotalCurrent(parseFloat("".concat(contract === null || contract === void 0 ? void 0 : contract.items[0].total)));
            } else {
                setTotalCurrent(0);
            }
        } else {
            var // mapping orders to calcul the subscription price and to create a new array wich contain every product row in the orders
            ref88, ref89, ref90, ref91;
            var userSubscriptionQuantity = 0;
            (contract === null || contract === void 0 ? void 0 : (ref88 = contract.items) === null || ref88 === void 0 ? void 0 : ref88.length) > 0 && ((ref89 = contract === null || contract === void 0 ? void 0 : contract.items[0]) === null || ref89 === void 0 ? void 0 : (ref90 = ref89.orders) === null || ref90 === void 0 ? void 0 : ref90.map(function(order) {
                if (dayjs_min_default()().diff(dayjs_min_default()(order.startLeasingDate), 'day') <= dayjs_min_default()().daysInMonth() && order.paymentState !== 'paid' && order.paymentState !== 'refunded' && order.paymentState !== 'cancelled' && order.state !== 'cart') {
                    var ref94, ref93;
                    (order === null || order === void 0 ? void 0 : (ref94 = order.items) === null || ref94 === void 0 ? void 0 : ref94.length) > 0 && (order === null || order === void 0 ? void 0 : (ref93 = order.items) === null || ref93 === void 0 ? void 0 : ref93.map(function(product) {
                        var ref;
                        (ref = product.units) === null || ref === void 0 ? void 0 : ref.map(function(unit) {
                            if (!unit.isReturned) {
                                product['orderToken'] = order.tokenValue;
                                userSubscriptionQuantity++;
                            }
                        });
                    }));
                }
            }));
            if ((promotions === null || promotions === void 0 ? void 0 : (ref91 = promotions.items) === null || ref91 === void 0 ? void 0 : ref91.length) > 0) {
                var currentSubscriptionPrice = 0;
                var planPrice = (0,utils/* findCurrentPlan */.Id)(promotions, userSubscriptionQuantity, currentSubscriptionPrice);
                setTotalCurrent(planPrice);
            }
        }
    }, [
        contract,
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.item) === null || ref1 === void 0 ? void 0 : ref1.items
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.wrapperShipping,
            children: [
                !isBuyAbleProducts && showDetailsOnBuyAbleProducts && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketShowDetails, {
                            t: t,
                            basket: basket,
                            setShowDetails: setShowDetails,
                            showDetails: showDetails
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                            in: showDetails,
                            timeout: "auto",
                            unmountOnExit: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    (contract === null || contract === void 0 ? void 0 : (ref2 = contract.items) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && ((ref3 = contract === null || contract === void 0 ? void 0 : contract.items[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.orders) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && totalCurrent !== 0 && constants/* isClassicSub */.q5 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.row,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref5 = basket.data) === null || ref5 === void 0 ? void 0 : ref5.current_subscription,
                                                            defaultText: t('texts:basket:current_subscription')
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        className: classes.linkToAccount,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: '/account',
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: basket === null || basket === void 0 ? void 0 : (ref6 = basket.data) === null || ref6 === void 0 ? void 0 : ref6.check_on_account,
                                                                    defaultText: t('texts:basket:check_on_account')
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: totalCurrent,
                                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                            showDayOrMonth: false,
                                                            isShort: false,
                                                            displayFlexPrice: false
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    constants/* isFlex */.Lz && !isBuyAbleProducts && (basket === null || basket === void 0 ? void 0 : (ref7 = basket.data) === null || ref7 === void 0 ? void 0 : ref7.enable_duration) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.rowBorder,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                component: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref8 = basket.data) === null || ref8 === void 0 ? void 0 : ref8.duration,
                                                        defaultText: t('texts:basket:duration')
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        className: classes.engagement,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref9 = basket.data) === null || ref9 === void 0 ? void 0 : ref9.sub_engagement,
                                                            defaultText: t('texts:basket:sub_engagement')
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: cart === null || cart === void 0 ? void 0 : (ref10 = cart.item) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.totals) === null || ref11 === void 0 ? void 0 : ref11.totalWithoutBoughtProducts,
                                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                            showDayOrMonth: true,
                                                            isShort: false,
                                                            displayFlexPrice: displayFlexPrice
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    (basket === null || basket === void 0 ? void 0 : (ref12 = basket.data) === null || ref12 === void 0 ? void 0 : ref12.enable_assurance) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.rowBorder,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref13 = basket.data) === null || ref13 === void 0 ? void 0 : ref13.assurance,
                                                    defaultText: t('texts:basket:assurance')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref14 = basket.data) === null || ref14 === void 0 ? void 0 : ref14.free,
                                                            defaultText: t('texts:basket:free')
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    (basket === null || basket === void 0 ? void 0 : (ref15 = basket.data) === null || ref15 === void 0 ? void 0 : ref15.enable_shipping) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: isEndFunnel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.rowBorder,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref16 = basket.data) === null || ref16 === void 0 ? void 0 : ref16.shipping,
                                                        defaultText: t('texts:basket:shipping')
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.left,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: cart.item.totals.shipping === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: basket === null || basket === void 0 ? void 0 : (ref17 = basket.data) === null || ref17 === void 0 ? void 0 : ref17.free,
                                                                defaultText: t('texts:basket:free')
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                    amount: cart === null || cart === void 0 ? void 0 : (ref18 = cart.item) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.totals) === null || ref19 === void 0 ? void 0 : ref19.shipping,
                                                                    showDayOrMonth: false,
                                                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    (basket === null || basket === void 0 ? void 0 : (ref20 = basket.data) === null || ref20 === void 0 ? void 0 : ref20.enable_reduction) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.rowBorder,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref21 = basket.data) === null || ref21 === void 0 ? void 0 : ref21.reduction,
                                                    defaultText: t('texts:basket:reduction')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: (cart === null || cart === void 0 ? void 0 : (ref22 = cart.item) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.totals) === null || ref23 === void 0 ? void 0 : ref23.promotion) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                amount: cart === null || cart === void 0 ? void 0 : (ref24 = cart.item) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.totals) === null || ref25 === void 0 ? void 0 : ref25.promotion,
                                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                showDayOrMonth: false
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: basket === null || basket === void 0 ? void 0 : (ref26 = basket.data) === null || ref26 === void 0 ? void 0 : ref26.free,
                                                                defaultText: t('texts:basket:free')
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    !isBuyAbleProducts && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.rowBorder,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref27 = basket.data) === null || ref27 === void 0 ? void 0 : ref27.return_date,
                                                    defaultText: t('texts:basket:return_date')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.left,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    align: 'right',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref28 = basket.data) === null || ref28 === void 0 ? void 0 : ref28.whenever_you_want,
                                                            defaultText: t('texts:basket:whenever_you_want')
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (user === null || user === void 0 ? void 0 : (ref29 = user.balance) === null || ref29 === void 0 ? void 0 : ref29.balance) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.rowBorder,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'body2',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: basket === null || basket === void 0 ? void 0 : (ref30 = basket.data) === null || ref30 === void 0 ? void 0 : ref30.gift_card_text,
                                                defaultText: t('texts:basket:gift_card_text')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.left,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                className: (0,clsx_m/* default */.Z)('basket__discount', classes.green),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                        amount: user === null || user === void 0 ? void 0 : (ref31 = user.balance) === null || ref31 === void 0 ? void 0 : ref31.balance,
                                                        showDayOrMonth: false,
                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(classes.giftCardExplanation, 'basket-giftCard-explanation'),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                            fontSize: "small",
                                            className: classes.giftCardIcon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: basket === null || basket === void 0 ? void 0 : (ref32 = basket.data) === null || ref32 === void 0 ? void 0 : ref32.gift_card_explanation,
                                            defaultText: t('texts:basket:gift_card_explanation')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !isBuyAbleProducts ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        constants/* isFlex */.Lz ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.rowBorder, classes.rowNoBorder),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref33 = basket.data) === null || ref33 === void 0 ? void 0 : ref33.total,
                                                    defaultText: t('texts:basket:total')
                                                }),
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref34 = basket.data) === null || ref34 === void 0 ? void 0 : ref34.renttotal,
                                                    defaultText: t('texts:basket:rentTotal')
                                                }),
                                                "\xa0",
                                                !isEndFunnel && !notDisplayWithoutShipping && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (0,clsx_m/* default */.Z)(classes.shipping, 'shipping__note'),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref35 = basket.data) === null || ref35 === void 0 ? void 0 : ref35.without_shipping,
                                                        defaultText: t('texts:basket:withoutShipping')
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.left,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        color: 'secondary',
                                        className: 'basket__total',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                        amount: cart === null || cart === void 0 ? void 0 : (ref36 = cart.item) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.totals) === null || ref37 === void 0 ? void 0 : ref37.totalWithoutBoughtProducts,
                                                        numberOfDays: numberOfDaysLeftInCurrentSubscription,
                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                        showDayOrMonth: true,
                                                        displayFlexPrice: displayFlexPrice
                                                    }),
                                                    (cart === null || cart === void 0 ? void 0 : (ref38 = cart.item) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.totals) === null || ref39 === void 0 ? void 0 : ref39.shipping) !== 0 && isEndFunnel && !mixedBasket && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "\xa0+\xa0"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                    amount: cart === null || cart === void 0 ? void 0 : (ref40 = cart.item) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.totals) === null || ref41 === void 0 ? void 0 : ref41.shipping,
                                                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                    showDayOrMonth: false,
                                                                    displayFlexPrice: displayFlexPrice
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.rowBorder, classes.rowNoBorder),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: (promotions === null || promotions === void 0 ? void 0 : promotions.futurPrice) !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'body2',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref42 = basket.data) === null || ref42 === void 0 ? void 0 : ref42.total_with_subscription,
                                                        defaultText: t('texts:basket:total_with_subscription')
                                                    }),
                                                    "\xa0"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.left,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                color: 'secondary',
                                                className: 'basket__total',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: promotions === null || promotions === void 0 ? void 0 : promotions.futurPrice,
                                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                            showDayOrMonth: true,
                                                            displayFlexPrice: displayFlexPrice
                                                        }),
                                                        "\xa0",
                                                        isEndFunnel && (cart === null || cart === void 0 ? void 0 : (ref43 = cart.item) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.totals) === null || ref44 === void 0 ? void 0 : ref44.shipping) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                "+\xa0",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                    amount: cart === null || cart === void 0 ? void 0 : (ref45 = cart.item) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.totals) === null || ref46 === void 0 ? void 0 : ref46.shipping,
                                                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                    showDayOrMonth: false,
                                                                    displayFlexPrice: false
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        color: 'error',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref47 = basket.data) === null || ref47 === void 0 ? void 0 : ref47.error_basket,
                                                    defaultText: t('texts:basket:error_basket')
                                                }),
                                                "\xa0"
                                            ]
                                        })
                                    })
                                })
                            })
                        }),
                        (contract === null || contract === void 0 ? void 0 : (ref48 = contract.items) === null || ref48 === void 0 ? void 0 : ref48.length) > 0 && ((ref49 = contract === null || contract === void 0 ? void 0 : contract.items[0]) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.orders) === null || ref50 === void 0 ? void 0 : ref50.length) > 0 && !mixedBasket && constants/* isFlex */.Lz && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.row,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.priceMonth,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: 'body2',
                                            className: classes.titleIcon,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref51 = basket.data) === null || ref51 === void 0 ? void 0 : ref51.to_pay_this_month,
                                                        defaultText: t('texts:basket:to_pay_this_month')
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: 'caption',
                                            component: 'p',
                                            className: classes.engagement,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref52 = basket.data) === null || ref52 === void 0 ? void 0 : ref52.newarticles,
                                                    defaultText: t('texts:basket:newarticles')
                                                }),
                                                "\xa0",
                                                dayjs_min_default()().format('L'),
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: basket === null || basket === void 0 ? void 0 : (ref53 = basket.data) === null || ref53 === void 0 ? void 0 : ref53.to,
                                                    defaultText: t('texts:basket:to')
                                                }),
                                                "\xa0",
                                                cart.item.endLeasingDate
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.right,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        color: 'secondary',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: isEndFunnel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: (cart === null || cart === void 0 ? void 0 : (ref54 = cart.item) === null || ref54 === void 0 ? void 0 : (ref55 = ref54.totals) === null || ref55 === void 0 ? void 0 : ref55.totalWithoutBoughtProducts) + (cart === null || cart === void 0 ? void 0 : (ref56 = cart.item) === null || ref56 === void 0 ? void 0 : (ref57 = ref56.totals) === null || ref57 === void 0 ? void 0 : ref57.shipping),
                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                showDayOrMonth: true,
                                                isShort: false,
                                                numberOfDays: numberOfDaysLeftInCurrentSubscription,
                                                displayFlexPrice: displayFlexPrice
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                        amount: cart === null || cart === void 0 ? void 0 : (ref58 = cart.item) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.totals) === null || ref59 === void 0 ? void 0 : ref59.totalWithoutBoughtProducts,
                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                        showDayOrMonth: true,
                                                        isShort: false,
                                                        numberOfDays: numberOfDaysLeftInCurrentSubscription,
                                                        displayFlexPrice: displayFlexPrice
                                                    }),
                                                    "\xa0"
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(classes.rowBorder, classes.rowHeavyBorder, !mixedBasket && classes.rowHeavyBorderBottom),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        !mixedBasket && constants/* isClassicSub */.q5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: basket === null || basket === void 0 ? void 0 : (ref60 = basket.data) === null || ref60 === void 0 ? void 0 : ref60.total,
                                            defaultText: t('texts:basket:total')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: basket === null || basket === void 0 ? void 0 : (ref61 = basket.data) === null || ref61 === void 0 ? void 0 : ref61.renttotal,
                                            defaultText: t('texts:basket:buyTotal')
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.left,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body2',
                                color: 'secondary',
                                className: 'basket__total',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: isEndFunnel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: constants/* isFlex */.Lz ? (cart === null || cart === void 0 ? void 0 : (ref62 = cart.item) === null || ref62 === void 0 ? void 0 : (ref63 = ref62.totals) === null || ref63 === void 0 ? void 0 : ref63.total) - (cart === null || cart === void 0 ? void 0 : (ref64 = cart.item) === null || ref64 === void 0 ? void 0 : ref64.totals.totalWithoutBoughtProducts) - (cart === null || cart === void 0 ? void 0 : (ref65 = cart.item) === null || ref65 === void 0 ? void 0 : (ref66 = ref65.totals) === null || ref66 === void 0 ? void 0 : ref66.shipping) : (cart === null || cart === void 0 ? void 0 : (ref67 = cart.item) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.totals) === null || ref68 === void 0 ? void 0 : ref68.total) - (cart === null || cart === void 0 ? void 0 : (ref69 = cart.item) === null || ref69 === void 0 ? void 0 : (ref70 = ref69.totals) === null || ref70 === void 0 ? void 0 : ref70.shipping),
                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                showDayOrMonth: false,
                                                buyAble: true,
                                                displayFlexPrice: displayFlexPrice
                                            }),
                                            (cart === null || cart === void 0 ? void 0 : (ref71 = cart.item) === null || ref71 === void 0 ? void 0 : (ref72 = ref71.totals) === null || ref72 === void 0 ? void 0 : ref72.shipping) !== 0 && !mixedBasket && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\xa0+\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: cart === null || cart === void 0 ? void 0 : (ref73 = cart.item) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.totals) === null || ref74 === void 0 ? void 0 : ref74.shipping,
                                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                            showDayOrMonth: false,
                                                            buyAble: true
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                            amount: constants/* isFlex */.Lz ? (cart === null || cart === void 0 ? void 0 : (ref75 = cart.item) === null || ref75 === void 0 ? void 0 : (ref76 = ref75.totals) === null || ref76 === void 0 ? void 0 : ref76.total) - (cart === null || cart === void 0 ? void 0 : (ref77 = cart.item) === null || ref77 === void 0 ? void 0 : (ref78 = ref77.totals) === null || ref78 === void 0 ? void 0 : ref78.totalWithoutBoughtProducts) - (cart === null || cart === void 0 ? void 0 : (ref79 = cart.item) === null || ref79 === void 0 ? void 0 : (ref80 = ref79.totals) === null || ref80 === void 0 ? void 0 : ref80.shipping) : cart === null || cart === void 0 ? void 0 : (ref81 = cart.item) === null || ref81 === void 0 ? void 0 : (ref82 = ref81.totals) === null || ref82 === void 0 ? void 0 : ref82.totalItemWithoutPromotion,
                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                            showDayOrMonth: false,
                                            isShort: false,
                                            buyAble: true,
                                            displayFlexPrice: displayFlexPrice
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Shop_BasketTotalsSub = ((0,es/* connect */.$j)(BasketTotalsSub_mapStateToProps, BasketTotalsSub_mapDispatchToProps)(BasketTotalsSub));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(14903);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(85160);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBack.js
var ArrowBack = __webpack_require__(69826);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Add.js
var Add = __webpack_require__(63957);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Apartment.js
var Apartment = __webpack_require__(18049);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CloudUpload.js
var CloudUpload = __webpack_require__(12459);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var icons_Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandLess.js
var ExpandLess = __webpack_require__(35025);
// EXTERNAL MODULE: ./components/Global/GlobalModal.tsx
var GlobalModal = __webpack_require__(29902);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(59000);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(1864);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/fgas.ts






function fgas_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fgas_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var authHeaders = function() {
    return (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE));
};
var rmsCertificatesCreateUrl = function() {
    var domain = "https://api-staging.lizee.io" || 0;
    var baseUrl = domain.endsWith('/api') ? "".concat(domain, "/") : "".concat(domain, "/api/");
    return "".concat(baseUrl).concat(path_browserify_default().join(requests/* RMSRequestUrl.fgasCapacityCertificates */.jo.fgasCapacityCertificates, ''));
};
function normalizeFgasCertificate(raw) {
    var ref, ref1, ref2, ref3;
    var ref4, ref5, ref6, _supportingDocumentUrl;
    return {
        id: raw.id,
        certificateNumber: raw.certificateNumber,
        validityStartDate: raw.validityStartDate,
        validityEndDate: raw.validityEndDate,
        holderCompanyName: raw.holderCompanyName,
        holderSiret: raw.holderSiret,
        holderAddress: {
            address: (ref4 = (ref = raw.holderAddress) === null || ref === void 0 ? void 0 : ref.address) !== null && ref4 !== void 0 ? ref4 : '',
            zipcode: (ref5 = (ref1 = raw.holderAddress) === null || ref1 === void 0 ? void 0 : ref1.zipcode) !== null && ref5 !== void 0 ? ref5 : '',
            city: (ref6 = (ref2 = raw.holderAddress) === null || ref2 === void 0 ? void 0 : ref2.city) !== null && ref6 !== void 0 ? ref6 : ''
        },
        supportingDocumentUrl: (_supportingDocumentUrl = raw.supportingDocumentUrl) !== null && _supportingDocumentUrl !== void 0 ? _supportingDocumentUrl : (ref3 = raw.supportingDocument) === null || ref3 === void 0 ? void 0 : ref3.name
    };
}
var getFgasCapacityCertificates = function(email) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* RMSRequestUrl.fgasCapacityCertificates */.jo.fgasCapacityCertificates,
        uid: "renters/".concat(encodeURIComponent(email)),
        headers: authHeaders()
    }).then(function(rows) {
        return rows.map(normalizeFgasCertificate);
    });
};
var searchFgasCapacityCertificates = function(search) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* RMSRequestUrl.fgasCapacityCertificates */.jo.fgasCapacityCertificates,
        params: {
            search: search
        },
        headers: authHeaders()
    }).then(function(rows) {
        return rows.map(normalizeFgasCertificate);
    });
};
var patchOrderItemFgasCertificate = function(cartToken, itemId, certificateId) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.patch */.YZ.patch,
        url: requests/* ERequestUrl.createCart */.KU.createCart,
        uid: "".concat(cartToken, "/items/").concat(itemId),
        data: {
            fgasCapacityCertificateId: certificateId
        },
        headers: {
            'Content-Type': 'application/merge-patch+json'
        }
    });
};
var createFgasCapacityCertificate = function(payload, supportingDocument) {
    var form = new FormData();
    form.append('data', JSON.stringify(payload));
    form.append('locale', (0,api/* getLocale */.Kd)());
    form.append('supportingDocument', supportingDocument, supportingDocument.name);
    return axios_default()({
        method: 'POST',
        url: rmsCertificatesCreateUrl(),
        headers: _objectSpread({}, authHeaders(), {
            'x-api-key': "z5fJZCKfp8vhYe3Wmg3FzPEnVs4Rd9vM" || 0
        }),
        data: form
    }).then(function(res) {
        var ref;
        var raw = ((ref = res.data) === null || ref === void 0 ? void 0 : ref.data) != null ? res.data.data : res.data;
        return normalizeFgasCertificate(raw);
    });
};

;// CONCATENATED MODULE: ./utils/fgasCertificateValidation.ts
/** ISO YYYY-MM-DD ou JJ/MM/AAAA (réponses API / affichage). */ function parseFgasLocalYmd(raw) {
    var s = raw.trim();
    var iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
        var y = Number(iso[1]);
        var mo = Number(iso[2]) - 1;
        var d = Number(iso[3]);
        var dt = new Date(y, mo, d);
        if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) {
            return null;
        }
        return dt;
    }
    var fr = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
    if (fr) {
        var d1 = Number(fr[1]);
        var mo1 = Number(fr[2]) - 1;
        var y1 = Number(fr[3]);
        var dt1 = new Date(y1, mo1, d1);
        if (dt1.getFullYear() !== y1 || dt1.getMonth() !== mo1 || dt1.getDate() !== d1) {
            return null;
        }
        return dt1;
    }
    return null;
}
/** Expirée ou fin = jour civil local → non utilisable pour une commande. */ function isFgasEndDateExpiredOrToday(endDateRaw) {
    var end = parseFgasLocalYmd(endDateRaw);
    if (!end) return false;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return end <= today;
}
function isFgasStartStrictlyBeforeEnd(startRaw, endRaw) {
    var start = parseFgasLocalYmd(startRaw);
    var end = parseFgasLocalYmd(endRaw);
    if (!start || !end) return false;
    return start < end;
}
function isValidFgasSiret(raw) {
    return /^\d{14}$/.test(raw.trim());
}
function isValidFgasFrenchPostalCode(raw) {
    return /^\d{5}$/.test(raw.trim());
}

;// CONCATENATED MODULE: ./components/Basket/FgasCertificateModal.tsx




















function FgasCertificateModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function FgasCertificateModal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                FgasCertificateModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                FgasCertificateModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function FgasCertificateModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FgasCertificateModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FgasCertificateModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var EMPTY_FORM = {
    certificateNumber: '',
    validityStartDate: '',
    validityEndDate: '',
    holderCompanyName: '',
    holderSiret: '',
    holderAddress: {
        address: '',
        zipcode: '',
        city: ''
    }
};
var CERTS_INITIAL_COUNT = 3;
var FgasCertificateModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        /** Surcharge GlobalModal : pas de bandeau gris, pas de ligne, croix plate, moins d’air titre → contenu */ '@global': {
            '.fgas-certificate-modal .MuiPaper-root': {
                borderRadius: "".concat(theme.spacing(1), "px !important")
            },
            '.fgas-certificate-modal__head': {
                background: 'none !important',
                backgroundColor: 'transparent !important',
                borderBottom: 'none !important',
                paddingTop: "".concat(theme.spacing(3), "px !important"),
                paddingBottom: theme.spacing(1)
            },
            '.fgas-certificate-modal__close': {
                background: 'none !important',
                backgroundColor: 'transparent !important',
                color: "".concat(theme.palette.text.primary, " !important"),
                borderRadius: 0,
                width: theme.spacing(3),
                height: theme.spacing(3),
                padding: theme.spacing(0.25),
                '&:hover, &:focus': {
                    background: "".concat((0,colorManipulator/* fade */.U1)(theme.palette.common.black, 0.06), " !important"),
                    backgroundColor: 'transparent !important'
                }
            },
            '.fgas-certificate-modal__content': {
                paddingTop: theme.spacing(1)
            }
        },
        description: {
            marginTop: 0,
            marginBottom: theme.spacing(3)
        },
        // ── Vue 1 : liste ──
        sectionTitle: {
            fontWeight: 600,
            marginBottom: theme.spacing(2)
        },
        certCard: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: theme.spacing(1.5),
            padding: theme.spacing(1.5, 2),
            marginBottom: theme.spacing(1.5),
            border: "1px solid ".concat(theme.palette.divider),
            borderRadius: theme.shape.borderRadius,
            cursor: 'pointer',
            transition: 'border-color 0.15s',
            '&:hover': {
                borderColor: theme.palette.secondary.dark
            }
        },
        certCardSelected: {
            borderColor: theme.palette.secondary.dark
        },
        certIcon: {
            color: theme.palette.secondary.dark,
            flexShrink: 0,
            marginTop: 2
        },
        certName: {
            fontWeight: 600,
            marginBottom: theme.spacing(0.25)
        },
        certMeta: {
            color: theme.palette.text.secondary
        },
        showMoreBtn: {
            paddingLeft: 0,
            color: theme.palette.primary.main,
            marginBottom: theme.spacing(2)
        },
        separator: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(2),
            margin: theme.spacing(2.5, 0),
            color: theme.palette.text.secondary
        },
        separatorLine: {
            flex: 1
        },
        addNewBtn: {
            width: '100%',
            justifyContent: 'center',
            padding: theme.spacing(1.5, 2)
        },
        cancelRow: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: theme.spacing(1.5)
        },
        // ── Vue 2 : formulaire ──
        backLink: {
            paddingLeft: 0,
            alignSelf: 'flex-start',
            width: 'auto',
            justifyContent: 'flex-start',
            textAlign: 'left'
        },
        searchWrapper: {
            position: 'relative'
        },
        searchDropdown: {
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1400,
            maxHeight: 200,
            overflowY: 'auto'
        },
        /** Même rendu que `components/TextField/TextField` (classe `label`) */ inputLabel: {
            display: 'block',
            cursor: 'pointer',
            textAlign: 'inherit',
            fontSize: 11,
            fontFamily: theme.typography.fontFamily,
            color: theme.typography.body1.color,
            paddingLeft: theme.spacing(1.25),
            marginBottom: theme.spacing(0.5)
        },
        /** Même hauteur visuelle que les inputs TextField (pas de minHeight ni padding vertical en plus) */ certSearchRow: {
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
            padding: theme.spacing(0, 1, 0, 1.25),
            backgroundColor: theme.extraColors.greyLight,
            borderRadius: theme.spacing(0.75),
            border: "1px solid ".concat(theme.extraColors.greyLight)
        },
        certSearchIcon: {
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            color: theme.palette.text.secondary
        },
        certSearchFieldInner: {
            flex: 1,
            minWidth: 0,
            marginBottom: '0 !important',
            '& > label': {
                display: 'none'
            },
            '& .inputContainer': {
                backgroundColor: 'transparent'
            },
            '& .input': {
                border: 'none',
                backgroundColor: 'transparent'
            }
        },
        /** Même padding / rayon que `.input` dans `components/TextField/TextField` */ fileUploadArea: {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.spacing(1, 1.25),
            borderRadius: theme.spacing(0.75),
            cursor: 'pointer',
            border: "1px dashed ".concat(theme.palette.divider),
            transition: 'border-color 0.15s',
            '&:hover': {
                borderColor: theme.palette.primary.main
            }
        },
        fileUploadAreaDisabled: {
            cursor: 'not-allowed',
            opacity: 0.55,
            pointerEvents: 'none',
            '&:hover': {
                borderColor: theme.palette.divider
            }
        },
        fileUploadInner: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: theme.spacing(1.25),
            minWidth: 0,
            maxWidth: '100%',
            flex: '0 1 auto'
        },
        fileUploadText: {
            flex: 1,
            minWidth: 0,
            fontSize: 14,
            lineHeight: 1.25
        },
        fileUploadClear: {
            flexShrink: 0,
            padding: theme.spacing(0.5),
            marginRight: theme.spacing(-0.5)
        },
        validateBtn: {
            width: '100%'
        },
        loadingBtnLabel: {
            visibility: 'hidden'
        },
        // ── Vue 3 : confirmation ──
        confirmCard: {
            padding: theme.spacing(2),
            border: "1px solid ".concat(theme.palette.divider),
            borderRadius: theme.shape.borderRadius
        },
        confirmCompanyName: {
            fontWeight: 600,
            marginBottom: theme.spacing(0.5)
        },
        checkboxContainer: {
            border: "1px solid ".concat(theme.palette.primary.light),
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1.5),
            backgroundColor: (0,colorManipulator/* fade */.U1)(theme.palette.primary.main, 0.04)
        },
        checkboxLabel: {
            margin: 0,
            alignItems: 'flex-start',
            '& .MuiCheckbox-root': {
                paddingTop: 2
            }
        },
        confirmActions: {
            display: 'flex',
            gap: theme.spacing(1.5)
        },
        confirmBackBtn: {
            flex: 1
        },
        confirmBtn: {
            flex: 2
        },
        error: {
            color: theme.palette.error.main
        },
        /** Espacement vertical homogène entre les blocs (formulaire création + confirmation) */ formVerticalStack: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
            '& $description': {
                marginBottom: 0
            },
            '& $backLink': {
                marginBottom: 0
            },
            '& $error': {
                marginTop: 0,
                marginBottom: 0
            }
        },
        loadingCenter: {
            display: 'flex',
            justifyContent: 'center',
            padding: theme.spacing(4, 0)
        }
    };
});
var FgasCertificateModal = function(param) {
    var open = param.open, onClose = param.onClose, onConfirm = param.onConfirm, basketData = param.basketData, userEmail = param.userEmail;
    var classes = FgasCertificateModal_useStyles();
    var isGuest = !userEmail;
    var ref16 = (0,react.useState)('list'), view = ref16[0], setView = ref16[1];
    // Vue 1
    var ref1 = (0,react.useState)([]), certificates = ref1[0], setCertificates = ref1[1];
    var ref2 = (0,react.useState)(false), loadingCerts = ref2[0], setLoadingCerts = ref2[1];
    var ref3 = (0,react.useState)(false), showAll = ref3[0], setShowAll = ref3[1];
    // Attestation retenue pour la vue confirmation (liste existante, autocomplete ou création)
    var ref4 = (0,react.useState)(null), selectedCertificate = ref4[0], setSelectedCertificate = ref4[1];
    // Vue 2 – formulaire
    var ref5 = (0,react.useState)(EMPTY_FORM), form = ref5[0], setForm = ref5[1];
    var ref6 = (0,react.useState)(false), isAutoFilled = ref6[0], setIsAutoFilled = ref6[1];
    var ref7 = (0,react.useState)(null), autoFilledCert = ref7[0], setAutoFilledCert = ref7[1];
    var ref8 = (0,react.useState)(null), certFile = ref8[0], setCertFile = ref8[1];
    var nativeFileInputRef = (0,react.useRef)(null);
    // Recherche autocomplete
    var ref9 = (0,react.useState)([]), searchResults = ref9[0], setSearchResults = ref9[1];
    var ref10 = (0,react.useState)(false), isSearching = ref10[0], setIsSearching = ref10[1];
    /** Un n° AC identique existe côté API (résultat recherche). */ var ref11 = (0,react.useState)(false), acNumberConflict = ref11[0], setAcNumberConflict = ref11[1];
    var searchTimerRef = (0,react.useRef)();
    // Vue 3 – confirmation
    var ref12 = (0,react.useState)(false), confirmed = ref12[0], setConfirmed = ref12[1];
    var ref13 = (0,react.useState)(false), submitting = ref13[0], setSubmitting = ref13[1];
    var ref14 = (0,react.useState)(''), error = ref14[0], setError = ref14[1];
    /** Après création API : au retour liste, recharger les attestations */ var pendingListRefreshAfterCreateRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (!open) return;
        resetState();
        if (!userEmail) return;
        setLoadingCerts(true);
        getFgasCapacityCertificates(userEmail).then(setCertificates).catch(function() {
            return setCertificates([]);
        }).finally(function() {
            return setLoadingCerts(false);
        });
    }, [
        open,
        userEmail
    ]);
    var resetState = function() {
        setCertificates([]);
        setView(isGuest ? 'create' : 'list');
        setSelectedCertificate(null);
        setForm(EMPTY_FORM);
        setIsAutoFilled(false);
        setAutoFilledCert(null);
        setCertFile(null);
        setSearchResults([]);
        setAcNumberConflict(false);
        setShowAll(false);
        setConfirmed(false);
        setError('');
        pendingListRefreshAfterCreateRef.current = false;
        if (nativeFileInputRef.current) nativeFileInputRef.current.value = '';
    };
    var resetCreateForm = function() {
        setForm(EMPTY_FORM);
        setIsAutoFilled(false);
        setAutoFilledCert(null);
        setCertFile(null);
        setSearchResults([]);
        setAcNumberConflict(false);
        if (nativeFileInputRef.current) nativeFileInputRef.current.value = '';
    };
    var clearCertFile = function() {
        setCertFile(null);
        if (nativeFileInputRef.current) nativeFileInputRef.current.value = '';
    };
    var updateForm = function(key, value) {
        return setForm(function(prev) {
            return FgasCertificateModal_objectSpread({}, prev, FgasCertificateModal_defineProperty({}, key, value));
        });
    };
    var updateHolderAddress = function(key, value) {
        return setForm(function(prev) {
            return FgasCertificateModal_objectSpread({}, prev, {
                holderAddress: FgasCertificateModal_objectSpread({}, prev.holderAddress, FgasCertificateModal_defineProperty({}, key, value))
            });
        });
    };
    var handleCertNumberChange = function(value) {
        updateForm('certificateNumber', value);
        if (isAutoFilled) {
            setIsAutoFilled(false);
            setAutoFilledCert(null);
            setForm(FgasCertificateModal_objectSpread({}, EMPTY_FORM, {
                certificateNumber: value
            }));
        }
        clearTimeout(searchTimerRef.current);
        if (value.length < 2) {
            setSearchResults([]);
            setAcNumberConflict(false);
            setIsSearching(false);
            return;
        }
        setIsSearching(true);
        searchTimerRef.current = setTimeout(FgasCertificateModal_asyncToGenerator(runtime_default().mark(function _callee() {
            var results, conflict;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return searchFgasCapacityCertificates(value);
                    case 3:
                        results = _ctx.sent;
                        setSearchResults(results);
                        conflict = results.some(function(r) {
                            return r.certificateNumber === value;
                        });
                        setAcNumberConflict(conflict);
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        setSearchResults([]);
                        setAcNumberConflict(false);
                    case 13:
                        _ctx.prev = 13;
                        setIsSearching(false);
                        return _ctx.finish(13);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9,
                    13,
                    16
                ]
            ]);
        })), 300);
    };
    var handleSelectSearchResult = function(cert) {
        setForm({
            certificateNumber: cert.certificateNumber,
            validityStartDate: cert.validityStartDate,
            validityEndDate: cert.validityEndDate,
            holderCompanyName: cert.holderCompanyName,
            holderSiret: cert.holderSiret,
            holderAddress: cert.holderAddress
        });
        setAutoFilledCert(cert);
        setIsAutoFilled(true);
        setCertFile(null);
        setSearchResults([]);
        setAcNumberConflict(false);
    };
    var handleSelectExisting = function(cert) {
        setSelectedCertificate(cert);
        setView('confirm');
    };
    var handleGoBack = function() {
        setConfirmed(false);
        setError('');
        if (view === 'confirm') {
            setSelectedCertificate(null);
            resetCreateForm();
            setView(isGuest ? 'create' : 'list');
            if (pendingListRefreshAfterCreateRef.current && userEmail) {
                pendingListRefreshAfterCreateRef.current = false;
                setLoadingCerts(true);
                getFgasCapacityCertificates(userEmail).then(setCertificates).catch(function() {
                /* conserver la liste affichée si l’API échoue */ }).finally(function() {
                    return setLoadingCerts(false);
                });
            }
        } else if (view === 'create') {
            if (isGuest) {
                resetCreateForm();
            } else {
                setView('list');
            }
        }
    };
    var isDuplicateAcNumber = !isAutoFilled && form.certificateNumber.trim().length >= 2 && acNumberConflict;
    var manualFormatsInvalid = !isAutoFilled && !(isValidFgasSiret(form.holderSiret) && isValidFgasFrenchPostalCode(form.holderAddress.zipcode));
    var datesInvalid = !isFgasStartStrictlyBeforeEnd(form.validityStartDate, form.validityEndDate) || isFgasEndDateExpiredOrToday(form.validityEndDate);
    var isFormValid = !!form.certificateNumber.trim() && !!form.validityStartDate && !!form.validityEndDate && !!form.holderCompanyName.trim() && !!form.holderSiret.trim() && !!form.holderAddress.address.trim() && !!form.holderAddress.zipcode.trim() && !!form.holderAddress.city.trim() && (!!autoFilledCert || !!certFile) && (isAutoFilled || !manualFormatsInvalid) && !datesInvalid && !isDuplicateAcNumber;
    var siretShowError = !isAutoFilled && !!form.holderSiret.trim() && !isValidFgasSiret(form.holderSiret);
    var postalShowError = !isAutoFilled && !!form.holderAddress.zipcode.trim() && !isValidFgasFrenchPostalCode(form.holderAddress.zipcode);
    var dateOrderShowError = !!form.validityStartDate && !!form.validityEndDate && !isFgasStartStrictlyBeforeEnd(form.validityStartDate, form.validityEndDate);
    var endDateExpiredShowError = !!form.validityEndDate && isFgasEndDateExpiredOrToday(form.validityEndDate);
    /** Si les deux problèmes sont présents, on n’affiche que l’erreur d’ordre des dates. */ var showEndDateExpiredError = endDateExpiredShowError && !dateOrderShowError;
    var handleValidate = function() {
        var _ref = FgasCertificateModal_asyncToGenerator(runtime_default().mark(function _callee() {
            var payload, created;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!autoFilledCert) {
                            _ctx.next = 6;
                            break;
                        }
                        setError('');
                        setSelectedCertificate(autoFilledCert);
                        resetCreateForm();
                        setView('confirm');
                        return _ctx.abrupt("return");
                    case 6:
                        setSubmitting(true);
                        setError('');
                        _ctx.prev = 8;
                        payload = FgasCertificateModal_objectSpread({}, form, userEmail ? {
                            renter: {
                                email: userEmail
                            }
                        } : {});
                        _ctx.next = 12;
                        return createFgasCapacityCertificate(payload, certFile);
                    case 12:
                        created = _ctx.sent;
                        pendingListRefreshAfterCreateRef.current = true;
                        setSelectedCertificate(created);
                        resetCreateForm();
                        setView('confirm');
                        _ctx.next = 22;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](8);
                        setError('Une erreur est survenue. Veuillez r\xe9essayer.');
                    case 22:
                        _ctx.prev = 22;
                        setSubmitting(false);
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    19,
                    22,
                    25
                ]
            ]);
        }));
        return function handleValidate() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirm = function() {
        var _ref = FgasCertificateModal_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (selectedCertificate) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setSubmitting(true);
                        setError('');
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return onConfirm(selectedCertificate);
                    case 7:
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](4);
                        setError("Une erreur est survenue lors de l'enregistrement. Veuillez r\xe9essayer.");
                        setSubmitting(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    9
                ]
            ]);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var displayCert = selectedCertificate !== null && selectedCertificate !== void 0 ? selectedCertificate : form;
    var currentCompanyName = displayCert.holderCompanyName;
    var currentSiret = displayCert.holderSiret;
    var addressLines = function() {
        var _holderAddress = displayCert.holderAddress, address = _holderAddress.address, zipcode = _holderAddress.zipcode, city = _holderAddress.city;
        var line2 = "".concat(zipcode, " ").concat(city).trim();
        return [
            address.trim(),
            line2
        ].filter(Boolean);
    }();
    var displayedCerts = showAll ? certificates : certificates.slice(0, CERTS_INITIAL_COUNT);
    var hiddenCount = certificates.length - CERTS_INITIAL_COUNT;
    // Textes CMS avec fallbacks
    var t = basketData;
    /** Invité : pas de liste ; évite un frame vide tant que `view` vaut encore `list`. */ var resolvedView = isGuest && view === 'list' ? 'create' : view;
    var description = /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "body2",
        className: classes.description,
        color: "textSecondary",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
            asText: true,
            data: t === null || t === void 0 ? void 0 : t.fgas_modal_description,
            defaultText: "Au moins un produit de votre panier n\xe9cessite une mise en service par une soci\xe9t\xe9 ayant une attestation de capacit\xe9 en cours de validit\xe9."
        })
    });
    var backButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        className: classes.backLink,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
            fontSize: "small"
        }),
        onClick: handleGoBack,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
            asText: true,
            data: t === null || t === void 0 ? void 0 : t.fgas_back_button,
            defaultText: "Retour"
        })
    });
    var ref15;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalModal/* default */.Z, {
        open: open,
        onClose: onClose,
        customClass: "fgas-certificate-modal",
        modalTitle: {
            data: t === null || t === void 0 ? void 0 : t.fgas_modal_title,
            defaultText: "Saisie de l'attestation de capacit\xe9"
        },
        children: [
            resolvedView === 'list' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    description,
                    loadingCerts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classes.loadingCenter,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 28
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            certificates.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        className: classes.sectionTitle,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: t === null || t === void 0 ? void 0 : t.fgas_companies_title,
                                            defaultText: "Mes soci\xe9t\xe9s enregistr\xe9es"
                                        })
                                    }),
                                    displayedCerts.map(function(cert) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)(classes.certCard, (selectedCertificate === null || selectedCertificate === void 0 ? void 0 : selectedCertificate.id) === cert.id && classes.certCardSelected),
                                            onClick: function() {
                                                return handleSelectExisting(cert);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Apartment/* default */.Z, {
                                                    className: classes.certIcon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            className: classes.certName,
                                                            children: cert.holderCompanyName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "caption",
                                                            display: "block",
                                                            className: classes.certMeta,
                                                            children: [
                                                                "SIRET : ",
                                                                cert.holderSiret
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "caption",
                                                            display: "block",
                                                            className: classes.certMeta,
                                                            children: [
                                                                cert.certificateNumber,
                                                                cert.validityEndDate ? " — Valide jusqu'au ".concat(cert.validityEndDate) : ''
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, cert.id);
                                    }),
                                    hiddenCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: classes.showMoreBtn,
                                        size: "small",
                                        startIcon: showAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                                        onClick: function() {
                                            return setShowAll(function(v) {
                                                return !v;
                                            });
                                        },
                                        children: showAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: t === null || t === void 0 ? void 0 : t.fgas_show_less,
                                            defaultText: "Voir moins"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: t === null || t === void 0 ? void 0 : t.fgas_show_more,
                                                    defaultText: "Voir plus"
                                                }),
                                                " (".concat(hiddenCount, " autre").concat(hiddenCount > 1 ? 's' : '', ")")
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: classes.addNewBtn,
                                variant: "outlined",
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {}),
                                onClick: function() {
                                    return setView('create');
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: t === null || t === void 0 ? void 0 : t.fgas_add_new_button,
                                    defaultText: "Ajouter une nouvelle attestation de capacit\xe9"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: classes.cancelRow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: onClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: t === null || t === void 0 ? void 0 : t.fgas_cancel_button,
                                        defaultText: "Annuler"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            resolvedView === 'create' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.formVerticalStack,
                children: [
                    description,
                    !isGuest && backButton,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: (0,clsx_m/* default */.Z)(classes.inputLabel, 'label'),
                                htmlFor: "fgas-certificate-number",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: t === null || t === void 0 ? void 0 : t.fgas_certificate_number_label,
                                        defaultText: "Num\xe9ro d'attestation de capacit\xe9 (AC)"
                                    }),
                                    ' ',
                                    "*"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: classes.searchWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        className: classes.certSearchRow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                className: classes.certSearchIcon,
                                                children: isSearching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                    size: 16
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                                    color: "inherit",
                                                    fontSize: "small"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                className: classes.certSearchFieldInner,
                                                name: "fgas-certificate-number",
                                                placeholder: (0,CMSText/* prismicText */.yz)(t === null || t === void 0 ? void 0 : t.fgas_certificate_number_placeholder, 'Rechercher ou saisir un n\xb0 AC…'),
                                                value: form.certificateNumber,
                                                onChange: handleCertNumberChange,
                                                noMargin: true
                                            })
                                        ]
                                    }),
                                    searchResults.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                                        className: classes.searchDropdown,
                                        elevation: 4,
                                        children: [
                                            isDuplicateAcNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                px: 2,
                                                pt: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "caption",
                                                    display: "block",
                                                    className: classes.error,
                                                    children: "Ce num\xe9ro d'AC existe d\xe9j\xe0. Veuillez s\xe9lectionner l'AC existante ci-dessous."
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                                dense: true,
                                                disablePadding: true,
                                                children: searchResults.map(function(r) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                                                        button: true,
                                                        onClick: function() {
                                                            return handleSelectSearchResult(r);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                            primary: r.certificateNumber,
                                                            secondary: r.holderCompanyName
                                                        })
                                                    }, r.id);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: t === null || t === void 0 ? void 0 : t.fgas_company_name_label,
                                                defaultText: "Raison sociale"
                                            }),
                                            ' ',
                                            "*"
                                        ]
                                    }),
                                    name: "fgas-holder-company",
                                    type: "text",
                                    value: form.holderCompanyName,
                                    disabled: isAutoFilled,
                                    onChange: function(value) {
                                        return updateForm('holderCompanyName', value);
                                    },
                                    noMargin: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: t === null || t === void 0 ? void 0 : t.fgas_siret_label,
                                                    defaultText: "SIRET"
                                                }),
                                                ' ',
                                                "*"
                                            ]
                                        }),
                                        name: "fgas-holder-siret",
                                        type: "text",
                                        value: form.holderSiret,
                                        disabled: isAutoFilled,
                                        onChange: function(value) {
                                            return updateForm('holderSiret', value);
                                        },
                                        maxLength: 14,
                                        noMargin: true
                                    }),
                                    siretShowError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "caption",
                                        display: "block",
                                        className: classes.error,
                                        children: "Le SIRET doit contenir 14 chiffres"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: t === null || t === void 0 ? void 0 : t.fgas_address_label,
                                    defaultText: "Adresse"
                                }),
                                ' ',
                                "*"
                            ]
                        }),
                        name: "fgas-holder-address",
                        type: "text",
                        value: form.holderAddress.address,
                        disabled: isAutoFilled,
                        onChange: function(value) {
                            return updateHolderAddress('address', value);
                        },
                        noMargin: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: t === null || t === void 0 ? void 0 : t.fgas_postal_code_label,
                                                    defaultText: "Code postal"
                                                }),
                                                ' ',
                                                "*"
                                            ]
                                        }),
                                        name: "fgas-holder-postcode",
                                        type: "text",
                                        value: form.holderAddress.zipcode,
                                        disabled: isAutoFilled,
                                        onChange: function(value) {
                                            return updateHolderAddress('zipcode', value);
                                        },
                                        maxLength: 5,
                                        noMargin: true
                                    }),
                                    postalShowError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "caption",
                                        display: "block",
                                        className: classes.error,
                                        children: "Le code postal doit contenir 5 chiffres"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: t === null || t === void 0 ? void 0 : t.fgas_city_label,
                                                defaultText: "Ville"
                                            }),
                                            ' ',
                                            "*"
                                        ]
                                    }),
                                    name: "fgas-holder-city",
                                    type: "text",
                                    value: form.holderAddress.city,
                                    disabled: isAutoFilled,
                                    onChange: function(value) {
                                        return updateHolderAddress('city', value);
                                    },
                                    noMargin: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: t === null || t === void 0 ? void 0 : t.fgas_start_date_label,
                                                defaultText: "Date d\xe9but validit\xe9 AC"
                                            }),
                                            ' ',
                                            "*"
                                        ]
                                    }),
                                    name: "fgas-validity-start",
                                    type: "date",
                                    value: form.validityStartDate,
                                    disabled: isAutoFilled,
                                    onChange: function(value) {
                                        return updateForm('validityStartDate', value);
                                    },
                                    noMargin: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: t === null || t === void 0 ? void 0 : t.fgas_end_date_label,
                                                defaultText: "Date d'expiration AC"
                                            }),
                                            ' ',
                                            "*"
                                        ]
                                    }),
                                    name: "fgas-validity-end",
                                    type: "date",
                                    value: form.validityEndDate,
                                    disabled: isAutoFilled,
                                    onChange: function(value) {
                                        return updateForm('validityEndDate', value);
                                    },
                                    noMargin: true
                                })
                            })
                        ]
                    }),
                    dateOrderShowError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        className: classes.error,
                        children: "La date de d\xe9but doit \xeatre ant\xe9rieure \xe0 la date de fin"
                    }),
                    showEndDateExpiredError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        className: classes.error,
                        children: "L'attestation de capacit\xe9 est expir\xe9e ou expire aujourd'hui et ne peut pas \xeatre utilis\xe9e"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: (0,clsx_m/* default */.Z)(classes.inputLabel, 'label'),
                                htmlFor: "fgas-cert-file-input",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: t === null || t === void 0 ? void 0 : t.fgas_document_label,
                                        defaultText: "Document AC (pdf, jpeg, png)"
                                    }),
                                    !isAutoFilled && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)(classes.fileUploadArea, isAutoFilled && classes.fileUploadAreaDisabled),
                                onClick: function() {
                                    var ref;
                                    if (!isAutoFilled) (ref = nativeFileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    className: classes.fileUploadInner,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudUpload/* default */.Z, {
                                            color: "action",
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            color: "textSecondary",
                                            className: classes.fileUploadText,
                                            noWrap: true,
                                            children: certFile ? certFile.name : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: t === null || t === void 0 ? void 0 : t.fgas_document_placeholder,
                                                defaultText: "Cliquez pour s\xe9lectionner un fichier"
                                            })
                                        }),
                                        certFile && !isAutoFilled && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            type: "button",
                                            size: "small",
                                            className: classes.fileUploadClear,
                                            "aria-label": "Retirer le fichier",
                                            onClick: function(e) {
                                                e.stopPropagation();
                                                clearCertFile();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Close/* default */.Z, {
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "fgas-cert-file-input",
                                ref: nativeFileInputRef,
                                type: "file",
                                hidden: true,
                                disabled: isAutoFilled,
                                accept: ".pdf,.jpg,.jpeg,.png",
                                onChange: function(e) {
                                    var ref;
                                    return setCertFile((ref15 = (ref = e.target.files) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref15 !== void 0 ? ref15 : null);
                                }
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        className: classes.error,
                        children: error
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        className: classes.validateBtn,
                        variant: "contained",
                        color: "primary",
                        disabled: !isFormValid || submitting,
                        onClick: handleValidate,
                        children: [
                            submitting && /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: 18,
                                color: "inherit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)(FgasCertificateModal_defineProperty({}, classes.loadingBtnLabel, submitting)),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: t === null || t === void 0 ? void 0 : t.fgas_validate_button,
                                    defaultText: "Valider l'attestation"
                                })
                            })
                        ]
                    })
                ]
            }),
            resolvedView === 'confirm' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.formVerticalStack,
                children: [
                    description,
                    backButton,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.confirmCard,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                className: classes.confirmCompanyName,
                                children: currentCompanyName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                color: "textSecondary",
                                style: {
                                    whiteSpace: 'pre-line'
                                },
                                children: addressLines.join('\n')
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body2",
                                color: "textSecondary",
                                children: [
                                    "SIRET : ",
                                    currentSiret
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classes.checkboxContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                            className: classes.checkboxLabel,
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                checked: confirmed,
                                onChange: function(e) {
                                    return setConfirmed(e.target.checked);
                                },
                                color: "primary"
                            }),
                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        data: t === null || t === void 0 ? void 0 : t.fgas_certificate_checkbox,
                                        defaultText: "Je m'engage \xe0 faire r\xe9aliser la mise en service du ou des produits F-Gas pr\xe9sents dans mon panier par la soci\xe9t\xe9 "
                                    }),
                                    !(t === null || t === void 0 ? void 0 : t.fgas_certificate_checkbox) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: currentCompanyName
                                            }),
                                            "` ($",
                                            addressLines.join(', '),
                                            ")` ."
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        className: classes.error,
                        children: error
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.confirmActions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: classes.confirmBackBtn,
                                variant: "outlined",
                                onClick: handleGoBack,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: t === null || t === void 0 ? void 0 : t.fgas_back_button,
                                    defaultText: "Retour"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: classes.confirmBtn,
                                variant: "contained",
                                color: "primary",
                                disabled: !confirmed || submitting,
                                onClick: handleConfirm,
                                children: [
                                    submitting && /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        size: 18,
                                        color: "inherit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)(FgasCertificateModal_defineProperty({}, classes.loadingBtnLabel, submitting)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: t === null || t === void 0 ? void 0 : t.fgas_confirm_button,
                                            defaultText: "Confirmer et continuer"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Basket_FgasCertificateModal = (FgasCertificateModal);

// EXTERNAL MODULE: ./components/Layout/Drawer.style.tsx
var Drawer_style = __webpack_require__(15787);
;// CONCATENATED MODULE: ./components/Shop/BasketTotalsSecondHand.tsx







// import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
var BasketTotalsSecondHand_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        wrapperShipping: {
            margin: 0,
            padding: theme.spacing(1)
        },
        rowBorder: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: theme.spacing(1, 0.5),
            borderTop: "1px solid ".concat(theme.extraColors.greyLight)
        },
        left: {
            display: 'flex',
            flexDirection: 'row'
        },
        green: {
            color: theme.palette.success.main
        },
        rowNoBorder: {
            border: 0
        },
        delete: {
            width: 20,
            height: 20,
            minHeight: 20,
            padding: 0,
            boxShadow: 'none',
            background: 'none',
            '&:hover, &:focus': {
                color: theme.palette.error.main,
                background: 'none'
            },
            '& .MuiSvgIcon-root': {
                height: '.75em',
                width: '.75em'
            }
        },
        row: {
            display: 'flex',
            padding: theme.spacing(1, 0.5),
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    });
});
var BasketTotalsSecondHand = function(param) {
    var t = param.t, basket = param.basket, cart = param.cart, settings = param.settings, includeShipping = param.includeShipping, deleteCoupon = param.deleteCoupon;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var basketSecondHandClasses = BasketTotalsSecondHand_useStyles();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: basketSecondHandClasses.wrapperShipping,
        children: [
            (basket === null || basket === void 0 ? void 0 : (ref = basket.data) === null || ref === void 0 ? void 0 : ref.enable_reduction) && (cart.item.totals.promotion !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: basketSecondHandClasses.rowBorder,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: 'body2',
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: basket === null || basket === void 0 ? void 0 : (ref1 = basket.data) === null || ref1 === void 0 ? void 0 : ref1.reduction,
                                defaultText: t('texts:basket:reduction')
                            }),
                            "\xa0"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: basketSecondHandClasses.left,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            className: (0,clsx_m/* default */.Z)('basket__discount', basketSecondHandClasses.green),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                    amount: cart.item.totals.promotion,
                                    showDayOrMonth: false,
                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                })
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: basketSecondHandClasses.rowBorder,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: 'body2',
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: basket === null || basket === void 0 ? void 0 : (ref2 = basket.data) === null || ref2 === void 0 ? void 0 : ref2.reduction_text_explication,
                        defaultText: t('texts:basket:reduction_text_explication')
                    })
                })
            })),
            constants/* displayTtcAndHtPrice */.r4 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: basketSecondHandClasses.row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body2',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: basket === null || basket === void 0 ? void 0 : (ref3 = basket.data) === null || ref3 === void 0 ? void 0 : ref3.total_excl_vat,
                                    defaultText: t('texts:basket:total_without_shipping_excl_vat')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: basketSecondHandClasses.left,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                            amount: cart === null || cart === void 0 ? void 0 : (ref4 = cart.item) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.totals) === null || ref5 === void 0 ? void 0 : ref5.itemsBeforeTax,
                                            showDayOrMonth: false,
                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    includeShipping && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: basketSecondHandClasses.row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body2',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: basket === null || basket === void 0 ? void 0 : (ref6 = basket.data) === null || ref6 === void 0 ? void 0 : ref6.delivery_fees_excl_vat,
                                    defaultText: t('texts:basket:delivery_fees_excl_vat')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: basketSecondHandClasses.left,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                            amount: cart === null || cart === void 0 ? void 0 : (ref7 = cart.item) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.totals) === null || ref8 === void 0 ? void 0 : ref8.shippingBeforeTax,
                                            showDayOrMonth: false,
                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: basketSecondHandClasses.row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body2',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: basket === null || basket === void 0 ? void 0 : (ref9 = basket.data) === null || ref9 === void 0 ? void 0 : ref9.vat,
                                    defaultText: t('texts:basket:vat')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: basketSecondHandClasses.left,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                            amount: includeShipping ? cart === null || cart === void 0 ? void 0 : (ref10 = cart.item) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.totals) === null || ref11 === void 0 ? void 0 : ref11.taxes : cart === null || cart === void 0 ? void 0 : (ref12 = cart.item) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.totals) === null || ref13 === void 0 ? void 0 : ref13.itemTaxes,
                                            showDayOrMonth: false,
                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: basketSecondHandClasses.row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: basket === null || basket === void 0 ? void 0 : (ref14 = basket.data) === null || ref14 === void 0 ? void 0 : ref14.total_without_shipping,
                                defaultText: t('texts:basket:total_without_shipping')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: basketSecondHandClasses.left,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body2',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        amount: cart === null || cart === void 0 ? void 0 : (ref15 = cart.item) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.totals) === null || ref16 === void 0 ? void 0 : ref16.totalSecondHand,
                                        showDayOrMonth: false,
                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var Shop_BasketTotalsSecondHand = (BasketTotalsSecondHand);

// EXTERNAL MODULE: ./utils/gtag.ts
var gtag = __webpack_require__(65809);
;// CONCATENATED MODULE: ./components/Basket/Basket.styles.ts

function Basket_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useBasketStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {},
        fullHeight: Basket_styles_defineProperty({}, theme.breakpoints.up('sm'), {
            minHeight: '100%',
            display: 'flex',
            alignItems: 'center'
        }),
        isAbsoluteHidden: {
            opacity: 0.5
        },
        count: {
            padding: theme.spacing(1, 0, 0, 2),
            marginTop: 0,
            fontWeight: 400,
            color: theme.extraColors.greyText
        },
        bold: {
            fontWeight: 'bold'
        },
        footerRow: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: theme.spacing(1, 2),
            gap: theme.spacing(2),
            margin: '0 !important',
            borderTop: '1px solid black',
            fontSize: '13px'
        },
        basketBtn: {
            padding: 0,
            minWidth: 0,
            width: theme.sizes.headerHeight,
            height: theme.sizes.headerHeight,
            color: function(LayoutStyle) {
                return !LayoutStyle.isTransparent ? LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black : theme.palette.common.white;
            },
            '&:hover, &:focus': {
                color: function(LayoutStyle) {
                    return !LayoutStyle.isTransparent && (LayoutStyle.backgroundColor && LayoutStyle.color && LayoutStyle.hover.color ? LayoutStyle.hover.color : theme.palette.primary.main);
                },
                backgroundColor: 'transparent',
                cursor: 'pointer'
            },
            '&.Mui-disabled': {
                color: 'currentColor'
            }
        },
        basketBtnReadOnly: {
            cursor: 'default',
            pointerEvents: 'none',
            '&:hover, &:focus': {
                cursor: 'default',
                pointerEvents: 'none'
            }
        },
        basketBtnText: {
            marginLeft: theme.spacing(1)
        },
        basketBtnIcon: {
            display: 'block',
            maxWidth: '100%',
            height: 'auto'
        },
        basketBtnIconSvg: {
            lineHeight: 1,
            '& .injected-svg': {
                display: 'inline-block',
                width: '1em',
                height: '1em',
                fontSize: '1.5rem',
                fill: 'currentColor',
                transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                flexShrink: 0,
                userSelect: 'none'
            }
        },
        badge: {
            position: 'absolute',
            bottom: theme.spacing(1),
            right: theme.spacing(1),
            padding: theme.spacing(0, 0.5),
            height: 20,
            lineHeight: '20px',
            minWidth: 20,
            borderRadius: theme.shape.borderRadius,
            fontSize: 13,
            fontWeight: 700,
            textAlign: 'center',
            border: "1px solid ".concat(theme.palette.common.white),
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        basket: Basket_styles_defineProperty({
            padding: theme.spacing(1, 2),
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.common.white
        }, theme.breakpoints.up('md'), {
            minHeight: '100%'
        }),
        basketBG: {
            backgroundColor: theme.extraColors.greyLight
        },
        basketContent: Basket_styles_defineProperty({
            padding: theme.spacing(2)
        }, theme.breakpoints.up('lg'), {
            padding: theme.spacing(2, 6)
        }),
        basketFooter: Basket_styles_defineProperty({
            zIndex: 10,
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1),
            padding: theme.spacing(1),
            backgroundColor: theme.palette.common.white
        }, theme.breakpoints.up('lg'), {
            padding: theme.spacing(2)
        }),
        basketProducts: {
            display: 'flex',
            flexDirection: 'column'
        },
        basketProductsCart: {},
        basketProductsFunnel: Basket_styles_defineProperty({}, theme.breakpoints.up('md'), {
            maxHeight: '55vh',
            overflow: 'auto'
        }),
        basketProductsList: {},
        reset: {
            color: theme.extraColors.greyText,
            margin: theme.spacing(0, 1, 0, 0),
            '&>img': {
                verticalAlign: 'middle'
            }
        },
        resetSmall: {
            padding: 0,
            fontSize: theme.typography.caption.fontSize,
            color: theme.palette.error.main,
            '&:hover, &:focus': {
                background: 'none'
            }
        },
        backdrop: {
            backgroundColor: 'rgba(40, 42, 37, .15)'
        },
        row: {
            display: 'flex',
            padding: theme.spacing(1, 0.5),
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        rowShipping: {
            display: 'inline-flex',
            justifyContent: 'center',
            width: '100%',
            '&>div': {
                marginLeft: 0
            }
        },
        next: {},
        alignCenter: {
            textAlign: 'center',
            width: '100%'
        },
        close: Basket_styles_defineProperty({
            cursor: 'pointer'
        }, theme.breakpoints.up('lg'), {}),
        smallText: {
            display: 'block',
            color: theme.extraColors.greyText
        },
        totalDetails: {
            marginLeft: theme.spacing(1),
            fontWeight: 700
        },
        rowFooterSub: {
            marginTop: 0
        },
        shipping: {
            fontSize: '80%',
            fontWeight: 400,
            color: "".concat(theme.extraColors.greyText)
        },
        basketTotalMixed: {
            borderTop: 0,
            borderBottom: "1px solid ".concat(theme.extraColors.grey),
            marginBottom: theme.spacing(1)
        },
        basketActions: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        basketActionsDelete: {
            justifyContent: 'center'
        },
        basketLinkToProductCard: {
            textAlign: 'center'
        },
        basketCheckboxValidation: {
            display: 'flex',
            alignItems: 'flex-start'
        }
    });
});

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocalMallOutlined.js
var LocalMallOutlined = __webpack_require__(18760);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 2 modules
var react_svg_esm = __webpack_require__(52933);
// EXTERNAL MODULE: ./utils/proxySvgUrl.ts
var proxySvgUrl = __webpack_require__(43359);
;// CONCATENATED MODULE: ./components/Basket/BasketButton.tsx










var BasketButton = function(param) {
    var isFunnel = param.isFunnel, productsCount = param.productsCount, layoutStyle = param.layoutStyle, toggleBasketDetails = param.toggleBasketDetails, basketIcon = param.basketIcon, showBasketWording = param.showBasketWording, settings = param.settings;
    var ref;
    var classes = useBasketStyles(layoutStyle);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        id: "menu-toggler",
        "data-testid": "basketButton",
        className: (0,clsx_m/* default */.Z)(classes.basketBtn, isFunnel && classes.basketBtnReadOnly, productsCount === 0 && classes.basketBtnReadOnly, 'basket__btn'),
        disableRipple: true,
        "aria-controls": "cart-menu",
        "aria-haspopup": "true",
        onClick: !isFunnel && productsCount !== 0 ? toggleBasketDetails : undefined,
        children: [
            (basketIcon === null || basketIcon === void 0 ? void 0 : basketIcon.url) && (basketIcon === null || basketIcon === void 0 ? void 0 : (ref = basketIcon.url) === null || ref === void 0 ? void 0 : ref.length) > 0 ? (basketIcon === null || basketIcon === void 0 ? void 0 : basketIcon.url.split('.').pop()) === 'svg' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: (0,proxySvgUrl/* proxySvgUrl */.u)(basketIcon === null || basketIcon === void 0 ? void 0 : basketIcon.url),
                className: (0,clsx_m/* default */.Z)('basket__icon', 'basket__icon--svg', classes.basketBtnIcon, classes.basketBtnIconSvg),
                wrapper: "span"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: basketIcon === null || basketIcon === void 0 ? void 0 : basketIcon.url,
                className: (0,clsx_m/* default */.Z)('basket__icon', classes.basketBtnIcon),
                alt: "basket__icon"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalMallOutlined/* default */.Z, {}),
            showBasketWording ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                data: settings === null || settings === void 0 ? void 0 : settings.my_basket,
                defaultText: t('texts:general:my_basket')
            }) : null,
            productsCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)('cart-badge', classes.badge),
                children: productsCount
            })
        ]
    }));
};

// EXTERNAL MODULE: ./utils/taxPricing.ts
var taxPricing = __webpack_require__(59973);
// EXTERNAL MODULE: ./redux/actions/cart.ts
var cart = __webpack_require__(14596);
;// CONCATENATED MODULE: ./components/Basket/Basket.tsx



































function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Basket_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Basket_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Basket_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Basket_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Basket_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Basket_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Basket_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Basket_mapStateToProps = function(state) {
    var ref, ref1;
    var showBasket = state === null || state === void 0 ? void 0 : (ref = state.basket) === null || ref === void 0 ? void 0 : ref.showBasketDetails;
    return {
        cart: state.cart,
        stock: state.stock,
        promotions: state.promotions,
        contract: state.contract,
        user: state.user,
        isBasketOpen: showBasket,
        parameters: state.parameters,
        takeBackStock: (ref1 = state.takeBack) === null || ref1 === void 0 ? void 0 : ref1.takeBackStock
    };
};
var Basket_mapDispatchToProps = {
    setShowBasket: basket/* setShowBasket */.az,
    recheckCartStock: cart/* recheckCartStock */.aD
};
var MainTooltip = (0,withStyles/* default */.Z)(function(theme) {
    return {
        tooltip: {
            textAlign: 'center',
            padding: theme.spacing(1),
            lineHeight: 1,
            '&:hover, &:focus': {
                cursor: 'default'
            }
        }
    };
})(Tooltip/* default */.ZP);
var Basket = function(param1) {
    var nextStep = param1.nextStep, promotions = param1.promotions, setShowBasket1 = param1.setShowBasket, isBasketOpen = param1.isBasketOpen, basket = param1.basket, contract = param1.contract, stock = param1.stock, isAbsolute = param1.isAbsolute, cart = param1.cart, parameters = param1.parameters, settings = param1.settings, hidePrice = param1.hidePrice, showSizes = param1.showSizes, layoutStyle = param1.layoutStyle, takeback = param1.takeback, user = param1.user, funnel = param1.funnel, deleteCoupon = param1.deleteCoupon, takeBackStock = param1.takeBackStock;
    var ref66, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50;
    var ref51 = (0,useCart/* useCart */.j)(), deleteCart = ref51.deleteCart, getCart = ref51.getCart;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = useBasketStyles(layoutStyle);
    var drawerClasses = (0,Drawer_style/* default */.Z)();
    var ref52 = (0,useMatomo/* default */.Z)(), trackEvent = ref52.trackEvent, pushInstruction = ref52.pushInstruction;
    var isCart = typeof cart.item !== 'undefined' && cart.item.items && cart.item.items.length > 0;
    var ref53 = (0,react.useState)([]), errorArray = ref53[0], setErrorArray = ref53[1];
    var ref54 = (0,react.useState)(false), errorStock = ref54[0], setErrorStock = ref54[1];
    var ref55 = (0,react.useState)(false), hasTryOutError = ref55[0], setHasTryOutError = ref55[1];
    var ref56 = (0,react.useState)(30), numberOfDaysLeftInCurrentSubscription = ref56[0], setNumberOfDaysLeftInCurrentSubscription = ref56[1];
    var ref57 = (0,react.useState)(''), currentUrl = ref57[0], setCurrentUrl = ref57[1];
    var notDisplayWithoutShipping = basket === null || basket === void 0 ? void 0 : (ref66 = basket.data) === null || ref66 === void 0 ? void 0 : ref66.not_display_without_shipping;
    var basketIcon = basket === null || basket === void 0 ? void 0 : (ref2 = basket.data) === null || ref2 === void 0 ? void 0 : ref2.basketbutton;
    var enableEmptyCartButton = basket === null || basket === void 0 ? void 0 : (ref3 = basket.data) === null || ref3 === void 0 ? void 0 : ref3.enable_empty_cart_button;
    var displayFlexPrice = settings === null || settings === void 0 ? void 0 : settings.display_flex_price_a_day;
    var router = (0,next_router.useRouter)();
    var isFunnel = [
        '/information',
        '/shipping',
        '/payment'
    ].includes(router.pathname);
    var isEndFunnel = router.route === '/shipping' || router.route === '/payment';
    var ref58 = (0,react.useState)(0), amountTotal = ref58[0], setAmountTotal = ref58[1];
    var start = dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref4 = cart.item) === null || ref4 === void 0 ? void 0 : ref4.startLeasingDate, 'DD/MM/YYYY');
    var end = dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref5 = cart.item) === null || ref5 === void 0 ? void 0 : ref5.endLeasingDate, 'DD/MM/YYYY');
    var ref59 = (0,react.useState)(end.diff(start, 'day') + 1), dayRange = ref59[0], setDayRange = ref59[1];
    var locked = cart.item && cart.item.items && cart.item.items.length > 0;
    var ref60 = (0,react.useMemo)(function() {
        var ref71, ref65;
        var buyAbleProducts = [];
        var rentAbleProducts = [];
        var secondHandProducts = [];
        var rentableProductsQuantity = 0;
        var buyableProductsQuantity = 0;
        var secondHandProductsQuantity = 0;
        var productsCount = 0;
        var isSecondHand = false;
        cart === null || cart === void 0 ? void 0 : (ref71 = cart.item) === null || ref71 === void 0 ? void 0 : (ref65 = ref71.items) === null || ref65 === void 0 ? void 0 : ref65.map(function(product) {
            var quantity = product.quantity;
            productsCount += quantity;
            if (product.type === 'SECOND_HAND') {
                // Check if we at least have one second hand item in the cart to determine the basket type
                isSecondHand = true;
            }
            if (product.product.variants[0].purchase) {
                buyAbleProducts.push(product);
                buyableProductsQuantity += quantity;
            } else if (Object.keys(product.units[0] || {}).includes('puid')) {
                var ref72, ref67, ref68, ref69, ref70;
                // For some reasons there's no image being sent back in the cart request for secondHand products
                var images = ((ref67 = (ref72 = stock.stock.length > 0 ? stock.stock : stock.stockBasket) === null || ref72 === void 0 ? void 0 : ref72.find(function(el) {
                    var ref;
                    return !!((ref = product.product.variants) === null || ref === void 0 ? void 0 : ref.find(function(variant) {
                        return el.lizeeSKU === variant.sku;
                    }));
                })) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.secondHand) === null || ref68 === void 0 ? void 0 : (ref69 = ref68[0]) === null || ref69 === void 0 ? void 0 : (ref70 = ref69.images) === null || ref70 === void 0 ? void 0 : ref70.map(function(img) {
                    if (img.path && !img.cachedPath) {
                        return {
                            cachedPath: img.path,
                            path: img.path.split('/').pop()
                        };
                    }
                    return img;
                })) || [];
                if (product.product.images.length === 0 && images) {
                    product.product.images = images;
                }
                var productVariantMap = product.product.variants.reduce(function(acc, variant) {
                    acc.set(variant.code, variant);
                    return acc;
                }, new Map());
                var units = product.units.map(function(unit) {
                    var u = Basket_objectSpread({}, unit);
                    var variant = productVariantMap.get(unit.variantCode);
                    if (variant) {
                        var pricing = (0,taxPricing/* getPricingWithTaxInfo */.B)(u.price, variant.taxIncludedInPrice, variant.taxRate);
                        u.price_ht = pricing.priceHt;
                        u.price = pricing.priceTtc;
                    }
                    return u;
                });
                secondHandProducts.push(Basket_objectSpread({}, product, {
                    units: units
                }));
                secondHandProductsQuantity += quantity;
            } else {
                rentAbleProducts.push(product);
                rentableProductsQuantity += quantity;
            }
        });
        return {
            isSecondHand: isSecondHand,
            productsCount: productsCount,
            rentableProductsQuantity: rentableProductsQuantity,
            buyableProductsQuantity: buyableProductsQuantity,
            secondHandProductsQuantity: secondHandProductsQuantity,
            buyAbleProducts: buyAbleProducts,
            rentAbleProducts: rentAbleProducts,
            secondHandProductsList: secondHandProducts,
            mixedBasket: (buyAbleProducts === null || buyAbleProducts === void 0 ? void 0 : buyAbleProducts.length) > 0 && (rentAbleProducts === null || rentAbleProducts === void 0 ? void 0 : rentAbleProducts.length) > 0
        };
    }, [
        cart.item,
        cart === null || cart === void 0 ? void 0 : (ref6 = cart.item) === null || ref6 === void 0 ? void 0 : ref6.items,
        stock
    ]), isSecondHand1 = ref60.isSecondHand, buyableProductsQuantity1 = ref60.buyableProductsQuantity, productsCount1 = ref60.productsCount, buyAbleProducts1 = ref60.buyAbleProducts, rentAbleProducts1 = ref60.rentAbleProducts, secondHandProductsList = ref60.secondHandProductsList, rentableProductsQuantity1 = ref60.rentableProductsQuantity, secondHandProductsQuantity1 = ref60.secondHandProductsQuantity, mixedBasket = ref60.mixedBasket;
    var ref61 = (0,react.useState)(false), showTooltip = ref61[0], setShowTooltip = ref61[1];
    var ref62 = (0,react.useState)(false), fgasCertModalOpen = ref62[0], setFgasCertModalOpen = ref62[1];
    var isEnableChooseStartingDate = parameters === null || parameters === void 0 ? void 0 : (ref7 = parameters.items) === null || ref7 === void 0 ? void 0 : ref7.enableChooseStartingDate;
    var ref63;
    var hasFgasProducts = (0,react.useMemo)(function() {
        var ref, ref74;
        return (ref63 = (ref = cart.item) === null || ref === void 0 ? void 0 : (ref74 = ref.items) === null || ref74 === void 0 ? void 0 : ref74.some(function(item) {
            return item.product.isFgas && !item.fgasCapacityCertificateId;
        })) !== null && ref63 !== void 0 ? ref63 : false;
    }, [
        (ref8 = cart.item) === null || ref8 === void 0 ? void 0 : ref8.items
    ]);
    var showBasketWording = (0,CMSText/* isPrismicText */.LT)(settings === null || settings === void 0 ? void 0 : settings.my_basket);
    var ref64 = (0,react.useState)(false), basketValidation = ref64[0], setBasketValidation = ref64[1];
    var secondHandProductValidationText = basket === null || basket === void 0 ? void 0 : (ref9 = basket.data) === null || ref9 === void 0 ? void 0 : ref9.checkbox_second_hand_product_validation;
    var changeBasketValidation = function() {
        setBasketValidation(!basketValidation);
    };
    (0,react.useEffect)(function() {
        if (router.isReady) {
            setCurrentUrl(router.asPath);
        }
    }, [
        router.isReady
    ]);
    (0,react.useEffect)(function() {
        var ref, ref75, ref76, ref77;
        isEndFunnel ? setAmountTotal(cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref75 = ref.totals) === null || ref75 === void 0 ? void 0 : ref75.total) : setAmountTotal(cart === null || cart === void 0 ? void 0 : (ref76 = cart.item) === null || ref76 === void 0 ? void 0 : (ref77 = ref76.totals) === null || ref77 === void 0 ? void 0 : ref77.items);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.item
    ]);
    (0,react.useEffect)(function() {
        var ref, ref78;
        setHasTryOutError((0,utils/* checkTryOutError */.HC)(cart));
        var isHalfDayRange = (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.oneDayDuration) === 'afternoon' || (cart === null || cart === void 0 ? void 0 : (ref78 = cart.item) === null || ref78 === void 0 ? void 0 : ref78.oneDayDuration) === 'morning';
        isHalfDayRange ? setDayRange(0.5) : setDayRange(end.diff(start, 'day') + 1);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.item
    ]);
    var toggleBasketDetails = function() {
        setShowBasket1(!isBasketOpen);
        trackEvent({
            category: 'Basket',
            action: "Open Basket"
        });
    };
    var handleClose = function() {
        setShowBasket1(false);
    };
    (0,react.useEffect)(function() {
        // if price per day, we need to extract buyable product pric to multiplie it by 30 so it is divided back on the total
        if (mixedBasket && displayFlexPrice) {
            var ref, ref79, ref80;
            var AmountTotalWithBuyable = 0;
            cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref79 = ref.items) === null || ref79 === void 0 ? void 0 : ref79.map(function(product) {
                if (!(0,utils/* isPurchasedItem */.mo)(product)) {
                    AmountTotalWithBuyable += !displayFlexPrice ? product.total : product.total * 30;
                }
            });
            if ((contract === null || contract === void 0 ? void 0 : (ref80 = contract.items) === null || ref80 === void 0 ? void 0 : ref80.length) > 0) {
                AmountTotalWithBuyable += contract === null || contract === void 0 ? void 0 : contract.items[0].totalWithoutBoughtProducts;
            }
            setAmountTotal(AmountTotalWithBuyable);
        }
    }, [
        mixedBasket
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var newArr = [];
        isCart && ((ref = cart.item.items) === null || ref === void 0 ? void 0 : ref.map(function(product) {
            var availability = (0,utils/* checkStockQuantityByItemType */.qe)(stock, product.product.variants[0], product.type, 'basket');
            if (product.quantity > availability) {
                newArr.push({
                    error: true,
                    code: product.product.variants[0].code
                });
            }
        }));
        setErrorStock(newArr.length > 0);
        setErrorArray(newArr);
    }, [
        stock === null || stock === void 0 ? void 0 : stock.stockBasket
    ]);
    var emptyCart = function() {
        var _ref = Basket_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref81, ref82, ref83;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        deleteCart();
                        trackEvent({
                            category: 'Basket',
                            action: "Empty Basket"
                        });
                        pushInstruction('clearEcommerceCart');
                        pushInstruction('trackEcommerceCartUpdate', constants/* isSubscription */.Nn ? (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref81 = ref.totals) === null || ref81 === void 0 ? void 0 : ref81.totalWithCart) : (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref82 = cart.item) === null || ref82 === void 0 ? void 0 : (ref83 = ref82.totals) === null || ref83 === void 0 ? void 0 : ref83.total));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function emptyCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var trackContinue = function() {
        trackEvent({
            category: 'Basket',
            action: "Initiate Checkout",
            name: "Click on Continue on ".concat(currentUrl),
            value: (0,utils/* numberToPrice */.e8)(cart.item.totals.total)
        });
        var gaParams = {
            currency: cart.item.currency,
            value: (0,utils/* numberToPrice */.e8)(cart.item.totals.items),
            items: cart.item.items.map(function(param) {
                var product = param.product, quantity = param.quantity, total = param.total;
                var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                var _obj;
                return _obj = {}, Basket_defineProperty(_obj, 'item_name', product === null || product === void 0 ? void 0 : product.name), Basket_defineProperty(_obj, 'item_id', gtag/* isChalhoub */.LP ? firstVariant.sku : product === null || product === void 0 ? void 0 : product.code), Basket_defineProperty(_obj, 'item_variant', gtag/* isChalhoub */.LP && firstVariant.code), Basket_defineProperty(_obj, "price", (0,utils/* numberToPrice */.e8)(total)), Basket_defineProperty(_obj, "quantity", quantity), _obj;
            })
        };
        var cleanGAParams = (0,gtag/* clearItemVariantFromGAParamsIfNotChalhoub */.o9)(gaParams);
        gtag/* tracker */.ap(base/* GAEvent.BEGIN_CHECKOUT */.gB.BEGIN_CHECKOUT, cleanGAParams);
        (0,gtag/* safeDataLayerPush */.Kx)((0,gtag/* getCheckoutGtmData */.MI)(cart));
        setShowBasket1(false);
    };
    var RedirectToFunnel = function() {
        trackEvent({
            category: 'Basket',
            action: "Continue from Basket to Informations"
        });
        setShowBasket1(false);
    };
    var handleContinue = function() {
        trackContinue();
        if (hasFgasProducts) {
            setFgasCertModalOpen(true);
        } else {
            router.push(nextStep);
        }
    };
    var handleFgasConfirm = function() {
        var _ref = Basket_asyncToGenerator(runtime_default().mark(function _callee(certificate) {
            var certId, fgasItems, _blocked_date_range;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        certId = Number(certificate.id);
                        if (!(Number.isFinite(certId) && cart.item)) {
                            _ctx.next = 8;
                            break;
                        }
                        fgasItems = cart.item.items.filter(function(item) {
                            return item.product.isFgas;
                        });
                        _ctx.next = 5;
                        return Promise.all(fgasItems.map(function(item) {
                            return patchOrderItemFgasCertificate(cart.item.tokenValue, item.id, certId);
                        }));
                    case 5:
                        ;
                        _ctx.next = 8;
                        return getCart(cart.item.tokenValue, (_blocked_date_range = cart.blocked_date_range) !== null && _blocked_date_range !== void 0 ? _blocked_date_range : null);
                    case 8:
                        setFgasCertModalOpen(false);
                        router.push(nextStep);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFgasConfirm(certificate) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (productsCount1 === 0) {
            setShowBasket1(false);
        }
    }, [
        productsCount1
    ]);
    (0,react.useEffect)(function() {
        var ref, ref84;
        if (displayFlexPrice && (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref84 = ref.items) === null || ref84 === void 0 ? void 0 : ref84.length) > 0) {
            var ref85, ref86;
            setNumberOfDaysLeftInCurrentSubscription(dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref85 = cart.item) === null || ref85 === void 0 ? void 0 : ref85.endLeasingDate, 'DD/MM/YYYY').diff(dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref86 = cart.item) === null || ref86 === void 0 ? void 0 : ref86.startLeasingDate, 'DD/MM/YYYY'), 'day'));
        }
    }, [
        cart
    ]);
    var isButtonDisabled = (0,react.useMemo)(function() {
        var ref, ref87;
        return (contract === null || contract === void 0 ? void 0 : contract.loading) || secondHandProductValidationText && secondHandProductValidationText.length > 0 && isSecondHand1 && !basketValidation || (user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.ordersCount) === 0 && (basket === null || basket === void 0 ? void 0 : (ref87 = basket.data) === null || ref87 === void 0 ? void 0 : ref87.minimum_cart_items) > productsCount1;
    }, [
        contract === null || contract === void 0 ? void 0 : contract.loading,
        secondHandProductValidationText,
        isSecondHand1,
        basketValidation,
        user === null || user === void 0 ? void 0 : (ref10 = user.user) === null || ref10 === void 0 ? void 0 : ref10.ordersCount,
        basket === null || basket === void 0 ? void 0 : (ref11 = basket.data) === null || ref11 === void 0 ? void 0 : ref11.minimum_cart_items,
        productsCount1, 
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "basket--".concat(isAbsolute ? 'cart' : 'funnel'),
                className: (0,clsx_m/* default */.Z)('basket', [
                    classes.root,
                    isFunnel && classes.fullHeight, 
                ]),
                children: [
                    isAbsolute && (productsCount1 === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTooltip, {
                        title: t('texts:basket:empty'),
                        placement: "bottom",
                        open: showTooltip,
                        enterDelay: 2000,
                        classes: {
                            tooltip: 'cart-tooltip'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.basketBtnTooltip,
                            onMouseEnter: function() {
                                return setShowTooltip(true);
                            },
                            onMouseLeave: function() {
                                return setShowTooltip(false);
                            },
                            role: "button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasketButton, {
                                isFunnel: isFunnel,
                                productsCount: productsCount1,
                                layoutStyle: layoutStyle,
                                toggleBasketDetails: toggleBasketDetails,
                                basketIcon: basketIcon,
                                showBasketWording: showBasketWording,
                                settings: settings
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BasketButton, {
                        isFunnel: isFunnel,
                        productsCount: productsCount1,
                        layoutStyle: layoutStyle,
                        toggleBasketDetails: toggleBasketDetails,
                        basketIcon: basketIcon,
                        showBasketWording: showBasketWording,
                        settings: settings
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrap/* default */.Z, {
                        condition: isAbsolute,
                        wrap: function(children) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                                        id: "cart-menu",
                                        open: isBasketOpen,
                                        onClose: handleClose,
                                        anchor: 'right',
                                        className: (0,clsx_m/* default */.Z)(drawerClasses.drawer),
                                        children: children
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Backdrop/* default */.Z, {
                                        className: classes.backdrop,
                                        open: isBasketOpen
                                    })
                                ]
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(isAbsolute ? drawerClasses.drawerLayout : classes.basket),
                            children: [
                                isAbsolute && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(drawerClasses.drawerHeader),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'h3',
                                            component: 'div',
                                            color: 'primary',
                                            className: "basket__popup__title",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: basket === null || basket === void 0 ? void 0 : (ref12 = basket.data) === null || ref12 === void 0 ? void 0 : ref12.popup_title,
                                                defaultText: t('texts:basket:drawer:title')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            size: 'small',
                                            color: 'default',
                                            disableRipple: true,
                                            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {}),
                                            onClick: function() {
                                                return handleClose();
                                            },
                                            className: drawerClasses.drawerClose,
                                            disableTouchRipple: true,
                                            disableElevation: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: basket === null || basket === void 0 ? void 0 : (ref13 = basket.data) === null || ref13 === void 0 ? void 0 : ref13.popup_close,
                                                defaultText: t('texts:basket:drawer:close')
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)('cart', isAbsolute && [
                                        drawerClasses.drawerContent,
                                        classes.basketBG
                                    ]),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)(isAbsolute && classes.basketContent, isSecondHand1 && !constants/* isSecondHandOnly */.G7 && !isAbsolute && classes.basketProductsFunnel),
                                        children: [
                                            errorStock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.row,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'caption',
                                                    color: 'error',
                                                    align: 'center',
                                                    gutterBottom: true,
                                                    children: t('texts:basket:error_stock')
                                                })
                                            }),
                                            hasTryOutError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.row,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'caption',
                                                    color: 'error',
                                                    align: 'center',
                                                    gutterBottom: true,
                                                    children: t('texts:basket:error_tryout')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.row,
                                                children: !constants/* isSubscription */.Nn && !constants/* isSecondHandOnly */.G7 && (rentAbleProducts1 === null || rentAbleProducts1 === void 0 ? void 0 : rentAbleProducts1.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: !isAbsolute ? "cart-shipping ".concat(classes.rowShipping) : 'cart-shipping cart-shipping--absolute',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingInfos/* default */.Z, {
                                                        startDate: start,
                                                        endDate: end,
                                                        deliverDuration: parameters === null || parameters === void 0 ? void 0 : (ref14 = parameters.items) === null || ref14 === void 0 ? void 0 : ref14.deliverDuration,
                                                        returnDuration: parameters === null || parameters === void 0 ? void 0 : (ref15 = parameters.items) === null || ref15 === void 0 ? void 0 : ref15.returnDuration,
                                                        loading: parameters === null || parameters === void 0 ? void 0 : parameters.loading,
                                                        isExpress: (cart === null || cart === void 0 ? void 0 : (ref16 = cart.item) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.shipments) === null || ref17 === void 0 ? void 0 : ref17.length) > 0 && ((ref19 = cart === null || cart === void 0 ? void 0 : (ref18 = cart.item) === null || ref18 === void 0 ? void 0 : ref18.shipments[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.method) === null || ref20 === void 0 ? void 0 : ref20.isExpress),
                                                        t: t,
                                                        text: basket === null || basket === void 0 ? void 0 : basket.data,
                                                        small: isAbsolute,
                                                        isEnableChooseStartingDate: isEnableChooseStartingDate
                                                    })
                                                })
                                            }),
                                            rentAbleProducts1.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)(classes.basketProducts, isAbsolute && classes.basketProductsCart, !isSecondHand1 && !isAbsolute && classes.basketProductsFunnel),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx_m/* default */.Z)('cart-list', classes.basketProductsList),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "h6",
                                                                    component: "div",
                                                                    className: (0,clsx_m/* default */.Z)('cart-count', classes.count),
                                                                    children: rentableProductsQuantity1 > 1 ? rentableProductsQuantity1 + ' ' + t('texts:basket:products') : rentableProductsQuantity1 + ' ' + t('texts:basket:product')
                                                                }),
                                                                rentAbleProducts1 === null || rentAbleProducts1 === void 0 ? void 0 : rentAbleProducts1.map(function(product) {
                                                                    var ref;
                                                                    var isAvailable = typeof errorArray.find(function(el) {
                                                                        return el.code === product.product.variants[0].code;
                                                                    }) !== 'undefined';
                                                                    var availability = (0,utils/* checkStockQuantity */.LY)(stock, product.product.variants[0], 'basket');
                                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketProductRow, {
                                                                        id: product.id,
                                                                        t: t,
                                                                        stock: stock,
                                                                        basket: basket,
                                                                        productCode: product.product.code,
                                                                        variant: product.product.variants[0],
                                                                        isTryOut: product.withTryingOn,
                                                                        isSki: product === null || product === void 0 ? void 0 : product.ski,
                                                                        dayRange: dayRange,
                                                                        name: product.product.name,
                                                                        photoThumb: product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.images[0],
                                                                        priceRental: product.total / 100,
                                                                        availability: availability,
                                                                        isAvailable: isAvailable,
                                                                        locked: locked,
                                                                        loading: cart.loading,
                                                                        hidePrice: hidePrice,
                                                                        showSizes: showSizes,
                                                                        settings: settings,
                                                                        productTaxons: product.product.taxons
                                                                    }, "product-".concat(product.id)));
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: !errorStock && !hasTryOutError && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                isCart && !constants/* isSubscription */.Nn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketTotalsDad, {
                                                                    t: t,
                                                                    cart: cart,
                                                                    basket: basket,
                                                                    dayRange: dayRange,
                                                                    settings: settings,
                                                                    mixedBasket: mixedBasket,
                                                                    user: user,
                                                                    showDetailsOnBuyAbleProducts: true,
                                                                    isSecondHand: isSecondHand1,
                                                                    parameters: parameters,
                                                                    funnel: funnel,
                                                                    deleteCoupon: deleteCoupon
                                                                }),
                                                                isCart && constants/* isSubscription */.Nn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketTotalsSub, {
                                                                    basket: basket,
                                                                    t: t,
                                                                    numberOfDaysLeftInCurrentSubscription: numberOfDaysLeftInCurrentSubscription,
                                                                    total: cart.item.totals.totalItemWithoutPromotion,
                                                                    settings: settings,
                                                                    isBuyAbleProducts: false,
                                                                    mixedBasket: mixedBasket,
                                                                    showDetailsOnBuyAbleProducts: true,
                                                                    user: user
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            (secondHandProductsList === null || secondHandProductsList === void 0 ? void 0 : secondHandProductsList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classes.basketProducts,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)('cart-list', classes.basketProductsList, isAbsolute && classes.basketProductsCart, isSecondHand1 && constants/* isSecondHandOnly */.G7 && !isAbsolute && classes.basketProductsFunnel),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "h6",
                                                                component: "div",
                                                                className: (0,clsx_m/* default */.Z)('cart-count', classes.count),
                                                                children: secondHandProductsQuantity1 > 1 ? secondHandProductsQuantity1 + ' ' + t('texts:basket:products') : secondHandProductsQuantity1 + ' ' + t('texts:basket:product')
                                                            }),
                                                            secondHandProductsList.map(function(product) {
                                                                var isAvailable = typeof errorArray.find(function(el) {
                                                                    return el.code === product.product.variants[0].code;
                                                                }) !== 'undefined';
                                                                // If quantity selector is enabled, group units by quality
                                                                if (settings === null || settings === void 0 ? void 0 : settings.second_hand_has_quantity_selector) {
                                                                    var unitsByQuality = product.units.reduce(function(acc, unit) {
                                                                        var quality = unit.productCondition;
                                                                        if (!acc[quality]) {
                                                                            acc[quality] = [];
                                                                        }
                                                                        acc[quality].push(unit);
                                                                        return acc;
                                                                    }, {});
                                                                    return Object.entries(unitsByQuality).map(function(param) {
                                                                        var _param = _slicedToArray(param, 2), quality = _param[0], units = _param[1];
                                                                        var ref;
                                                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketProductRow, {
                                                                            id: product.id,
                                                                            t: t,
                                                                            stock: stock,
                                                                            basket: basket,
                                                                            buyAble: true,
                                                                            isSki: product === null || product === void 0 ? void 0 : product.ski,
                                                                            productCode: product.product.code,
                                                                            variant: product.product.variants[0],
                                                                            isTryOut: product.withTryingOn,
                                                                            dayRange: dayRange,
                                                                            name: product.product.name,
                                                                            photoThumb: product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.images[0],
                                                                            isAvailable: isAvailable,
                                                                            locked: locked,
                                                                            loading: cart.loading,
                                                                            hidePrice: hidePrice,
                                                                            showSizes: showSizes,
                                                                            settings: settings,
                                                                            isSecondHand: isSecondHand1,
                                                                            units: units,
                                                                            takeback: takeback,
                                                                            takeBackStock: takeBackStock,
                                                                            productTaxons: product.product.taxons
                                                                        }, "product-".concat(product.id, "-").concat(quality)));
                                                                    });
                                                                }
                                                                // Default: render one row per unit (original behavior)
                                                                return product.units.map(function(unit) {
                                                                    var ref;
                                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketProductRow, {
                                                                        id: product.id,
                                                                        t: t,
                                                                        stock: stock,
                                                                        basket: basket,
                                                                        buyAble: true,
                                                                        isSki: product === null || product === void 0 ? void 0 : product.ski,
                                                                        productCode: product.product.code,
                                                                        variant: product.product.variants[0],
                                                                        isTryOut: product.withTryingOn,
                                                                        dayRange: dayRange,
                                                                        name: product.product.name,
                                                                        photoThumb: product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.images[0],
                                                                        isAvailable: isAvailable,
                                                                        locked: locked,
                                                                        loading: cart.loading,
                                                                        hidePrice: hidePrice,
                                                                        showSizes: showSizes,
                                                                        settings: settings,
                                                                        isSecondHand: isSecondHand1,
                                                                        unit: unit,
                                                                        takeback: takeback,
                                                                        productTaxons: product.product.taxons
                                                                    }, "product-".concat(product.id, "-").concat(unit.puid)));
                                                                });
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketTotalsSecondHand, {
                                                        t: t,
                                                        cart: cart,
                                                        basket: basket,
                                                        settings: settings,
                                                        user: user,
                                                        includeShipping: isEndFunnel,
                                                        deleteCoupon: deleteCoupon
                                                    })
                                                ]
                                            }),
                                            buyAbleProducts1.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classes.basketProducts,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)('cart-list', classes.basketProductsList),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "h6",
                                                                component: "div",
                                                                className: (0,clsx_m/* default */.Z)('cart-count', classes.count),
                                                                children: buyAbleProducts1.length === 0 ? 'panier vide' : buyableProductsQuantity1 > 1 ? buyableProductsQuantity1 + ' ' + t('texts:basket:products') : buyableProductsQuantity1 + ' ' + t('texts:basket:product')
                                                            }),
                                                            buyAbleProducts1 === null || buyAbleProducts1 === void 0 ? void 0 : buyAbleProducts1.map(function(product) {
                                                                var ref;
                                                                var isAvailable = typeof errorArray.find(function(el) {
                                                                    return el.code === product.product.variants[0].code;
                                                                }) !== 'undefined';
                                                                var availability = (0,utils/* checkStockQuantity */.LY)(stock, product.product.variants[0], 'basket');
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketProductRow, {
                                                                    id: product.id,
                                                                    t: t,
                                                                    stock: stock,
                                                                    basket: basket,
                                                                    buyAble: true,
                                                                    isSki: product === null || product === void 0 ? void 0 : product.ski,
                                                                    productCode: product.product.code,
                                                                    variant: product.product.variants[0],
                                                                    isTryOut: product.withTryingOn,
                                                                    dayRange: dayRange,
                                                                    name: product.product.name,
                                                                    photoThumb: product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.images[0],
                                                                    priceRental: product.total / 100,
                                                                    availability: availability,
                                                                    isAvailable: isAvailable,
                                                                    locked: locked,
                                                                    loading: cart.loading,
                                                                    hidePrice: hidePrice,
                                                                    showSizes: showSizes,
                                                                    settings: settings,
                                                                    productTaxons: product.product.taxons
                                                                }, "product-".concat(product.id)));
                                                            })
                                                        ]
                                                    }),
                                                    isCart && !constants/* isSubscription */.Nn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketTotalsDad, {
                                                        t: t,
                                                        cart: cart,
                                                        basket: basket,
                                                        dayRange: dayRange,
                                                        mixedBasket: mixedBasket,
                                                        isBuyAbleProducts: true,
                                                        showDetailsOnBuyAbleProducts: rentAbleProducts1.length === 0,
                                                        settings: settings,
                                                        user: user,
                                                        parameters: parameters,
                                                        funnel: funnel,
                                                        deleteCoupon: deleteCoupon
                                                    }),
                                                    isCart && constants/* isSubscription */.Nn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketTotalsSub, {
                                                        basket: basket,
                                                        t: t,
                                                        numberOfDaysLeftInCurrentSubscription: numberOfDaysLeftInCurrentSubscription,
                                                        total: cart.item.totals.totalItemWithoutPromotion,
                                                        settings: settings,
                                                        mixedBasket: mixedBasket,
                                                        isBuyAbleProducts: true,
                                                        showDetailsOnBuyAbleProducts: rentAbleProducts1.length === 0,
                                                        user: user
                                                    })
                                                ]
                                            }),
                                            (0,CMSText/* isPrismicText */.LT)(basket === null || basket === void 0 ? void 0 : (ref21 = basket.data) === null || ref21 === void 0 ? void 0 : ref21.link_to_product_card) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                component: 'div',
                                                className: (0,clsx_m/* default */.Z)(classes.basketLinkToProductCard, 'basket_link_to_product_card'),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    data: basket === null || basket === void 0 ? void 0 : (ref22 = basket.data) === null || ref22 === void 0 ? void 0 : ref22.link_to_product_card
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(isAbsolute && [
                                        drawerClasses.drawerFooter,
                                        classes.basketFooter
                                    ]),
                                    children: [
                                        isCart && !constants/* isSubscription */.Nn && !mixedBasket && rentAbleProducts1.length > 0 && !isFunnel && !isSecondHand1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketTotalsDad, {
                                            t: t,
                                            cart: cart,
                                            basket: basket,
                                            dayRange: dayRange,
                                            settings: settings,
                                            user: user,
                                            parameters: parameters,
                                            funnel: funnel,
                                            deleteCoupon: deleteCoupon
                                        }),
                                        isCart && constants/* isSubscription */.Nn && !mixedBasket && rentAbleProducts1.length > 0 && !isFunnel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_BasketTotalsSub, {
                                            basket: basket,
                                            t: t,
                                            numberOfDaysLeftInCurrentSubscription: numberOfDaysLeftInCurrentSubscription,
                                            total: cart.item.totals.totalItemWithoutPromotion,
                                            settings: settings,
                                            isBuyAbleProducts: false,
                                            user: user
                                        }),
                                        buyAbleProducts1.length > 0 && rentAbleProducts1.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.footerRow, isAbsolute && classes.basketTotalMixed),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: 'body1',
                                                    align: 'center',
                                                    className: classes.bold,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref23 = basket.data) === null || ref23 === void 0 ? void 0 : ref23.buytotal,
                                                            defaultText: t('texts:basket:buyTotal')
                                                        }),
                                                        "\xa0",
                                                        !isEndFunnel && !notDisplayWithoutShipping && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: classes.shipping,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: basket === null || basket === void 0 ? void 0 : (ref24 = basket.data) === null || ref24 === void 0 ? void 0 : ref24.without_shipping,
                                                                defaultText: t('texts:basket:withoutShipping')
                                                            })
                                                        })
                                                    ]
                                                }),
                                                !constants/* isSubscription */.Nn ? // Date to Date
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body1',
                                                    align: 'center',
                                                    className: (0,clsx_m/* default */.Z)(classes.bold, 'cart-total', 'cart-total--dad'),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                        amount: amountTotal,
                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                        showDayOrMonth: false,
                                                        displayFlexPrice: displayFlexPrice
                                                    })
                                                }) : // Subscription
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body1',
                                                        align: 'right',
                                                        className: classes.totalDetails,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: constants/* isFlex */.Lz ? cart.item.totals.total - cart.item.totals.totalWithoutBoughtProducts - (cart === null || cart === void 0 ? void 0 : (ref25 = cart.item) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.totals) === null || ref26 === void 0 ? void 0 : ref26.shipping) : isEndFunnel ? cart.item.totals.total : cart.item.totals.totalItemWithoutPromotion,
                                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                            showDayOrMonth: false,
                                                            buyAble: true,
                                                            displayFlexPrice: displayFlexPrice
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        buyAbleProducts1.length > 0 && rentAbleProducts1.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.footerRow, isAbsolute && classes.basketTotalMixed),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: 'body1',
                                                    align: 'center',
                                                    className: classes.bold,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref27 = basket.data) === null || ref27 === void 0 ? void 0 : ref27.total,
                                                            defaultText: t('texts:basket:total')
                                                        }),
                                                        "\xa0",
                                                        !isEndFunnel && !notDisplayWithoutShipping && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: classes.shipping,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: basket === null || basket === void 0 ? void 0 : (ref28 = basket.data) === null || ref28 === void 0 ? void 0 : ref28.without_shipping,
                                                                defaultText: t('texts:basket:withoutShipping')
                                                            })
                                                        })
                                                    ]
                                                }),
                                                !constants/* isSubscription */.Nn ? // Date to Date
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body1',
                                                    align: 'center',
                                                    className: classes.bold,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                        amount: amountTotal,
                                                        dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                        dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                        showDayOrMonth: false,
                                                        displayFlexPrice: displayFlexPrice
                                                    })
                                                }) : // Subscription
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: 'body1',
                                                        align: 'right',
                                                        className: classes.totalDetails,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                amount: constants/* isFlex */.Lz ? cart === null || cart === void 0 ? void 0 : (ref29 = cart.item) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.totals) === null || ref30 === void 0 ? void 0 : ref30.totalWithoutBoughtProducts : (cart === null || cart === void 0 ? void 0 : (ref31 = cart.item) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.totals) === null || ref32 === void 0 ? void 0 : ref32.itemsTotalWithCart) - (cart === null || cart === void 0 ? void 0 : (ref33 = cart.item) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.totals) === null || ref34 === void 0 ? void 0 : ref34.totalItemWithoutPromotion),
                                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                showDayOrMonth: true,
                                                                numberOfDays: numberOfDaysLeftInCurrentSubscription,
                                                                isShort: true,
                                                                displayFlexPrice: displayFlexPrice
                                                            }),
                                                            "\xa0+\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                amount: constants/* isFlex */.Lz ? cart.item.totals.total - cart.item.totals.totalWithoutBoughtProducts - (cart === null || cart === void 0 ? void 0 : (ref35 = cart.item) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.totals) === null || ref36 === void 0 ? void 0 : ref36.shipping) : isEndFunnel ? cart.item.totals.total : cart.item.totals.totalItemWithoutPromotion,
                                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                showDayOrMonth: false,
                                                                buyAble: true,
                                                                displayFlexPrice: displayFlexPrice
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        isSecondHand1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: (basket === null || basket === void 0 ? void 0 : (ref37 = basket.data) === null || ref37 === void 0 ? void 0 : ref37.enable_shipping) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: isEndFunnel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx_m/* default */.Z)(classes.row, isAbsolute && classes.basketTotalMixed),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: 'body2',
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                        asText: true,
                                                                        data: basket === null || basket === void 0 ? void 0 : (ref38 = basket.data) === null || ref38 === void 0 ? void 0 : ref38.shipping,
                                                                        defaultText: t('texts:basket:shipping')
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: classes.left,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        variant: 'body2',
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                            children: (cart === null || cart === void 0 ? void 0 : (ref39 = cart.item) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.totals) === null || ref40 === void 0 ? void 0 : ref40.shipping) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                                asText: true,
                                                                                data: basket === null || basket === void 0 ? void 0 : (ref41 = basket.data) === null || ref41 === void 0 ? void 0 : ref41.free,
                                                                                defaultText: t('texts:basket:free')
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                                amount: cart === null || cart === void 0 ? void 0 : (ref42 = cart.item) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.totals) === null || ref43 === void 0 ? void 0 : ref43.shipping,
                                                                                showDayOrMonth: false,
                                                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (0,clsx_m/* default */.Z)(classes.footerRow, isAbsolute && classes.basketTotalMixed),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: 'body1',
                                                            align: 'center',
                                                            className: classes.bold,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: basket === null || basket === void 0 ? void 0 : (ref44 = basket.data) === null || ref44 === void 0 ? void 0 : ref44.total,
                                                                    defaultText: t('texts:basket:total')
                                                                }),
                                                                "\xa0",
                                                                !isEndFunnel && !notDisplayWithoutShipping && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: classes.shipping,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                        asText: true,
                                                                        data: basket === null || basket === void 0 ? void 0 : (ref45 = basket.data) === null || ref45 === void 0 ? void 0 : ref45.without_shipping,
                                                                        defaultText: t('texts:basket:withoutShipping')
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'body1',
                                                            align: 'center',
                                                            className: classes.bold,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                amount: amountTotal,
                                                                dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                                                dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                                                                showDayOrMonth: false,
                                                                displayFlexPrice: displayFlexPrice
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        constants/* isSubscription */.Nn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.alignCenter, classes.rowFooterSub, 'cart-flexSub-text'),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                component: 'p',
                                                variant: "caption",
                                                className: classes.smallText,
                                                children: [
                                                    constants/* isFlex */.Lz && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: basket === null || basket === void 0 ? void 0 : (ref46 = basket.data) === null || ref46 === void 0 ? void 0 : ref46.engagement,
                                                                defaultText: t('texts:basket:engagement')
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: basket === null || basket === void 0 ? void 0 : (ref47 = basket.data) === null || ref47 === void 0 ? void 0 : ref47.debit,
                                                        defaultText: t('texts:basket:debit')
                                                    })
                                                ]
                                            })
                                        }),
                                        locked && nextStep && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                isSecondHand1 && (secondHandProductValidationText === null || secondHandProductValidationText === void 0 ? void 0 : secondHandProductValidationText.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.basketCheckboxValidation,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            edge: "start",
                                                            checked: basketValidation,
                                                            onChange: changeBasketValidation,
                                                            disableRipple: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'body2',
                                                            component: 'div',
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: secondHandProductValidationText
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.basketActions,
                                                    children: [
                                                        isAbsolute && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            color: 'default',
                                                            size: 'small',
                                                            disableRipple: true,
                                                            className: (0,clsx_m/* default */.Z)('cart-reset', classes.reset, 'basket__continue-shopping'),
                                                            onClick: handleClose,
                                                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: basket === null || basket === void 0 ? void 0 : basket.data.continue_shop,
                                                                defaultText: t('texts:basket:continue_shop')
                                                            })
                                                        }),
                                                        productsCount1 !== 0 && !errorStock && !hasTryOutError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: constants/* isClassicSub */.q5 && (promotions === null || promotions === void 0 ? void 0 : promotions.futurPrice) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                className: (0,clsx_m/* default */.Z)('cart-next', classes.next),
                                                                "data-testid": "continue",
                                                                variant: 'contained',
                                                                color: 'primary',
                                                                size: 'small',
                                                                disabled: true,
                                                                onClick: function() {
                                                                    return RedirectToFunnel();
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: basket.data.continue,
                                                                    defaultText: t('texts:basket:continue')
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                className: (0,clsx_m/* default */.Z)('cart-next', classes.next),
                                                                "data-testid": "continue",
                                                                variant: 'contained',
                                                                color: 'primary',
                                                                size: 'small',
                                                                disabled: isButtonDisabled,
                                                                onClick: handleContinue,
                                                                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: basket === null || basket === void 0 ? void 0 : (ref48 = basket.data) === null || ref48 === void 0 ? void 0 : ref48.continue,
                                                                    defaultText: t('texts:basket:continue')
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            disabled: true,
                                                            variant: "contained",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: basket.data.continue,
                                                                defaultText: t('texts:basket:continue')
                                                            })
                                                        })
                                                    ]
                                                }),
                                                productsCount1 > 0 && isAbsolute && enableEmptyCartButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,clsx_m/* default */.Z)(classes.basketActions, classes.basketActionsDelete),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        size: "small",
                                                        color: "inherit",
                                                        className: (0,clsx_m/* default */.Z)('cart-reset', classes.reset, classes.resetSmall),
                                                        onClick: emptyCart,
                                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightOff/* default */.Z, {}),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: basket === null || basket === void 0 ? void 0 : (ref49 = basket.data) === null || ref49 === void 0 ? void 0 : ref49.empty_cart_text,
                                                            defaultText: t('texts:basket:delete_basket')
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basket_FgasCertificateModal, {
                open: fgasCertModalOpen,
                onClose: function() {
                    return setFgasCertModalOpen(false);
                },
                onConfirm: handleFgasConfirm,
                basketData: basket === null || basket === void 0 ? void 0 : basket.data,
                userEmail: user === null || user === void 0 ? void 0 : (ref50 = user.user) === null || ref50 === void 0 ? void 0 : ref50.email
            })
        ]
    }));
};
/* harmony default export */ var Basket_Basket = ((0,es/* connect */.$j)(Basket_mapStateToProps, Basket_mapDispatchToProps)(Basket));


/***/ }),

/***/ 5512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ConditionalWrap = function(param) {
    var condition = param.condition, wrap = param.wrap, children = param.children;
    return condition ? wrap(children) : children;
};
/* harmony default export */ __webpack_exports__["Z"] = (ConditionalWrap);


/***/ }),

/***/ 84732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94455);




var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        downloadlink: {
            textDecoration: 'underline',
            texttransform: 'none',
            '&:hover, &:focus': {
                textDecoration: 'none'
            },
            cursor: 'pointer'
        }
    });
});
var DownloadLink = function(param) {
    var downloadLink = param.downloadLink, data = param.data, defaultText = param.defaultText;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        variant: 'h5',
        component: 'span',
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: downloadLink,
            target: 'blank',
            className: classes.downloadlink,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CMSText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                data: data,
                defaultText: defaultText
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DownloadLink);


/***/ }),

/***/ 29902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80366);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94455);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        modal: {
            borderRadius: 0,
            '& .MuiPaper-root': _defineProperty({
                borderRadius: 0
            }, theme.breakpoints.up('md'), {
                minWidth: 700
            })
        },
        modalHead: {
            padding: theme.spacing(2, 3),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: theme.extraColors.greyLight,
            borderBottom: "1px solid ".concat(theme.extraColors.grey)
        },
        modalTitle: {
            display: 'inline-flex',
            alignItems: 'center',
            fontWeight: 700,
            lineHeight: 1,
            '&>.MuiSvgIcon-root': {
                marginRight: theme.spacing(1)
            }
        },
        modalTitleWarning: {
            color: theme.palette.error.main
        },
        modalClose: {
            cursor: 'pointer',
            padding: theme.spacing(0.5),
            width: theme.spacing(4),
            height: theme.spacing(4),
            borderRadius: theme.spacing(2),
            textAlign: 'center',
            color: theme.extraColors.greyLight,
            background: theme.extraColors.grey,
            '&:hover, &:focus': {
                background: theme.palette.common.black
            }
        },
        modalContent: {
            padding: theme.spacing(3)
        }
    });
});
var GlobalModal = function(param) {
    var open = param.open, onClose = param.onClose, children = param.children, customClass = param.customClass, icon = param.icon, modalTitle = param.modalTitle, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(customClass, classes.modal),
        open: open,
        onClose: onClose,
        maxWidth: 'md',
        disableBackdropClick: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("".concat(customClass, "__head"), classes.modalHead),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: 'h2',
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("".concat(customClass, "__title"), classes.modalTitle, isWarning && "".concat(customClass, "__title--warning"), isWarning && classes.modalTitleWarning),
                        children: [
                            icon && icon,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CMSText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: modalTitle.data,
                                    defaultText: modalTitle.defaultText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("".concat(customClass, "__close"), classes.modalClose),
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("".concat(customClass, "__content"), classes.modalContent),
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (GlobalModal);


/***/ }),

/***/ 26137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58365);




var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var ImgKitHandler = function(param) {
    var classes = param.classes, imagePaths = param.imagePaths, alt = param.alt, onClickEvent = param.onClickEvent, settings = param.settings;
    var ref2, ref1;
    var imageHeight;
    switch(settings.ar){
        case '1-1':
            imageHeight = Math.round(settings.width * (1 / 1));
            break;
        case '3-4':
            imageHeight = Math.round(settings.width * (4 / 3));
            break;
        case '4-3':
            imageHeight = Math.round(settings.width * (3 / 4));
            break;
        case '16-9':
            imageHeight = Math.round(settings.width * (16 / 9));
            break;
        case '2-3':
            imageHeight = Math.round(settings.width * (3 / 2));
            break;
        case '9-16':
            imageHeight = Math.round(settings.width * (9 / 16));
            break;
        default:
            imageHeight = settings.width;
            break;
    }
    var imageKitLoader = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ref;
        var params = [
            "w-".concat(settings.width),
            "h-".concat(imageHeight)
        ];
        if (settings.ar) {
            params.push("ar-".concat(settings.ar));
        }
        if (settings.quality) {
            params.push("q-".concat(settings.quality));
        }
        var paramsString = params.join(',');
        var urlEndpoint = "https://ik.imagekit.io/lizee/rp-millet-production/";
        if (urlEndpoint[urlEndpoint.length - 1] === '/') urlEndpoint = urlEndpoint.substring(0, urlEndpoint.length - 1);
        // Interval variable for cache-busting version parameter (`v`),
        // updated every 4 hours to ensure periodic cache refresh.
        var fourHourInterval = Math.floor(Date.now() / (4 * 60 * 60 * 1000));
        var url = (imagePaths === null || imagePaths === void 0 ? void 0 : (ref = imagePaths.path) === null || ref === void 0 ? void 0 : ref.startsWith('http')) ? imagePaths === null || imagePaths === void 0 ? void 0 : imagePaths.path : "".concat(urlEndpoint, "/").concat(imagePaths === null || imagePaths === void 0 ? void 0 : imagePaths.path);
        return "".concat(url, "?tr=").concat(paramsString, "&v=").concat(fourHourInterval);
    }, [
        imagePaths,
        settings
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: typeof imagePaths === 'undefined' || _typeof(imagePaths.path) === undefined ? (settings === null || settings === void 0 ? void 0 : settings.defaultImage) && (settings === null || settings === void 0 ? void 0 : (ref2 = settings.defaultImage) === null || ref2 === void 0 ? void 0 : ref2.url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
            src: settings === null || settings === void 0 ? void 0 : (ref1 = settings.defaultImage) === null || ref1 === void 0 ? void 0 : ref1.url,
            className: classes,
            alt: alt,
            layout: "fill",
            loading: "lazy"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            variant: "rect",
            animation: false
        }) :  true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
            loader: imageKitLoader,
            src: (imagePaths === null || imagePaths === void 0 ? void 0 : imagePaths.path) ? imagePaths === null || imagePaths === void 0 ? void 0 : imagePaths.path : '/images/placeholder.jpg',
            className: classes,
            alt: alt,
            onClick: onClickEvent,
            layout: "fill",
            loading: "lazy"
        }) : /*#__PURE__*/ 0
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ImgKitHandler);


/***/ }),

/***/ 63052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29525);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80366);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var _material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(72063);
/* harmony import */ var _redux_actions_inStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7766);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36456);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94455);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        root: {
            '& .MuiDialog-paper': {
                borderRadius: theme.shape.borderRadius
            }
        },
        container: {},
        modalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: theme.extraColors.greyLight
        },
        cross: {
            cursor: 'pointer',
            height: 32,
            width: 32,
            padding: theme.spacing(0.5),
            color: theme.palette.common.white,
            backgroundColor: theme.extraColors.grey,
            borderRadius: '50%',
            margin: theme.spacing(1)
        },
        title: {
            padding: theme.spacing(1),
            margin: theme.spacing(1)
        },
        row: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: theme.spacing(1),
            gap: theme.spacing(1),
            '& .MuiTypography-root>.paragraph-class': {
                marginTop: 0,
                '&:last-child': {
                    marginBottom: 0
                }
            }
        },
        marginLeft: {
            marginLeft: theme.spacing(2)
        },
        warning: {},
        warningText: _defineProperty({}, theme.breakpoints.down('sm'), {
            fontSize: '80%'
        })
    });
});
var mapDispatchToProps = {
    deleteChosenStore: _redux_actions_inStore__WEBPACK_IMPORTED_MODULE_4__/* .deleteChosenStore */ .ZY
};
var mapStateToProps = function() {
    return {};
};
var ChangeStoreModal = function(param) {
    var open = param.open, handleClose = param.handleClose, deleteChosenStore1 = param.deleteChosenStore, doc = param.doc, t = param.t;
    var ref, ref1, ref2, ref3;
    var classes = useStyles();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var closeModalAndDeleteStore = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        // close modale, delete store, delete cart
                        handleClose();
                        _ctx.next = 3;
                        return localStorage.removeItem('selectedStore');
                    case 3:
                        _ctx.next = 5;
                        return deleteChosenStore1(router.asPath);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function closeModalAndDeleteStore() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            open: open,
            onClose: handleClose,
            maxWidth: 'sm',
            className: classes.root,
            scroll: 'paper',
            disableBackdropClick: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: classes.container,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "".concat(classes.modalHeader),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                variant: "h5",
                                component: "h2",
                                className: "".concat(classes.title),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.change_store_title,
                                    defaultText: t('texts:instore:change_store_title')
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                className: classes.cross,
                                onClick: handleClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        dividers: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.row, classes.warning),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        color: 'error'
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.row, classes.warningText),
                                        component: 'div',
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                            data: doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.change_store_paragraph,
                                            defaultText: t('texts:instore:change_store_paragraph')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: classes.row,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        onClick: handleClose,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                            asText: true,
                                            data: doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.cancel_button,
                                            defaultText: t('texts:instore:cancel_button')
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        variant: 'contained',
                                        color: 'secondary',
                                        className: classes.marginLeft,
                                        onClick: closeModalAndDeleteStore,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                            asText: true,
                                            data: doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.change_store_button,
                                            defaultText: t('texts:instore:change_store_button')
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(ChangeStoreModal));


/***/ }),

/***/ 15787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75154);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        drawer: _defineProperty({}, theme.breakpoints.down('md'), {
            '& .MuiPaper-root': {
                width: '100%'
            }
        }),
        drawerLayout: _defineProperty({
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%'
        }, theme.breakpoints.up('lg'), {
            width: theme.sizes.basketWidthLG
        }),
        drawerHeader: _defineProperty({
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: theme.spacing(1, 1, 1, 2),
            position: 'absolute',
            zIndex: theme.zIndex.appBar,
            top: 0,
            left: 0,
            right: 0,
            height: theme.sizes.headerHeight,
            background: theme.palette.common.white
        }, theme.breakpoints.down('md'), {
            position: 'fixed'
        }),
        drawerClose: {
            '&:hover, &:focus': {
                background: 'none'
            }
        },
        drawerContent: {
            flexGrow: 1,
            marginTop: theme.sizes.headerHeight
        },
        drawerFooter: {
            position: 'sticky',
            bottom: 0,
            boxShadow: theme.shadows[1]
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useStyles);


/***/ }),

/***/ 49841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(52795);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Drawer/Drawer.js
var Drawer = __webpack_require__(39636);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Menu.js
var Menu = __webpack_require__(48884);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/HelpOutline.js
var HelpOutline = __webpack_require__(82369);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AccountCircle.js
var AccountCircle = __webpack_require__(82067);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Room.js
var Room = __webpack_require__(53624);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./components/InStore/ChangeStoreModal.tsx
var ChangeStoreModal = __webpack_require__(63052);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slide/Slide.js
var Slide = __webpack_require__(82285);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(55953);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button_Button = __webpack_require__(282);
;// CONCATENATED MODULE: ./components/Layout/TaxonsMenu.tsx








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        menuItemRelative: {
            position: 'relative'
        },
        submenuAbsolute: {
            position: 'absolute',
            left: 0,
            top: '100%',
            zIndex: 10,
            minWidth: 'max-content',
            background: '#fff',
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
            padding: theme.spacing(2, 2, 2, 2),
            borderRadius: 8,
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1)
        },
        rowItem: {
            padding: theme.spacing(0.5, 0),
            lineHeight: 1.7,
            fontSize: 15
        },
        columnHeader: {
            fontWeight: 800,
            marginBottom: theme.spacing(1),
            fontSize: 16
        },
        subMenuItem: {
            listStyle: 'none',
            margin: '0.7rem 0',
            '&:hover': {
                textDecoration: 'underline'
            }
        },
        subMenuLink: {
            color: theme.palette.common.black,
            '&:hover, &:focus': {
                color: theme.palette.primary.main,
                textDecoration: 'underline'
            }
        },
        menuLink: {
            fontWeight: 1000,
            '&:hover, &:focus': {
                textDecoration: 'underline'
            }
        }
    });
});
var TaxonsMenu = function(param) {
    var origin = param.origin, isMobile = param.isMobile, LayoutStyle = param.LayoutStyle;
    var classes = menuUseStyles(LayoutStyle);
    var local = useStyles();
    var taxons = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref4;
        return ((ref = state.taxons.items) === null || ref === void 0 ? void 0 : (ref4 = ref[0]) === null || ref4 === void 0 ? void 0 : ref4.children) || [];
    });
    // Desktop submenu open/close state
    var ref5 = (0,react.useState)(null), subMenuOpen = ref5[0], setSubMenuOpen = ref5[1];
    var ref1 = (0,react.useState)(false), subMenuStyle = ref1[0], setSubMenuStyle = ref1[1];
    // Mobile navigation state
    var ref2 = (0,react.useState)([
        taxons
    ]), mobileStack = ref2[0], setMobileStack = ref2[1];
    var ref3 = (0,react.useState)([]), mobilePath = ref3[0], setMobilePath = ref3[1];
    var buildLink = function(slugs) {
        return "".concat(origin, "/").concat(slugs.join('/'));
    };
    // Desktop: handle submenu open/close
    var handleSubMenu = function(idx) {
        setSubMenuOpen(idx);
        setTimeout(function() {
            setSubMenuStyle(true);
        }, 300);
    };
    var handleCloseSubMenu = function() {
        setSubMenuOpen(null);
        setSubMenuStyle(false);
    };
    // Mobile: handle navigation
    var handleMobileNext = function(taxon) {
        if (taxon.children && taxon.children.length > 0) {
            setMobileStack(_toConsumableArray(mobileStack).concat([
                taxon.children
            ]));
            setMobilePath(_toConsumableArray(mobilePath).concat([
                taxon
            ]));
        }
    };
    var handleMobileBack = function() {
        if (mobileStack.length > 1) {
            setMobileStack(mobileStack.slice(0, -1));
            setMobilePath(mobilePath.slice(0, -1));
        }
    };
    // Utility function to check if all children have no children
    var allChildrenAreLeaf = function(children) {
        return children.every(function(c) {
            return !c.children || c.children.length === 0;
        });
    };
    // --- Desktop Render ---
    if (!isMobile) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            className: (0,clsx_m/* default */.Z)(classes.menuRoot, 'menu'),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (0,clsx_m/* default */.Z)(classes.menuList, 'menu__list'),
                children: taxons.map(function(level0, idx0) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                        className: (0,clsx_m/* default */.Z)(classes.menuItem, 'menu__item', local.menuItemRelative),
                        onMouseEnter: function() {
                            return handleSubMenu(idx0);
                        },
                        onMouseLeave: handleCloseSubMenu,
                        onFocus: function() {
                            return handleSubMenu(idx0);
                        },
                        onBlur: handleCloseSubMenu,
                        tabIndex: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: buildLink([
                                    level0.slug
                                ]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (0,clsx_m/* default */.Z)(classes.menuLink, 'menu__link'),
                                    children: level0.name
                                })
                            }),
                            subMenuOpen === idx0 && level0.children && level0.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.submenu, 'menu__submenu', local.submenuAbsolute, subMenuOpen === idx0 && subMenuStyle && classes.subMenuOpen),
                                children: allChildrenAreLeaf(level0.children) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    style: {
                                        margin: 0,
                                        padding: 0
                                    },
                                    children: level0.children.map(function(level1) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            className: classes.subMenuItem,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: buildLink([
                                                    level0.slug,
                                                    level1.slug
                                                ]),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: classes.subMenuLink,
                                                    children: level1.name
                                                })
                                            })
                                        }, level1.code);
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                                    elevation: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        container: true,
                                        spacing: 2,
                                        className: classes.tableGrid,
                                        children: level0.children.map(function(level1) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                item: true,
                                                xs: 12 / (level0.children.length || 1),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        className: (0,clsx_m/* default */.Z)(classes.columnHeader, local.menuLink),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: buildLink([
                                                                level0.slug,
                                                                level1.slug
                                                            ]),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: (0,clsx_m/* default */.Z)(classes.menuLink, 'menu__link'),
                                                                children: level1.name
                                                            })
                                                        })
                                                    }),
                                                    level1.children && level1.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: level1.children.map(function(level2) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                                className: classes.rowItem,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                    href: buildLink([
                                                                        level0.slug,
                                                                        level1.slug,
                                                                        level2.slug, 
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        className: (0,clsx_m/* default */.Z)(classes.menuLink, local.menuLink, 'menu__link'),
                                                                        style: {
                                                                            fontWeight: 400
                                                                        },
                                                                        children: level2.name
                                                                    })
                                                                })
                                                            }, level2.code);
                                                        })
                                                    })
                                                ]
                                            }, level1.code);
                                        })
                                    })
                                })
                            })
                        ]
                    }, level0.code);
                })
            })
        }));
    }
    // --- Mobile Render ---
    var currentLevel = mobileStack[mobileStack.length - 1];
    var parentTaxon = mobilePath[mobilePath.length - 1];
    var parentSlugs = mobilePath.map(function(t) {
        return t.slug;
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(classes.rootMobile, 'menu', 'menu--mobile'),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
                in: mobileStack.length > 1,
                direction: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: mobileStack.length === 1 ? classes.hide : undefined,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.subMenuMobile,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)(classes.subMenuMobileBack, 'menu-mobile__back'),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        size: "small",
                                        onClick: handleMobileBack,
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                        className: classes.subMenuMobileBackBtn,
                                        fullWidth: true,
                                        disableRipple: true,
                                        disableTouchRipple: true,
                                        disableElevation: true,
                                        children: parentTaxon ? parentTaxon.name : ''
                                    })
                                }),
                                currentLevel.map(function(taxon, idx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)(classes.menuMobileItem, 'menu-mobile__item'),
                                        onClick: function() {
                                            return taxon.children && taxon.children.length > 0 && handleMobileNext(taxon);
                                        },
                                        children: taxon.children && taxon.children.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (0,clsx_m/* default */.Z)(classes.menuMobileLink, 'menu__link'),
                                                    children: taxon.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: buildLink(_toConsumableArray(parentSlugs).concat([
                                                taxon.slug
                                            ])),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (0,clsx_m/* default */.Z)(classes.menuMobileLink, 'menu__link'),
                                                children: taxon.name
                                            })
                                        })
                                    }, taxon.code);
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: mobileStack.length > 1 ? classes.hide : undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)('menu__list', 'menu__list--mobile'),
                    children: currentLevel.map(function(taxon, idx) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)(classes.menuMobileItem, 'menu-mobile__item'),
                            onClick: function() {
                                return handleMobileNext(taxon);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,clsx_m/* default */.Z)(classes.menuMobileLink, 'menu__link'),
                                    children: taxon.name
                                }),
                                taxon.children && taxon.children.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: buildLink(_toConsumableArray(parentSlugs).concat([
                                        taxon.slug
                                    ])),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (0,clsx_m/* default */.Z)(classes.menuMobileLink, 'menu__link'),
                                        children: taxon.name
                                    })
                                })
                            ]
                        }, taxon.code);
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Layout_TaxonsMenu = (TaxonsMenu);

;// CONCATENATED MODULE: ./components/Layout/Menu.tsx









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var menuUseStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        root: {},
        rootMobile: {
            borderTop: "1px solid ".concat(theme.extraColors.grey)
        },
        hide: {
            height: 0,
            opacity: 0,
            width: 0,
            overflow: 'hidden'
        },
        menuList: _defineProperty({
            margin: 0,
            padding: 0,
            listStyle: 'none',
            color: 'currentColor'
        }, theme.breakpoints.up('lg'), {
            display: 'flex',
            gap: theme.spacing(1)
        }),
        menuListMobileSecondary: {
            padding: theme.spacing(1),
            backgroundColor: theme.extraColors.greyLight
        },
        menuItem: (_obj = {
            position: 'relative',
            display: 'inline-block',
            lineHeight: 1.2,
            fontSize: theme.typography.caption.fontSize,
            textAlign: 'left',
            color: 'currentColor'
        }, _defineProperty(_obj, theme.breakpoints.up('lg'), {
            '&:not(:last-child)': {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(1),
                '&:after': {
                    content: '"|"'
                }
            }
        }), _defineProperty(_obj, '&:hover, &:focus', {
            '& .menu__submenu': {
                display: 'block'
            }
        }), _obj),
        menuLink: {
            color: function(LayoutStyle) {
                return !LayoutStyle.isTransparent ? LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black : theme.palette.common.white;
            },
            '&:hover, &:focus': {
                color: function(LayoutStyle) {
                    return !LayoutStyle.isTransparent ? LayoutStyle.hover ? LayoutStyle.hover.color : theme.palette.common.black : theme.palette.common.white;
                }
            }
        },
        subMenu: {
            position: 'absolute',
            display: 'none',
            minWidth: 200,
            textAlign: 'left',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: function(LayoutStyle) {
                return LayoutStyle.submenuBackgroundColor || theme.palette.common.white;
            },
            boxShadow: theme.shadows[1]
        },
        subMenuItem: {
            listStyle: 'none',
            margin: '0.7rem 0',
            '&:hover': {
                textDecoration: 'underline'
            }
        },
        subMenuLink: {
            color: function(LayoutStyle) {
                return LayoutStyle.submenuTextColor || theme.palette.common.black;
            },
            '&:hover, &:focus': {
                color: function(LayoutStyle) {
                    return LayoutStyle.hover ? LayoutStyle.hover.color : theme.palette.common.black;
                }
            }
        },
        menuMobileItem: {
            cursor: 'pointer',
            padding: 0,
            color: function(LayoutStyle) {
                return LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black;
            },
            backgroundColor: theme.palette.common.white,
            justifyContent: 'space-between',
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight),
            '&:active': {
                backgroundColor: theme.extraColors.greyLight
            }
        },
        menuMobileItemSecondary: {
            fontSize: theme.typography.caption.fontSize,
            color: theme.extraColors.greyText
        },
        menuMobileLink: {
            flex: 1,
            padding: theme.spacing(1, 2),
            color: function(LayoutStyle) {
                return LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black;
            }
        },
        subMenuMobile: {
            '& .MuiList-root': {
                padding: 0
            }
        },
        subMenuMobileFixed: {
            position: 'relative',
            '& .MuiList-root': {
                paddingTop: theme.sizes.headerHeight / 2,
                paddingBottom: 0
            }
        },
        subMenuMobileBack: {
            display: 'flex',
            alignItems: 'center',
            height: theme.sizes.headerHeight / 2,
            padding: 0,
            backgroundColor: theme.extraColors.grey
        },
        subMenuMobileBackFixed: {
            position: 'fixed',
            zIndex: 1,
            top: theme.sizes.headerHeight,
            left: 0,
            right: 0
        },
        subMenuMobileBackBtn: {
            justifyContent: 'flex-start',
            height: '100%',
            borderRadius: 0
        }
    });
});
var Menu_Menu = function(param) {
    var general = param.general, t = param.t, type = param.type, isMobile = param.isMobile, LayoutStyle = param.LayoutStyle;
    var ref9, ref1;
    if ((general === null || general === void 0 ? void 0 : (ref9 = general.data) === null || ref9 === void 0 ? void 0 : ref9.build_menu_from_taxons) && window !== undefined) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_TaxonsMenu, {
            isMobile: isMobile,
            origin: window.location.origin,
            LayoutStyle: LayoutStyle
        }));
    }
    var classes = menuUseStyles(LayoutStyle);
    var slices = general === null || general === void 0 ? void 0 : (ref1 = general.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var mainMenu = type === 'primary' ? slices === null || slices === void 0 ? void 0 : slices.filter(function(slice) {
        return slice.slice_type === 'main_menu_item';
    }) : slices === null || slices === void 0 ? void 0 : slices.filter(function(slice) {
        return slice.slice_type === 'secondary_menu_item';
    });
    var ref2 = (0,react.useState)(null), subMenuParent = ref2[0], setSubMenuParent = ref2[1];
    var ref3 = (0,react.useState)([]), subMenu = ref3[0], setSubMenu = ref3[1];
    var ref4 = (0,react.useState)(false), subMenuOpen = ref4[0], setSubMenuOpen = ref4[1];
    var ref5 = (0,react.useState)(false), subMenuStyle = ref5[0], setSubMenuStyle = ref5[1];
    var handleSubMenu = function(parent, data) {
        setSubMenuParent(parent);
        setSubMenu(data);
        setSubMenuOpen(true);
        setTimeout(function() {
            setSubMenuStyle(true);
        }, 300);
    };
    var handleBack = function() {
        setSubMenu([]);
        setSubMenuOpen(false);
        setSubMenuStyle(false);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, "menu", "menu--".concat(type), isMobile && [
            classes.rootMobile,
            "menu--mobile",
            "menu--".concat(type),
            "menu--mobile--".concat(type), 
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(subMenuOpen && classes.hide),
                children: (mainMenu === null || mainMenu === void 0 ? void 0 : mainMenu.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (0,clsx_m/* default */.Z)(classes.menuList, 'menu__list', "menu__list--".concat(type), isMobile && "menu__list--mobile", isMobile && type === 'secondary' && [
                            classes.menuListMobileSecondary
                        ]),
                        children: mainMenu === null || mainMenu === void 0 ? void 0 : mainMenu.map(function(item, index) {
                            var ref, ref6, ref7, ref8;
                            var navLinkLabel = item === null || item === void 0 ? void 0 : (ref = item.primary) === null || ref === void 0 ? void 0 : ref['nav_link_label'];
                            var navLink = item === null || item === void 0 ? void 0 : (ref6 = item.primary) === null || ref6 === void 0 ? void 0 : ref6['nav_link'];
                            return (navLinkLabel === null || navLinkLabel === void 0 ? void 0 : navLinkLabel.length) > 0 && (navLink === null || navLink === void 0 ? void 0 : navLink.link_type) !== 'Any' && (isMobile ? ((ref7 = item.items) === null || ref7 === void 0 ? void 0 : ref7.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                onClick: function() {
                                    return handleSubMenu(navLinkLabel, item.items);
                                },
                                className: (0,clsx_m/* default */.Z)('menu-mobile__item', "menu-mobile__item--".concat(type), classes.menuMobileItem),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classes.menuMobileLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: navLinkLabel,
                                            defaultText: t('texts:general:main_menu:item')
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
                                ]
                            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)(classes.menuMobileItem, 'menu-mobile__item', "menu-mobile__item--".concat(type), type === 'secondary' && classes.menuMobileItemSecondary),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: navLink.url,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: classes.menuMobileLink,
                                        target: (navLink === null || navLink === void 0 ? void 0 : navLink.target) === '_blank' ? '_blank' : '_self',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: navLinkLabel,
                                            defaultText: t('texts:general:main_menu:item')
                                        })
                                    })
                                })
                            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.menuItem, 'menu__item'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: navLink.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (0,clsx_m/* default */.Z)(classes.menuLink, 'menu__link'),
                                                target: (navLink === null || navLink === void 0 ? void 0 : navLink.target) === '_blank' ? '_blank' : '_self',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: navLinkLabel,
                                                    defaultText: t('texts:general:main_menu:item')
                                                })
                                            })
                                        }),
                                        ((ref8 = item.items) === null || ref8 === void 0 ? void 0 : ref8.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.subMenu, 'menu__submenu'),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: item.items.map(function(subItem, subIndex) {
                                                    var subNavLinkLabel = subItem === null || subItem === void 0 ? void 0 : subItem['sub_nav_link_label'];
                                                    var subNavLink = subItem === null || subItem === void 0 ? void 0 : subItem['sub_nav_link'];
                                                    return (subNavLinkLabel === null || subNavLinkLabel === void 0 ? void 0 : subNavLinkLabel.length) > 0 && (subNavLink === null || subNavLink === void 0 ? void 0 : subNavLink.link_type) !== 'Any' && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: classes.subMenuItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: subNavLink === null || subNavLink === void 0 ? void 0 : subNavLink.url,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: (subNavLink === null || subNavLink === void 0 ? void 0 : subNavLink.target) === '_blank' ? '_blank' : '_self',
                                                                className: classes.subMenuLink,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: subNavLinkLabel,
                                                                    defaultText: t('texts:general:main_menu:item')
                                                                })
                                                            })
                                                        })
                                                    }, subIndex);
                                                })
                                            })
                                        })
                                    ]
                                }, index)
                            }, index));
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
                in: subMenuOpen,
                direction: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)(!subMenuOpen && classes.hide),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(classes.subMenuMobile, subMenuStyle && classes.subMenuMobileFixed),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)('menu-mobile__back', classes.subMenuMobileBack, subMenuStyle && classes.subMenuMobileBackFixed),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "small",
                                        onClick: function() {
                                            return handleBack();
                                        },
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                        className: classes.subMenuMobileBackBtn,
                                        fullWidth: true,
                                        disableRipple: true,
                                        disableTouchRipple: true,
                                        disableElevation: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: subMenuParent,
                                            defaultText: t('texts:general:main_menu:item')
                                        })
                                    })
                                }),
                                subMenu.map(function(item, index) {
                                    var subNavLinkLabel = item === null || item === void 0 ? void 0 : item['sub_nav_link_label'];
                                    var subNavLink = item === null || item === void 0 ? void 0 : item['sub_nav_link'];
                                    return (subNavLinkLabel === null || subNavLinkLabel === void 0 ? void 0 : subNavLinkLabel.length) > 0 && (subNavLink === null || subNavLink === void 0 ? void 0 : subNavLink.link_type) !== 'Any' && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                                        className: classes.menuMobileItem,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: subNavLink === null || subNavLink === void 0 ? void 0 : subNavLink.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: (subNavLink === null || subNavLink === void 0 ? void 0 : subNavLink.target) === '_blank' ? '_blank' : '_self',
                                                onClick: function() {
                                                    return setSubMenu([]);
                                                },
                                                className: classes.menuMobileLink,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: subNavLinkLabel,
                                                    defaultText: t('texts:general:main_menu:item')
                                                })
                                            })
                                        })
                                    }, index);
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Layout_Menu = (Menu_Menu);

// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./components/Basket/Basket.tsx + 10 modules
var Basket = __webpack_require__(41097);
// EXTERNAL MODULE: ./components/Layout/Drawer.style.tsx
var Drawer_style = __webpack_require__(15787);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(29525);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Error.js
var Error = __webpack_require__(72063);
;// CONCATENATED MODULE: ./components/Global/ChangeLanguageModal.tsx











function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ChangeLanguageModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ChangeLanguageModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            '& .MuiDialog-paper': {
                borderRadius: theme.shape.borderRadius
            }
        },
        container: {},
        modalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: theme.extraColors.greyLight
        },
        cross: {
            cursor: 'pointer',
            height: 32,
            width: 32,
            padding: theme.spacing(0.5),
            color: theme.palette.common.white,
            backgroundColor: theme.extraColors.grey,
            borderRadius: '50%',
            margin: theme.spacing(1)
        },
        title: {
            padding: theme.spacing(1),
            margin: theme.spacing(1)
        },
        row: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: theme.spacing(1),
            gap: theme.spacing(1),
            '& .MuiTypography-root>.paragraph-class': {
                marginTop: 0,
                '&:last-child': {
                    marginBottom: 0
                }
            }
        },
        warning: {},
        warningText: ChangeLanguageModal_defineProperty({}, theme.breakpoints.down('sm'), {
            fontSize: '80%'
        })
    });
});
var ChangeLanguageModal = function(param) {
    var lang1 = param.lang, pathname = param.pathname, query = param.query, open = param.open, handleClose = param.handleClose, doc = param.doc, t = param.t;
    var ref, ref1, ref2, ref3;
    var classes = ChangeLanguageModal_useStyles();
    var router = (0,next_router.useRouter)();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var trackLangChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(lang) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        trackEvent({
                            category: 'Header',
                            href: '/account',
                            action: "Change in ".concat(lang.toUpperCase().substring(0, 2))
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function trackLangChange(lang) {
            return _ref.apply(this, arguments);
        };
    }();
    var closeLanguageModalAndChangeLanguage = function() {
        router.push({
            pathname: pathname,
            query: query
        }, {
            pathname: pathname
        }, {
            locale: lang1
        });
        handleClose();
        trackLangChange(lang1);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: open,
        onClose: handleClose,
        maxWidth: 'sm',
        className: classes.root,
        scroll: 'paper',
        disableBackdropClick: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(classes.modalHeader),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            component: "h2",
                            className: "".concat(classes.title),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.change_language_modal_title,
                                defaultText: t('texts:general:change_language_modal_title')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            className: classes.cross,
                            onClick: handleClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                    dividers: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.row, classes.warning),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                                    color: "secondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)(classes.row, classes.warningText),
                                    component: 'div',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.change_language_modal_text,
                                        defaultText: t('texts:general:change_language_modal_text')
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.row,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: handleClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.change_language_modal_cancel_text,
                                        defaultText: t('texts:general:change_language_modal_cancel_text')
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: 'contained',
                                    color: 'secondary',
                                    onClick: closeLanguageModalAndChangeLanguage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.change_language_modal_validation_text,
                                        defaultText: t('texts:general:change_language_modal_validation_text')
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Global_ChangeLanguageModal = (ChangeLanguageModal);

// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 2 modules
var react_svg_esm = __webpack_require__(52933);
// EXTERNAL MODULE: ./utils/proxySvgUrl.ts
var proxySvgUrl = __webpack_require__(43359);
// EXTERNAL MODULE: ./components/Banner/Banner.tsx
var Banner = __webpack_require__(28565);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Close.js
var esm_Close = __webpack_require__(59544);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Search.js
var Search = __webpack_require__(17215);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
;// CONCATENATED MODULE: ./components/Button/InputButton.tsx











function InputButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            InputButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var InputButton_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var color = function(LayoutStyle) {
        return !LayoutStyle.isTransparent && (LayoutStyle.backgroundColor && LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black);
    };
    return (0,createStyles/* default */.Z)({
        button: {
            fontWeight: theme.typography.body2.fontWeight,
            color: color,
            borderColor: color
        },
        transparentButton: {
            color: theme.palette.common.white,
            borderColor: theme.palette.common.white
        },
        btnIcon: {
            padding: 0,
            marginLeft: theme.spacing(1),
            '&:hover': {
                backgroundColor: 'transparent'
            },
            '& .search__button__icon': {
                color: color,
                opacity: 1
            }
        },
        btnIconSvg: {
            display: 'block',
            maxWidth: '100%',
            height: 'auto',
            color: color,
            opacity: function(LayoutStyle) {
                return LayoutStyle.isTransparent ? 1 : 0.5;
            },
            lineHeight: 1,
            '& .injected-svg': {
                display: 'inline-block',
                width: '1em',
                height: '1em',
                fontSize: '1.5rem',
                transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                flexShrink: 0,
                userSelect: 'none'
            }
        }
    });
});
var InputButton = function(_param) {
    var _iconOnly = _param.iconOnly, iconOnly = _iconOnly === void 0 ? false : _iconOnly, iconUrl = _param.iconUrl, label = _param.label, _transparentBackground = _param.transparentBackground, transparentBackground = _transparentBackground === void 0 ? false : _transparentBackground, onClick = _param.onClick, isMobile = _param.isMobile, LayoutStyle = _param.LayoutStyle, props = _objectWithoutProperties(_param, [
        "iconOnly",
        "iconUrl",
        "label",
        "transparentBackground",
        "onClick",
        "isMobile",
        "LayoutStyle"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = InputButton_useStyles(LayoutStyle);
    var isIconUrlDefined = iconUrl && (iconUrl === null || iconUrl === void 0 ? void 0 : iconUrl.length) > 0 && new URL(iconUrl).pathname.split('.').pop() === 'svg';
    var Icon = function() {
        return isIconUrlDefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
            src: (0,proxySvgUrl/* proxySvgUrl */.u)(iconUrl),
            className: (0,clsx_m/* default */.Z)('search__button__icon', 'search__button__icon--svg', classes.btnIconSvg),
            wrapper: "span"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {});
    };
    if (iconOnly || isMobile) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, _objectSpread({}, props, {
            className: (0,clsx_m/* default */.Z)('search__button__icon__only', [
                classes.btnIcon,
                transparentBackground && 'search__button__icon__only__transparent', 
            ]),
            disableRipple: true,
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
        })));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        size: "small",
        variant: 'outlined',
        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
        className: (0,clsx_m/* default */.Z)('search__button__icon', [
            transparentBackground && 'search__button__icon__transparent',
            transparentBackground && classes.transparentButton,
            classes.button, 
        ]),
        disableRipple: true,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                asText: true,
                data: label,
                defaultText: t('texts:general.search_bar.button_label')
            })
        })
    }));
};
/* harmony default export */ var Button_InputButton = (InputButton);

// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog_Dialog = __webpack_require__(50657);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var icons_material_Close = __webpack_require__(50594);
;// CONCATENATED MODULE: ./components/Dialog/DialogFullscreen.tsx






function DialogFullscreen_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var DialogFullscreen_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        dialogHeader: {
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            paddingRight: 20,
            paddingTop: 10
        },
        dialogContent: (_obj = {
            display: 'flex',
            paddingTop: 100
        }, DialogFullscreen_defineProperty(_obj, theme.breakpoints.down('sm'), {
            paddingTop: 10
        }), DialogFullscreen_defineProperty(_obj, "justifyContent", 'center'), DialogFullscreen_defineProperty(_obj, "height", '100%'), _obj)
    });
});
var FullScreenDialog = function(param) {
    var open = param.open, setOpen = param.setOpen, children = param.children;
    var classes = DialogFullscreen_useStyles();
    var handleClose = function() {
        setOpen(false);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog_Dialog/* default */.Z, {
        fullScreen: true,
        open: open,
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.dialogHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    edge: "end",
                    color: "inherit",
                    onClick: handleClose,
                    "aria-label": "close",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_material_Close/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.dialogContent,
                children: children
            })
        ]
    }));
};
/* harmony default export */ var DialogFullscreen = (FullScreenDialog);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputBase/InputBase.js + 1 modules
var InputBase = __webpack_require__(15575);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Cancel.js
var Cancel = __webpack_require__(24673);
;// CONCATENATED MODULE: ./components/Input/SearchInput.tsx










function SearchInput_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SearchInput_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: SearchInput_defineProperty({
            display: 'flex',
            minWidth: 568
        }, theme.breakpoints.down('sm'), {
            minWidth: '100%',
            padding: '0 20px'
        }),
        rootInline: {
            minWidth: 'unset',
            width: '100%',
            padding: 0
        },
        imageSection: SearchInput_defineProperty({
            height: '5rem',
            width: 'fit-content',
            marginRight: '2rem'
        }, theme.breakpoints.down('sm'), {
            height: '4rem'
        }),
        mainSection: {
            flexGrow: 1
        },
        imageOnLeft: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        },
        searchInput: {
            display: 'flex',
            height: 38,
            padding: theme.spacing(0.5),
            paddingLeft: theme.spacing(1),
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: 'none',
            '& div': {
                flex: 1
            },
            border: "1px solid ".concat(theme.extraColors.grey),
            backgroundColor: "".concat(theme.extraColors.greyLight),
            '&:hover': {
                backgroundColor: "".concat(theme.extraColors.greyLight)
            },
            textDecoration: 'none',
            '& :hover': {
                backgroundColor: 'transparent'
            }
        },
        searchIcon: {
            height: 30,
            width: 30,
            borderRadius: 6
        },
        clearIcon: {
            height: 15,
            width: 15,
            '&.clear_input_icon_button': {
                marginRight: theme.spacing(0.5),
                color: theme.palette.common.black,
                opacity: 0.54
            }
        },
        btnIcon: {
            display: 'block',
            maxWidth: '100%',
            height: 'auto'
        },
        searchIconSvg: {
            color: theme.palette.common.black
        },
        btnIconSvg: {
            color: theme.palette.common.black,
            lineHeight: 1,
            '& .injected-svg': {
                display: 'inline-block',
                width: '1em',
                height: '1em',
                fontSize: '1.5rem',
                transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                flexShrink: 0,
                userSelect: 'none'
            }
        }
    });
});
var SearchInput = function(param1) {
    var search = param1.search, setSearch = param1.setSearch, label = param1.label, placeholder = param1.placeholder, searchIconUrl = param1.searchIconUrl, action = param1.action, imageOnLeft = param1.imageOnLeft, _inline = param1.inline, inline = _inline === void 0 ? false : _inline, inputRef = param1.inputRef;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = SearchInput_useStyles();
    var isIconUrlDefined = searchIconUrl && (searchIconUrl === null || searchIconUrl === void 0 ? void 0 : searchIconUrl.length) > 0 && new URL(searchIconUrl).pathname.split('.').pop() === 'svg';
    var Icon = function() {
        return isIconUrlDefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
            src: (0,proxySvgUrl/* proxySvgUrl */.u)(searchIconUrl),
            className: (0,clsx_m/* default */.Z)('search__button__icon', 'search__button__icon--svg', classes.btnIconSvg),
            wrapper: "span"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
            className: classes.searchIconSvg
        });
    };
    var inputPlaceholder = (0,CMSText/* prismicText */.yz)(placeholder, t('texts:general.search_bar.input_placeholder'));
    var searchField = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)('search_input_container', classes.searchInput),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.Z, {
                inputRef: inputRef,
                placeholder: inputPlaceholder,
                value: search,
                autoFocus: !inline,
                onChange: function(param) {
                    var target = param.target;
                    return setSearch(target.value);
                },
                onKeyDown: function(event) {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        action();
                    }
                },
                inputProps: {
                    'aria-label': 'search input'
                }
            }),
            search.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                color: "primary",
                className: (0,clsx_m/* default */.Z)('clear_input_icon_button', classes.clearIcon),
                "aria-label": "search",
                size: "small",
                onClick: function() {
                    return setSearch('');
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, {
                    style: {
                        fontSize: 15
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                color: "primary",
                className: (0,clsx_m/* default */.Z)('search_input_icon_button', classes.searchIcon),
                "aria-label": "search",
                onClick: action,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
            })
        ]
    });
    if (inline) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)('search_bar', 'search_bar--inline', classes.root, classes.rootInline),
            children: searchField
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            (imageOnLeft === null || imageOnLeft === void 0 ? void 0 : imageOnLeft.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(classes.imageSection, 'search_bar__img_section'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageOnLeft.url,
                    alt: imageOnLeft.alt,
                    className: classes.imageOnLeft
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.mainSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'h3',
                        component: 'h1',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: label,
                            defaultText: t('texts:general.search_bar.input_label')
                        })
                    }),
                    searchField
                ]
            })
        ]
    }));
};
/* harmony default export */ var Input_SearchInput = (SearchInput);

// EXTERNAL MODULE: ./utils/gtag.ts
var gtag = __webpack_require__(65809);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FavoriteBorderSharp.js
var FavoriteBorderSharp = __webpack_require__(66385);
;// CONCATENATED MODULE: ./components/Account/WishListLink.tsx









var WishListLink_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        wishListLink: {
            '& svg': {
                height: '1.5rem !important',
                width: '1.5rem !important'
            }
        }
    };
});
var WishListLink = function(param) {
    var className = param.className, url = param.url;
    var classes = WishListLink_useStyles();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: '/wish-list',
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (0,clsx_m/* default */.Z)(className, 'wish-list-go-to'),
            "data-testid": 'go_to_wish_list',
            onClick: function() {
                return trackEvent({
                    category: 'user Wish List',
                    action: "User go to his Wish List"
                });
            },
            children: url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                className: classes.wishListLink,
                src: (0,proxySvgUrl/* proxySvgUrl */.u)(url)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteBorderSharp/* default */.Z, {})
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(49161);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/EventSeat.js
var EventSeat = __webpack_require__(25478);
;// CONCATENATED MODULE: ./components/Account/ReservationsLink.tsx











var ReservationsLink_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        reservationsLink: {
            '& svg': {
                height: '1.5rem !important',
                width: '1.5rem !important'
            }
        }
    };
});
var ReservationsLink = function(param) {
    var className = param.className, url = param.url;
    var classes = ReservationsLink_useStyles();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
        title: t('texts:reservations:header_tooltip'),
        arrow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: '/my-reservations',
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (0,clsx_m/* default */.Z)(className, 'reservations-go-to'),
                "data-testid": 'go_to_reservations',
                onClick: function() {
                    return trackEvent({
                        category: 'user Reservations',
                        action: "User go to his Reservations"
                    });
                },
                children: url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                    className: classes.reservationsLink,
                    src: (0,proxySvgUrl/* proxySvgUrl */.u)(url)
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EventSeat/* default */.Z, {})
            })
        })
    }));
};

// EXTERNAL MODULE: ./redux/actions/taxons.ts
var taxons = __webpack_require__(44279);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./components/Layout/Header.tsx
































function Header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Header_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        header: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: theme.zIndex.appBar,
            color: theme.extraColors.greyText,
            boxShadow: theme.shadows[1],
            background: function(LayoutStyle) {
                return !LayoutStyle.isTransparent && LayoutStyle.backgroundColor ? LayoutStyle.backgroundColor : theme.palette.common.white;
            },
            transition: theme.transitions.create([
                'transform',
                'top'
            ]),
            transform: "translateY(0)"
        },
        headerBanner: Header_defineProperty({
            top: function(LayoutStyle) {
                return !LayoutStyle.isHomePage && LayoutStyle.isBanner ? 0 : 40;
            }
        }, theme.breakpoints.down('md'), {
            top: function(LayoutStyle) {
                return !LayoutStyle.isHomePage && LayoutStyle.isBanner ? 0 : 60;
            }
        }),
        headerTop: {
            transform: 'none'
        },
        headerScrolling: {
            transition: theme.transitions.create('transform'),
            transform: "translateY(-".concat(theme.sizes.headerHeight * 3, "px)"),
            '&.header--top': {
                transform: 'none'
            }
        },
        headerTransparent: {
            color: function(LayoutStyle) {
                return LayoutStyle.isTransparent && theme.palette.common.white;
            },
            transition: theme.transitions.create('background'),
            background: function(LayoutStyle) {
                return LayoutStyle.isTransparent && 'transparent';
            },
            boxShadow: 'none'
        },
        headerScrollingTransparent: {
            boxShadow: theme.shadows[1],
            background: theme.palette.common.white
        },
        headerLayout: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: theme.sizes.headerHeight,
            transition: theme.transitions.create('height')
        },
        headerLayoutTransparent: Header_defineProperty({}, theme.breakpoints.up('md'), {
            height: theme.sizes.headerHeightTransparent
        }),
        headerCol: {
            display: 'flex',
            alignItems: 'center',
            height: '100%'
        },
        headerLeft: Header_defineProperty({
            display: 'flex',
            gap: theme.spacing(2),
            '& a': {
                display: 'block'
            }
        }, theme.breakpoints.up('md'), {}),
        headerCenter: {
            justifyContent: 'center'
        },
        header3Col: {
            width: "".concat(1 / 3 * 100, "%")
        },
        headerRight: {
            justifyContent: 'flex-end'
        },
        headerLink: {
            display: 'block',
            '&>img': {
                display: 'block'
            }
        },
        headerTitle: {
            marginLeft: theme.spacing(2),
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.085em',
            color: theme.palette.common.black
        },
        headerIcons: Header_defineProperty({
            display: 'flex',
            flexWrap: 'nowrap'
        }, theme.breakpoints.up('md'), {
            borderLeft: "1px solid currentColor",
            marginLeft: theme.spacing(2)
        }),
        headerIconsAlt: Header_defineProperty({}, theme.breakpoints.up('md'), {
            borderLeft: 0
        }),
        headerBtn: {
            minWidth: 20,
            padding: 0,
            fontSize: 12,
            color: function(LayoutStyle) {
                return !LayoutStyle.isTransparent && (LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black);
            },
            marginLeft: theme.spacing(2),
            background: 'none',
            '& .MuiSvgIcon-root': Header_defineProperty({}, theme.breakpoints.up('md'), {
                marginRight: theme.spacing(0.5)
            }),
            '&:hover, &:focus': {
                color: function(LayoutStyle) {
                    return !LayoutStyle.isTransparent && (LayoutStyle.backgroundColor && LayoutStyle.color && LayoutStyle.hover.color ? LayoutStyle.hover.color : theme.palette.primary.main);
                },
                background: 'none'
            },
            '&[aria-current=true]': {
                color: theme.palette.primary.main
            },
            '& p': {
                margin: 0
            }
        },
        headerBtnTransparent: {
            color: theme.palette.common.white
        },
        logo: Header_defineProperty({
            height: theme.sizes.headerHeight - theme.spacing(2),
            width: 'auto'
        }, theme.breakpoints.down('sm'), {
            maxWidth: '40vw',
            objectFit: 'contain'
        }),
        logoTransparent: Header_defineProperty({}, theme.breakpoints.up('md'), {
            height: theme.sizes.headerHeightTransparent - theme.spacing(4)
        }),
        colorPrimary: {
            color: theme.palette.primary.main
        },
        menuItem: {
            color: theme.palette.common.black
        },
        menuItemTransparent: {
            color: theme.palette.common.white
        },
        languageSelector: Header_defineProperty({
            marginLeft: '.5rem',
            '& a': {
                color: function(LayoutStyle) {
                    return !LayoutStyle.isTransparent && (LayoutStyle.backgroundColor && LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black);
                },
                '&:hover, &:focus': {
                    color: function(LayoutStyle) {
                        return !LayoutStyle.isTransparent && LayoutStyle.backgroundColor && LayoutStyle.color && LayoutStyle.hover.color && LayoutStyle.hover.color;
                    }
                }
            }
        }, theme.breakpoints.down('md'), {
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center'
        }),
        languageSeparator: Header_defineProperty({
            lineHeight: '1px'
        }, theme.breakpoints.down('sm'), {
            marginRight: '3px'
        }),
        langbtn: {
            minWidth: 'inherit',
            padding: 0
        },
        activeLang: {
            '&[aria-current=true]': {
                color: function(LayoutStyle) {
                    return !LayoutStyle.isTransparent && (LayoutStyle.backgroundColor && LayoutStyle.hover.color ? LayoutStyle.hover.color : theme.palette.common.black);
                },
                pointerEvents: 'none',
                fontWeight: 'bold',
                textDecoration: 'underline'
            }
        },
        inlineDiv: {
            display: 'inline-flex',
            justifyContent: 'start',
            alignItems: 'center',
            width: '100%'
        },
        inStoreLines: {
            lineHeight: 1
        },
        openModalStoreLink: {
            textTransform: 'none',
            color: theme.palette.secondary.main,
            textDecoration: 'underline',
            fontSize: 12
        },
        drawerContent: {
            background: theme.extraColors.grey
        },
        drawerFooter: {
            background: theme.extraColors.greyLight,
            padding: theme.spacing(1)
        },
        headerBurger: {
            background: 'none',
            boxShadow: 'none',
            color: function(LayoutStyle) {
                return !LayoutStyle.isTransparent && (LayoutStyle.backgroundColor && LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black);
            }
        },
        drawerFooterBtn: {
            width: '100%',
            borderRadius: 0,
            textAlign: 'left',
            justifyContent: 'flex-start',
            background: theme.palette.common.white,
            color: theme.extraColors.greyText,
            '& .MuiSvgIcon-root': {
                marginRight: theme.spacing(2)
            }
        },
        btnIcon: {
            display: 'block',
            maxWidth: '100%',
            height: 'auto'
        },
        btnIconSvg: {
            lineHeight: 1,
            '& .injected-svg': {
                display: 'inline-block',
                width: '1em',
                height: '1em',
                fontSize: '1.5rem',
                fill: 'currentColor',
                transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                flexShrink: 0,
                userSelect: 'none'
            }
        },
        wishListLink: {
            color: theme.palette.common.black,
            height: '1.5rem',
            width: '1.5rem',
            marginLeft: '1rem'
        }
    });
});
var mapStateToProps = function(state) {
    return {
        stores: state.stores,
        cart: state.cart,
        parameters: state.parameters,
        userIsLoggedIn: state.user.isLoggedIn,
        taxons: state.taxons
    };
};
var mapDispatchToProps = {
    getTaxons: taxons/* getTaxons */.xI
};
var Header = function(param1) {
    var _isHomePage = param1.isHomePage, isHomePage = _isHomePage === void 0 ? false : _isHomePage, logo = param1.logo, doc = param1.doc, t = param1.t, stores = param1.stores, parameters = param1.parameters, logoTransparent = param1.logoTransparent, isTransparent = param1.isTransparent, showOnScrollUp = param1.showOnScrollUp, showOnTop = param1.showOnTop, inStoreText = param1.inStoreText, isBanner = param1.isBanner, background = param1.background, textColor = param1.textColor, hoverColor = param1.hoverColor, cart = param1.cart, basket = param1.basket, account = param1.account, faq = param1.faq, funnel = param1.funnel, takeback = param1.takeback, submenuBackgroundColor = param1.submenuBackgroundColor, submenuTextColor = param1.submenuTextColor, isDisplayedBannerOnAllPages = param1.isDisplayedBannerOnAllPages, banner = param1.banner, pageName = param1.pageName, userIsLoggedIn = param1.userIsLoggedIn, getTaxons1 = param1.getTaxons, taxons = param1.taxons;
    var ref52, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42;
    var router = (0,next_router.useRouter)();
    var backgroundHeaderColor = background;
    var textMenuColor = textColor;
    var hoverMenuColor = hoverColor;
    var LayoutStyle = {
        backgroundColor: backgroundHeaderColor,
        color: textMenuColor,
        hover: {
            color: hoverMenuColor
        },
        isTransparent: isTransparent && showOnTop,
        submenuBackgroundColor: submenuBackgroundColor,
        submenuTextColor: submenuTextColor,
        isHomePage: isHomePage,
        isDisplayedBannerOnAllPages: isDisplayedBannerOnAllPages,
        isBanner: isBanner
    };
    var classes = Header_useStyles(LayoutStyle);
    var drawerClasses = (0,Drawer_style/* default */.Z)();
    var theme = (0,useTheme/* default */.Z)();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var isDesktop = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up('lg'));
    var ref43 = (0,react.useState)(false), openModalInStore = ref43[0], setOpenModalInStore = ref43[1];
    var isIconOnly = doc === null || doc === void 0 ? void 0 : (ref52 = doc.data) === null || ref52 === void 0 ? void 0 : ref52.menu_icon_only;
    var isSticky = doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.header_sticky;
    var menuPos = (0,utils/* menuPosition */.q7)(doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.main_menu);
    var burgerPos = (0,utils/* menuPosition */.q7)(doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.burger_menu);
    var logoPos = (0,utils/* logoPosition */.BC)(doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.logo_position);
    var accountIconPrismic = account === null || account === void 0 ? void 0 : (ref5 = account.data) === null || ref5 === void 0 ? void 0 : ref5.accountbutton;
    var faqIconPrismic = faq === null || faq === void 0 ? void 0 : (ref6 = faq.data) === null || ref6 === void 0 ? void 0 : ref6.faqbutton;
    var locale = router.locale, locales = router.locales;
    var ref44 = (0,react.useState)(false), openMenu = ref44[0], setOpenMenu = ref44[1];
    var ref45 = (0,react.useState)(false), primaryMenuActive = ref45[0], setPrimaryMenuActive = ref45[1];
    var ref46 = (0,react.useState)(false), openLanguageModal = ref46[0], setOpenLanguageModal = ref46[1];
    var ref47 = (0,react.useState)(router.locale), selectedLanguage = ref47[0], setSelectedLanguage = ref47[1];
    var ref48 = (0,react.useState)(false), open = ref48[0], setOpen = ref48[1];
    var ref49 = (0,react.useState)(''), search = ref49[0], setSearch = ref49[1];
    var searchInputRef = (0,react.useRef)(null);
    var isVaudeSearchPopup = "millet" === 'vaude';
    var isAccountIconDefined = (accountIconPrismic === null || accountIconPrismic === void 0 ? void 0 : accountIconPrismic.url) && (accountIconPrismic === null || accountIconPrismic === void 0 ? void 0 : (ref7 = accountIconPrismic.url) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && (accountIconPrismic === null || accountIconPrismic === void 0 ? void 0 : accountIconPrismic.url.split('.').pop()) === 'svg';
    var isFaqIconDefined = (faqIconPrismic === null || faqIconPrismic === void 0 ? void 0 : faqIconPrismic.url) && (faqIconPrismic === null || faqIconPrismic === void 0 ? void 0 : (ref8 = faqIconPrismic.url) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && (faqIconPrismic === null || faqIconPrismic === void 0 ? void 0 : faqIconPrismic.url.split('.').pop()) === 'svg';
    var likingEnabled = (doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.wishlist_enabled) && userIsLoggedIn;
    var wishListIcon = doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.wish_list_icon;
    var reservationsEnabled = (doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.enable_reservation) && userIsLoggedIn;
    var reservationsIcon = doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : ref12.reservations_header_icon;
    var handlePrimaryMenuActive = function() {
        if (primaryMenuActive) {
            setPrimaryMenuActive(false);
        } else {
            setPrimaryMenuActive(true);
        }
    };
    var openLanguageModalAndSelectedLanguage = function(lang) {
        var ref, ref51;
        // if we have no item in cart we do not open the modal and just redirect, else we open the modal
        if ((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref51 = ref.items) === null || ref51 === void 0 ? void 0 : ref51.length) > 0) {
            setOpenLanguageModal(true);
        } else {
            router.push({
                pathname: '/',
                query: {}
            }, {
                pathname: '/'
            }, {
                locale: lang
            });
        }
        setSelectedLanguage(lang);
    };
    var redirectToUpcomingLocale = function(lang) {
        router.push({
            pathname: "/pages/".concat(lang)
        }, {
            pathname: "/pages/".concat(lang)
        });
    };
    (0,react.useEffect)(function() {
        if (!taxons.loading && taxons.items.length === 0) {
            getTaxons1();
        }
    }, [
        taxons.loading,
        taxons.items
    ]);
    (0,react.useEffect)(function() {
        if (open && isVaudeSearchPopup) {
            var ref;
            (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        open,
        isVaudeSearchPopup
    ]);
    var HeaderLangs = function(param) {
        var isMenuItemTransparent = param.isMenuItemTransparent, _spacing = param.spacing, spacing = _spacing === void 0 ? true : _spacing;
        return (locales === null || locales === void 0 ? void 0 : locales.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (0,clsx_m/* default */.Z)('header__lang', Header_defineProperty({}, classes.languageSelector, spacing)),
            children: [
                locales === null || locales === void 0 ? void 0 : locales.map(function(lang, index) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            size: "small",
                                            "aria-current": lang === locale,
                                            className: (0,clsx_m/* default */.Z)('header__langbtn', [
                                                classes.langbtn,
                                                classes.menuItem,
                                                isMenuItemTransparent && classes.menuItemTransparent,
                                                lang === locale && classes.activeLang, 
                                            ]),
                                            onClick: function() {
                                                return openLanguageModalAndSelectedLanguage(lang);
                                            },
                                            children: lang.toUpperCase().substring(0, 2)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Global_ChangeLanguageModal, {
                                        open: openLanguageModal,
                                        doc: doc,
                                        t: t,
                                        handleClose: function() {
                                            return setOpenLanguageModal(false);
                                        },
                                        lang: selectedLanguage,
                                        pathname: router.pathname,
                                        query: router.query
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classes.languageSeparator,
                                children: locales.length === index + 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "\xa0"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "\xa0-\xa0"
                                })
                            })
                        ]
                    }, lang));
                }),
                (locales === null || locales === void 0 ? void 0 : locales.length) > 0 && (constants/* upcomingLocales */.Ko === null || constants/* upcomingLocales */.Ko === void 0 ? void 0 : constants/* upcomingLocales.length */.Ko.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\xa0-\xa0"
                }),
                constants/* upcomingLocales */.Ko === null || constants/* upcomingLocales */.Ko === void 0 ? void 0 : constants/* upcomingLocales.map */.Ko.map(function(lang, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "small",
                                        className: (0,clsx_m/* default */.Z)('header__langbtn', [
                                            classes.langbtn,
                                            classes.menuItem,
                                            isMenuItemTransparent && classes.menuItemTransparent, 
                                        ]),
                                        onClick: redirectToUpcomingLocale.bind(null, lang),
                                        children: lang.toUpperCase().substring(0, 2)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classes.languageSeparator,
                                children: constants/* upcomingLocales.length */.Ko.length === index + 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "\xa0"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "\xa0-\xa0"
                                })
                            })
                        ]
                    }, lang);
                })
            ]
        });
    };
    var Logo = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("img", {
            src: logo ? logo === null || logo === void 0 ? void 0 : logo.url : '/images/logo_default_grey.svg',
            className: (0,clsx_m/* default */.Z)('header__logo', classes.logo),
            alt: (logo === null || logo === void 0 ? void 0 : logo.alt) !== null ? logo === null || logo === void 0 ? void 0 : logo.alt : ''
        });
    };
    var accountIcon = isAccountIconDefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
        src: (0,proxySvgUrl/* proxySvgUrl */.u)(accountIconPrismic.url),
        className: (0,clsx_m/* default */.Z)('account__icon', 'account__icon--svg', classes.btnIcon, classes.btnIconSvg),
        wrapper: "span"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {});
    var faqIcon = isFaqIconDefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
        src: (0,proxySvgUrl/* proxySvgUrl */.u)(faqIconPrismic.url),
        className: (0,clsx_m/* default */.Z)('faq__icon', 'faq__icon--svg', classes.btnIcon, classes.btnIconSvg),
        wrapper: "span"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpOutline/* default */.Z, {});
    var ref50;
    var LogoTransparent = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: "/",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: classes.headerLink,
                onClick: function() {
                    return trackEvent({
                        category: 'Header',
                        href: '/account',
                        action: 'Header to Homepage',
                        name: "".concat(router.pathname)
                    });
                },
                children: isHomePage && logoTransparent && isTransparent && showOnTop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "header__logo-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (logoTransparent === null || logoTransparent === void 0 ? void 0 : logoTransparent.url) ? logoTransparent === null || logoTransparent === void 0 ? void 0 : logoTransparent.url : '/images/logo_default_white.svg',
                        className: (0,clsx_m/* default */.Z)('header__logo', [
                            classes.logo,
                            isTransparent && showOnTop && classes.logoTransparent, 
                        ]),
                        alt: (ref50 = logoTransparent === null || logoTransparent === void 0 ? void 0 : logoTransparent.alt) !== null && ref50 !== void 0 ? ref50 : ''
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
            })
        });
    };
    var HeaderAccountLink = function() {
        var ref, ref53, ref54, ref55;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: (doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.account_link_to_register) ? '/register' : '/account',
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                disableRipple: true,
                size: "small",
                onClick: function() {
                    return trackEvent({
                        category: 'Header',
                        href: '/account',
                        action: 'Header to My account',
                        name: "".concat(router.pathname)
                    });
                },
                "data-testid": 'account_header',
                component: "a",
                className: (0,clsx_m/* default */.Z)('header__cta', 'header__cta--account', [
                    classes.headerBtn,
                    isTransparent && showOnTop && classes.headerBtnTransparent,
                    router.pathname.includes('account') && classes.colorPrimary, 
                ]),
                children: [
                    accountIcon,
                    isDesktop && isIconOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "srOnly",
                        color: router.pathname.includes('account') ? 'primary' : 'textPrimary',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: inStoreText === null || inStoreText === void 0 ? void 0 : (ref53 = inStoreText.data) === null || ref53 === void 0 ? void 0 : ref53.header_change_store,
                            defaultText: t('texts:instore:header_change_store')
                        })
                    }),
                    isDesktop && !isIconOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: doc === null || doc === void 0 ? void 0 : (ref54 = doc.data) === null || ref54 === void 0 ? void 0 : ref54.my_account,
                        defaultText: t('texts:general:my_account')
                    }),
                    !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "srOnly",
                        color: router.pathname.includes('account') ? 'primary' : 'textPrimary',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: inStoreText === null || inStoreText === void 0 ? void 0 : (ref55 = inStoreText.data) === null || ref55 === void 0 ? void 0 : ref55.header_change_store,
                            defaultText: t('texts:instore:header_change_store')
                        })
                    })
                ]
            })
        });
    };
    var HeaderFaqLink = function() {
        var ref63, ref56, ref57, ref58, ref59, ref60, ref61;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: (doc === null || doc === void 0 ? void 0 : (ref63 = doc.data) === null || ref63 === void 0 ? void 0 : (ref56 = ref63.custom_faq_link) === null || ref56 === void 0 ? void 0 : ref56.url) || '/faq',
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                target: doc === null || doc === void 0 ? void 0 : (ref57 = doc.data) === null || ref57 === void 0 ? void 0 : (ref58 = ref57.custom_faq_link) === null || ref58 === void 0 ? void 0 : ref58.target,
                disableRipple: true,
                size: "small",
                onClick: function() {
                    var ref, ref62;
                    return trackEvent({
                        category: 'Header',
                        href: (doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : (ref62 = ref.custom_faq_link) === null || ref62 === void 0 ? void 0 : ref62.url) || '/faq',
                        action: 'Header to FAQ',
                        name: "".concat(router.pathname)
                    });
                },
                component: "a",
                "aria-current": router.pathname === '/faq',
                disabled: router.pathname === '/faq',
                className: (0,clsx_m/* default */.Z)('header__cta', 'header__cta--faq', [
                    classes.headerBtn,
                    isTransparent && showOnTop && classes.headerBtnTransparent, 
                ]),
                children: [
                    faqIcon,
                    isDesktop && isIconOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "srOnly",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: doc === null || doc === void 0 ? void 0 : (ref59 = doc.data) === null || ref59 === void 0 ? void 0 : ref59.faq,
                            defaultText: t('texts:general:FAQ')
                        })
                    }),
                    isDesktop && !isIconOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: doc === null || doc === void 0 ? void 0 : (ref60 = doc.data) === null || ref60 === void 0 ? void 0 : ref60.faq,
                        defaultText: t('texts:general:FAQ')
                    }),
                    !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "srOnly",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: doc === null || doc === void 0 ? void 0 : (ref61 = doc.data) === null || ref61 === void 0 ? void 0 : ref61.faq,
                            defaultText: t('texts:general:FAQ')
                        })
                    })
                ]
            })
        });
    };
    var handleSearchButton = function() {
        setOpen(true);
        trackEvent({
            category: 'SearchButton',
            action: isVaudeSearchPopup ? 'Open search popup' : 'Open Seach bar'
        });
        gtag/* tracker */.ap('searchBar', {
            value: open
        });
    };
    var handleSearchSubmit = function() {
        if (search) router.push("/search?q=".concat(search)).then(function() {
            return setOpen(false);
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (0,clsx_m/* default */.Z)('header', [
            classes.header,
            showOnTop && [
                'header--top',
                classes.headerTop,
                "header--top--page__".concat(pageName), 
            ],
            isBanner && showOnTop && classes.headerBanner,
            isTransparent && showOnTop && [
                'header--transparent',
                classes.headerTransparent
            ],
            !isSticky && showOnScrollUp && classes.headerScrolling,
            "header--page__".concat(pageName),
            isHomePage && 'header--home',
            isHomePage && showOnTop && 'header--home--top',
            open && isVaudeSearchPopup && 'header--search-open', 
        ]),
        children: [
            isBanner && isDisplayedBannerOnAllPages && !isHomePage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner["default"], {
                banner: banner,
                t: t
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)('header__layout', [
                            classes.headerLayout,
                            isTransparent && showOnTop && classes.headerLayoutTransparent, 
                        ]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.headerCol, classes.headerLeft, 'header__col', 'header__left', menuPos === 'Center' && classes.header3Col, logoPos === 'Center' && !isDesktop && classes.header3Col),
                                children: [
                                    !isDesktop && burgerPos === 'Left' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)('header__burger', classes.headerBurger),
                                        onClick: function() {
                                            return setOpenMenu(true);
                                        }
                                    }),
                                    isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoTransparent, {}) : logoPos === 'Left' && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoTransparent, {}),
                                    isDesktop && menuPos === 'Left' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Menu, {
                                        general: doc,
                                        t: t,
                                        type: 'primary',
                                        LayoutStyle: LayoutStyle
                                    })
                                ]
                            }),
                            isDesktop && menuPos === 'Center' && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)('header__col', 'header__center', classes.headerCol, classes.headerCenter, classes.header3Col),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Menu, {
                                    general: doc,
                                    t: t,
                                    type: 'primary',
                                    LayoutStyle: LayoutStyle
                                })
                            }),
                            !isDesktop && logoPos === 'Center' && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)('header__col', 'header__center', classes.headerCol, classes.headerCenter, classes.header3Col),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoTransparent, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)('header__col', 'header__right', classes.headerCol, classes.headerRight, menuPos === 'Center' && classes.header3Col, !isDesktop && logoPos === 'Center' && classes.header3Col),
                                children: [
                                    isDesktop && menuPos === 'Right' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Menu, {
                                        general: doc,
                                        t: t,
                                        type: 'primary',
                                        LayoutStyle: LayoutStyle
                                    }),
                                    isDesktop && !(doc === null || doc === void 0 ? void 0 : (ref13 = doc.data) === null || ref13 === void 0 ? void 0 : ref13.build_menu_from_taxons) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Menu, {
                                        general: doc,
                                        t: t,
                                        LayoutStyle: LayoutStyle,
                                        type: 'secondary'
                                    }),
                                    (doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : ref14.enable_search) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_InputButton, {
                                        iconOnly: doc === null || doc === void 0 ? void 0 : (ref15 = doc.data) === null || ref15 === void 0 ? void 0 : ref15.search_type,
                                        label: doc === null || doc === void 0 ? void 0 : (ref16 = doc.data) === null || ref16 === void 0 ? void 0 : ref16.search_label,
                                        iconUrl: doc === null || doc === void 0 ? void 0 : (ref17 = doc.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.search_icon) === null || ref18 === void 0 ? void 0 : ref18.url,
                                        transparentBackground: LayoutStyle.isTransparent,
                                        onClick: handleSearchButton,
                                        isMobile: !isDesktop,
                                        LayoutStyle: LayoutStyle
                                    }),
                                    !isDesktop && (doc === null || doc === void 0 ? void 0 : (ref19 = doc.data) === null || ref19 === void 0 ? void 0 : ref19.show_header_langs_on_mobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLangs, {
                                        isMenuItemTransparent: isTransparent && showOnTop
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)('header__icons', classes.headerIcons, menuPos === 'No menu' && classes.headerIconsAlt),
                                        children: [
                                            (parameters === null || parameters === void 0 ? void 0 : (ref20 = parameters.items) === null || ref20 === void 0 ? void 0 : ref20.in_store) && (stores === null || stores === void 0 ? void 0 : stores.selectedStore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                disableRipple: true,
                                                size: "small",
                                                onClick: function() {
                                                    return setOpenModalInStore(true);
                                                },
                                                "data-testid": 'instore_header',
                                                className: (0,clsx_m/* default */.Z)('header__cta', 'header__cta--instore', [
                                                    classes.headerBtn,
                                                    isTransparent && showOnTop && classes.headerBtnTransparent,
                                                    router.pathname.includes('account') && classes.colorPrimary, 
                                                ]),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.inlineDiv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Room/* default */.Z, {}),
                                                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classes.inStoreLines,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: stores === null || stores === void 0 ? void 0 : (ref21 = stores.selectedStore) === null || ref21 === void 0 ? void 0 : ref21.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    onClick: function() {
                                                                        return setOpenModalInStore(true);
                                                                    },
                                                                    className: (0,clsx_m/* default */.Z)(classes.openModalStoreLink, 'header__cta--instore--choice'),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                        data: doc === null || doc === void 0 ? void 0 : (ref22 = doc.data) === null || ref22 === void 0 ? void 0 : ref22.modale_title,
                                                                        defaultText: t('texts:instore:modale_title')
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            burgerPos === 'No menu' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderAccountLink, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderFaqLink, {})
                                                ]
                                            }) : isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderAccountLink, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderFaqLink, {})
                                                ]
                                            })
                                        ]
                                    }),
                                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLangs, {
                                        isMenuItemTransparent: isTransparent && showOnTop && isDesktop
                                    }),
                                    likingEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(WishListLink, {
                                        className: classes.wishListLink,
                                        url: wishListIcon === null || wishListIcon === void 0 ? void 0 : wishListIcon.url
                                    }),
                                    reservationsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationsLink, {
                                        className: classes.wishListLink,
                                        url: reservationsIcon === null || reservationsIcon === void 0 ? void 0 : reservationsIcon.url
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basket/* default */.Z, {
                                        settings: doc === null || doc === void 0 ? void 0 : doc.data,
                                        basket: basket,
                                        isAbsolute: true,
                                        textShippings: funnel === null || funnel === void 0 ? void 0 : funnel.data,
                                        nextStep: "/information",
                                        hidePrice: doc === null || doc === void 0 ? void 0 : (ref23 = doc.data) === null || ref23 === void 0 ? void 0 : ref23.only_add_with_pack,
                                        showSizes: doc === null || doc === void 0 ? void 0 : (ref24 = doc.data) === null || ref24 === void 0 ? void 0 : ref24.show_size_name,
                                        layoutStyle: LayoutStyle,
                                        takeback: takeback
                                    }),
                                    !isDesktop && burgerPos === 'Right' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)('header__burger', classes.headerBurger),
                                        onClick: function() {
                                            return setOpenMenu(true);
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    isVaudeSearchPopup && (doc === null || doc === void 0 ? void 0 : (ref25 = doc.data) === null || ref25 === void 0 ? void 0 : ref25.enable_search) && open && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                        onClickAway: function() {
                            return setOpen(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header__search header__search--popup",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_SearchInput, {
                                inline: true,
                                search: search,
                                setSearch: setSearch,
                                placeholder: doc === null || doc === void 0 ? void 0 : (ref26 = doc.data) === null || ref26 === void 0 ? void 0 : ref26.search_placeholder,
                                searchIconUrl: doc === null || doc === void 0 ? void 0 : (ref27 = doc.data) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.search_icon) === null || ref28 === void 0 ? void 0 : ref28.url,
                                inputRef: searchInputRef,
                                action: handleSearchSubmit
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeStoreModal/* default */.Z, {
                open: openModalInStore,
                doc: inStoreText,
                t: t,
                handleClose: function() {
                    return setOpenModalInStore(false);
                }
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                anchor: burgerPos === 'Right' ? 'right' : 'left',
                open: openMenu,
                onClose: function() {
                    return setOpenMenu(false);
                },
                className: (0,clsx_m/* default */.Z)('menu-mobile', drawerClasses.drawer),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)('menu-mobile__layout', drawerClasses.drawerLayout),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)('menu-mobile__header', drawerClasses.drawerHeader),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoTransparent, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    size: 'small',
                                    color: 'default',
                                    disableRipple: true,
                                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Close/* default */.Z, {}),
                                    onClick: function() {
                                        return setOpenMenu(false);
                                    },
                                    className: (0,clsx_m/* default */.Z)('menu-mobile__close', drawerClasses.drawerClose),
                                    disableTouchRipple: true,
                                    disableElevation: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref29 = doc.data) === null || ref29 === void 0 ? void 0 : ref29.menu_close_text,
                                        defaultText: t('texts:general:menu:close')
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)('menu-mobile__content', drawerClasses.drawerContent, classes.drawerContent),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                in: openMenu,
                                timeout: 600,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: function() {
                                                return handlePrimaryMenuActive();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Menu, {
                                                general: doc,
                                                t: t,
                                                type: 'primary',
                                                LayoutStyle: LayoutStyle,
                                                isMobile: true
                                            })
                                        }),
                                        !primaryMenuActive && !(doc === null || doc === void 0 ? void 0 : (ref30 = doc.data) === null || ref30 === void 0 ? void 0 : ref30.build_menu_from_taxons) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Menu, {
                                            general: doc,
                                            t: t,
                                            type: 'secondary',
                                            LayoutStyle: LayoutStyle,
                                            isMobile: true
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)('menu-mobile__footer', drawerClasses.drawerFooter, classes.drawerFooter),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (doc === null || doc === void 0 ? void 0 : (ref31 = doc.data) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.custom_faq_link) === null || ref32 === void 0 ? void 0 : ref32.url) || '/faq',
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        target: doc === null || doc === void 0 ? void 0 : (ref33 = doc.data) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.custom_faq_link) === null || ref34 === void 0 ? void 0 : ref34.target,
                                        disableRipple: true,
                                        size: "small",
                                        onClick: function() {
                                            var ref, ref64;
                                            return trackEvent({
                                                category: 'Header',
                                                href: (doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : (ref64 = ref.custom_faq_link) === null || ref64 === void 0 ? void 0 : ref64.url) || '/faq',
                                                action: 'Header to FAQ',
                                                name: "".concat(router.pathname)
                                            });
                                        },
                                        component: "a",
                                        "aria-current": router.pathname === '/faq',
                                        disabled: router.pathname === '/faq',
                                        className: (0,clsx_m/* default */.Z)('menu-mobile__cta', 'menu-mobile__cta--faq', [
                                            classes.drawerFooterBtn, 
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpOutline/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : (ref35 = doc.data) === null || ref35 === void 0 ? void 0 : ref35.faq,
                                                defaultText: t('texts:general:FAQ')
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (doc === null || doc === void 0 ? void 0 : (ref36 = doc.data) === null || ref36 === void 0 ? void 0 : ref36.account_link_to_register) ? '/register' : '/account',
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        disableRipple: true,
                                        size: "small",
                                        onClick: function() {
                                            return trackEvent({
                                                category: 'Header',
                                                href: '/account',
                                                action: 'Header to My account',
                                                name: "".concat(router.pathname)
                                            });
                                        },
                                        "data-testid": 'account_header',
                                        component: "a",
                                        className: (0,clsx_m/* default */.Z)('menu-mobile__cta', 'menu-mobile__cta--account', [
                                            classes.drawerFooterBtn
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                data: doc === null || doc === void 0 ? void 0 : (ref37 = doc.data) === null || ref37 === void 0 ? void 0 : ref37.my_account,
                                                defaultText: t('texts:general:my_account')
                                            })
                                        ]
                                    })
                                }),
                                !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLangs, {
                                    isMenuItemTransparent: false,
                                    spacing: false
                                })
                            ]
                        })
                    ]
                })
            }),
            !isVaudeSearchPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogFullscreen, {
                open: open,
                setOpen: setOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_SearchInput, {
                    search: search,
                    setSearch: setSearch,
                    label: doc === null || doc === void 0 ? void 0 : (ref38 = doc.data) === null || ref38 === void 0 ? void 0 : ref38.search_label,
                    placeholder: doc === null || doc === void 0 ? void 0 : (ref39 = doc.data) === null || ref39 === void 0 ? void 0 : ref39.search_placeholder,
                    searchIconUrl: doc === null || doc === void 0 ? void 0 : (ref40 = doc.data) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.search_icon) === null || ref41 === void 0 ? void 0 : ref41.url,
                    action: handleSearchSubmit,
                    imageOnLeft: doc === null || doc === void 0 ? void 0 : (ref42 = doc.data) === null || ref42 === void 0 ? void 0 : ref42.search_image_on_left
                })
            })
        ]
    }));
};
/* harmony default export */ var Layout_Header = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Header));


/***/ }),

/***/ 31520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Link = function(props) {
    var href = props.href, otherProps = _objectWithoutProperties(props, [
        "href"
    ]);
    var productionDomain = "https://location.millet.com";
    // Vérifier que href n'est pas undefined ou vide
    if (!href || href === '') {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", _objectSpread({}, otherProps)));
    }
    var origin;
    if (true) {
        origin = window.location.origin;
    }
    var relativeHref;
    if (origin && typeof href === 'string' && productionDomain && href.includes(productionDomain)) {
        relativeHref = href.replace(productionDomain, origin);
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], _objectSpread({
        href: relativeHref || href
    }, otherProps)));
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 49172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14903);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58365);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94455);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        root: _defineProperty({
            display: 'flex',
            justifyContent: 'space-around',
            paddingBottom: 10,
            width: '100%',
            '&>.MuiBox-root': {
                padding: theme.spacing(1.25, 2),
                borderRadius: theme.shape.borderRadius,
                textAlign: 'center',
                '&>p': {
                    fontSize: 12
                },
                '&>span': {
                    fontSize: 14,
                    display: 'block',
                    lineHeight: 1
                }
            }
        }, theme.breakpoints.up('lg'), {
            display: 'inline-flex',
            padding: 0,
            marginLeft: theme.spacing(1),
            '&>.MuiBox-root': {
                margin: theme.spacing(0, 0.5)
            }
        }),
        inline: {
            display: 'inline-block'
        },
        isSmall: {
            display: 'block',
            margin: 0,
            padding: 0,
            '&>.MuiBox-root': {
                padding: 0,
                margin: theme.spacing(0, 0, 0.5),
                borderRadius: theme.shape.borderRadius,
                textAlign: 'left',
                display: 'flex',
                alignItems: 'center',
                background: 'none',
                width: 'auto',
                '&>p': {
                    fontSize: 12,
                    marginRight: theme.spacing(0.5)
                },
                '&>span': {
                    fontSize: 14,
                    display: 'inline-block',
                    lineHeight: 1
                }
            }
        },
        start: _defineProperty({
            marginRight: theme.spacing(1),
            backgroundColor: theme.palette.primaryTransparent.light,
            '&>p': {
                color: theme.palette.primaryTransparent.main
            },
            '&>span': {
                color: theme.palette.primary.main
            }
        }, theme.breakpoints.down('sm'), {
            width: '50%'
        }),
        end: _defineProperty({
            marginLeft: theme.spacing(1),
            backgroundColor: theme.palette.primaryTransparent.light,
            '&>p': {
                color: theme.palette.primaryTransparent.main
            },
            '&>span': {
                color: theme.palette.primary.main
            }
        }, theme.breakpoints.down('sm'), {
            width: '50%'
        })
    });
});
var ShippingInfos = function(param) {
    var startDate = param.startDate, endDate = param.endDate, deliverDuration = param.deliverDuration, returnDuration = param.returnDuration, _loading = param.loading, loading = _loading === void 0 ? true : _loading, small = param.small, text = param.text, isExpress = param.isExpress, t = param.t, _isEnableChooseStartingDate = param.isEnableChooseStartingDate, isEnableChooseStartingDate = _isEnableChooseStartingDate === void 0 ? false : _isEnableChooseStartingDate;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: small ? "shipping-infos ".concat(classes.root, " ").concat(classes.isSmall) : "shipping-infos ".concat(classes.root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "shipping-infos__start ".concat(classes.start),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "body2",
                        component: "p",
                        noWrap: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            asText: true,
                            data: text === null || text === void 0 ? void 0 : text.delivered_on,
                            defaultText: t('texts:funnel:delivered_on')
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: "span",
                        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "text",
                            width: "10ch",
                            component: "span",
                            className: classes.inline
                        }) : startDate ? (!isExpress ? dayjs__WEBPACK_IMPORTED_MODULE_2___default()(startDate, 'DD/MM/YYYY').add(-deliverDuration, 'day') : dayjs__WEBPACK_IMPORTED_MODULE_2___default()(startDate, 'DD/MM/YYYY')).format('L') : ' '
                    })
                ]
            }),
            !isEnableChooseStartingDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "shipping-infos__end ".concat(classes.end),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "body2",
                        component: "p",
                        noWrap: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            asText: true,
                            data: text === null || text === void 0 ? void 0 : text.return_before,
                            defaultText: t('texts:funnel:return_before')
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: "span",
                        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "text",
                            width: "10ch",
                            component: "span",
                            className: classes.inline
                        }) : endDate ? dayjs__WEBPACK_IMPORTED_MODULE_2___default()(endDate, 'DD/MM/YYYY').add(returnDuration, 'day').format('L') : ' '
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ShippingInfos);


/***/ }),

/***/ 31907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36456);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31567);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16502);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66026);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94455);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8920);








var mapStateToProps = function(state) {
    return {
        cart: state.cart
    };
};
var Price = function(param) {
    var _amount = param.amount, amount = _amount === void 0 ? 0 : _amount, isShort = param.isShort, showDayOrMonth = param.showDayOrMonth, buyAble = param.buyAble, dayOrMonth = param.dayOrMonth, dayOrMonthShort = param.dayOrMonthShort, UnitText = param.UnitText, UnitTextShort = param.UnitTextShort, _amountNotDivided = param.amountNotDivided, amountNotDivided = _amountNotDivided === void 0 ? false : _amountNotDivided, _numberOfDays = param.numberOfDays, numberOfDays = _numberOfDays === void 0 ? 30 : _numberOfDays, cart = param.cart, _displayFlexPrice = param.displayFlexPrice, displayFlexPrice = _displayFlexPrice === void 0 ? false : _displayFlexPrice, showUnitText = param.showUnitText, currency = param.currency, afterCurrency = param.afterCurrency;
    var ref, ref1, ref2;
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)().t;
    var currencySymbol = '€';
    var isRight = true;
    var currencyPrice = currency || (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.currency) || 'EUR';
    switch(currencyPrice){
        case 'EUR':
            var ref3;
            currencySymbol = (theme === null || theme === void 0 ? void 0 : (ref3 = theme.settings) === null || ref3 === void 0 ? void 0 : ref3.priceFormat) === 'comma_two_decimals' ? '\xa0€' : '€';
            isRight = true;
            break;
        case 'CHF':
            currencySymbol = 'CHF ';
            isRight = false;
            break;
        case 'GBP':
            currencySymbol = '\xa3';
            isRight = false;
            break;
        case 'USD':
            currencySymbol = '$';
            isRight = true;
            break;
        case 'AED':
            currencySymbol = 'AED';
            isRight = true;
            break;
        default:
            break;
    }
    var altNumberFormat = new Intl.NumberFormat((theme === null || theme === void 0 ? void 0 : (ref1 = theme.settings) === null || ref1 === void 0 ? void 0 : ref1.priceLocaleFormat) || 'de-DE', {
        minimumFractionDigits: 2
    });
    var amountDisplay = _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .isFlex */ .Lz && displayFlexPrice && !buyAble ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(amount, amountNotDivided) / numberOfDays : (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(amount, amountNotDivided);
    var price = Number.isNaN(amountDisplay) ? 0 : amountDisplay;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: 'price__amount',
                children: [
                    !isRight && currencySymbol,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: (theme === null || theme === void 0 ? void 0 : (ref2 = theme.settings) === null || ref2 === void 0 ? void 0 : ref2.priceFormat) === 'comma_two_decimals' ? altNumberFormat.format(price) : price
                    }),
                    isRight && currencySymbol,
                    afterCurrency
                ]
            }),
            showDayOrMonth && !buyAble && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: 'price__duration',
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: !displayFlexPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                asText: true,
                                defaultText: _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .isSubscription */ .Nn ? t('texts:general:month_short') : t('texts:general:day_short'),
                                data: isShort ? dayOrMonthShort : dayOrMonth
                            }),
                            showUnitText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                asText: true,
                                defaultText: t('texts:general:unit'),
                                data: isShort ? UnitTextShort : UnitText
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t('texts:general:day')
                            }),
                            showUnitText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t('texts:general:unit')
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps)(Price));


/***/ }),

/***/ 83230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79437);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38799);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43929);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94813);
/* harmony import */ var _material_ui_icons_Add__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63957);
/* harmony import */ var _Loader_Loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96149);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36456);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66026);











function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        quantitySelector: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative'
        },
        btn: {
            padding: 0,
            minWidth: 32,
            width: 32,
            height: 32,
            borderRadius: theme.shape.borderRadius * 3
        },
        btnLoading: {
            cursor: 'default',
            pointerEvents: 'none'
        },
        alignLeft: {
            justifyContent: 'flex-start'
        },
        isSmall: {
            paddingTop: 0,
            '& .MuiButtonBase-root': {
                minWidth: 22,
                width: 22,
                height: 22,
                '&>span>svg': {
                    width: '.75em',
                    height: '.75em'
                }
            },
            '& .quantitySelector__total': {
                height: 32,
                width: 35,
                margin: theme.spacing(0, 0.5)
            }
        },
        disableForcedMinus: {
            '&:disabled': {
                border: "1px solid ".concat(theme.palette.primary.main),
                color: theme.palette.primary.main,
                background: 'transparent'
            }
        },
        total: {
            position: 'relative',
            zIndex: 2,
            width: 50,
            height: 45,
            margin: theme.spacing(0, 1),
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            border: "1px solid ".concat(theme.extraColors.grey),
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.common.white,
            '.isSmall &': {
                width: 52
            },
            '& input': {
                textAlign: 'center',
                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                    '-webkit-appearance': 'none',
                    margin: 0
                },
                '&[type=number]': {
                    '-moz-appearance': 'textfield'
                }
            }
        },
        disableForcedPlus: {
            '&:disabled': {
                color: theme.palette.common.white,
                background: theme.palette.primary.main
            }
        },
        overlay: {
            zIndex: 3,
            position: 'absolute',
            top: -2,
            left: -2,
            right: -2,
            bottom: -2,
            background: 'rgba(255,255,255, .8)',
            backdropFilter: 'blur(2px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            pointerEvents: 'none',
            '&:hover': {
                cursor: 'wait',
                pointerEvents: 'none'
            }
        },
        stockQuantity: {
            fontSize: '0.75rem',
            color: theme.palette.text.secondary,
            width: '100%',
            textAlign: 'center'
        }
    });
});
var mapStateToProps = function(param, ownProps) {
    var stock = param.stock;
    var ref, ref1;
    var ref2;
    var stockElement = (ref2 = stock === null || stock === void 0 ? void 0 : (ref = stock.stockMap) === null || ref === void 0 ? void 0 : ref.get(ownProps.variantSku)) !== null && ref2 !== void 0 ? ref2 : stock === null || stock === void 0 ? void 0 : (ref1 = stock.stockBasket) === null || ref1 === void 0 ? void 0 : ref1.find(function(element) {
        return element.lizeeSKU === ownProps.variantSku;
    });
    return {
        maxStock: stockElement === null || stockElement === void 0 ? void 0 : stockElement.quantity
    };
};
var QuantitySelector = function(param) {
    var value1 = param.value, handleChange = param.handleChange, _min = param.min, min = _min === void 0 ? 0 : _min, max = param.max, small = param.small, isShop = param.isShop, disable = param.disable, align = param.align, loading = param.loading, maxStock = param.maxStock;
    var classes = useStyles();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value1), inputValue = ref[0], setInputValue = ref[1];
    var debouncedHandleChange = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(value) {
            return handleChange(value);
        }, 400);
    }, [
        handleChange
    ]);
    var onQuantityChange = function(e) {
        var value = e.target.value;
        var _inputValue = value === '' ? undefined : Number(value);
        if (_inputValue && _inputValue > maxStock) {
            _inputValue = maxStock;
        }
        setInputValue(_inputValue);
        if (_inputValue !== undefined) {
            debouncedHandleChange(_inputValue);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setInputValue(value1);
    }, [
        value1
    ]);
    // Add cleanup
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            debouncedHandleChange.clear();
        };
    }, [
        debouncedHandleChange
    ]);
    var _obj;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('quantitySelector', classes.quantitySelector, (_obj = {}, _defineProperty(_obj, classes.isSmall, small), _defineProperty(_obj, classes.alignLeft, align === 'left'), _obj)),
                children: [
                    loading && (small ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classes.overlay
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classes.overlay,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader_Loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                    })),
                    !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('quantitySelector__btn', 'quantitySelector__btn--minus', classes.btn, isShop && classes.disableForcedMinus),
                        "data-testid": "removeQuantity",
                        variant: "outlined",
                        color: "primary",
                        type: "button",
                        disabled: value1 === min || disable,
                        onClick: function() {
                            if (value1 !== min) {
                                handleChange(--value1);
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('MuiButtonBase-root', classes.btn, classes.btnLoading)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('quantitySelector__total', classes.total, _defineProperty({}, (classes.isSmall, 'quantitySelector__total--small'), small)),
                        children: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .isB2B */ .tP ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            value: inputValue,
                            onChange: onQuantityChange,
                            type: "number",
                            disableUnderline: true,
                            inputProps: {
                                min: min,
                                max: maxStock
                            }
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: value1
                        })
                    }),
                    !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('quantitySelector__btn', 'quantitySelector__btn--plus', classes.btn, isShop && classes.disableForcedPlus),
                        "data-testid": "addQuantity",
                        variant: "outlined",
                        color: "primary",
                        type: "button",
                        disabled: !!(max && value1 === max) || disable,
                        onClick: function() {
                            if (value1 !== max) {
                                handleChange(++value1);
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Add__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('MuiButtonBase-root', classes.btn, classes.btnLoading)
                    })
                ]
            }),
            _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .isB2B */ .tP && maxStock !== undefined && maxStock !== null || _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .isDisplayBasketProductAvailableQuantity */ .QG && maxStock !== undefined && maxStock !== null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.stockQuantity,
                children: t('texts:basket:remainingInStock', {
                    count: maxStock - value1
                })
            }) : null
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProps)(QuantitySelector));


/***/ }),

/***/ 96780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75154);




var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        root: {
            marginTop: theme.spacing(0.25),
            textAlign: 'left'
        },
        /** Aligné sur `ProductPriceFormat` (`classes.promotion`) pour les cartes produit */ inlineRoot: {
            display: 'inline-flex',
            alignItems: 'center',
            marginLeft: theme.spacing(1)
        },
        badge: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            borderRadius: theme.spacing(0.5),
            fontSize: '75%',
            padding: theme.spacing(0, 0.5),
            display: 'inline-block',
            whiteSpace: 'nowrap'
        }
    });
});
var TaxonPromotionBadge = function(param) {
    var percent = param.percent, _inline = param.inline, inline = _inline === void 0 ? false : _inline, _display = param.display, display = _display === void 0 ? true : _display;
    var classes = useStyles();
    if (!display || percent == null) return null;
    var badge = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(inline ? 'productCard__discount' : 'cart-item__discount', classes.badge),
        children: [
            "-",
            percent,
            "\xa0%"
        ]
    });
    if (inline) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classes.inlineRoot,
            children: badge
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)('cart-item__promo-badge', classes.root),
        children: badge
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (TaxonPromotionBadge);


/***/ }),

/***/ 78931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useTakeback; }
/* harmony export */ });
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31567);
/* harmony import */ var _components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94455);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function useTakeback() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)().t;
    // object to handle take back states
    var productCheckState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(data) {
        return {
            perfectCondition: {
                title: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__/* .prismicText */ .yz)(data === null || data === void 0 ? void 0 : data.perfectcondition, t('texts:takeBack:state_1')),
                desc: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__/* .prismicText */ .yz)(data === null || data === void 0 ? void 0 : data.perfectconditiondefinition, t('texts:takeBack:state_1'))
            },
            veryGoodCondition: {
                title: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__/* .prismicText */ .yz)(data === null || data === void 0 ? void 0 : data.verygoodcondition, t('texts:takeBack:state_2')),
                desc: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__/* .prismicText */ .yz)(data === null || data === void 0 ? void 0 : data.verygoodconditiondefinition, t('texts:takeBack:state_2'))
            },
            goodCondition: {
                title: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__/* .prismicText */ .yz)(data === null || data === void 0 ? void 0 : data.goodcondition, t('texts:takeBack:state_3')),
                desc: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__/* .prismicText */ .yz)(data === null || data === void 0 ? void 0 : data.goodconditiondefinition, t('texts:takeBack:state_3'))
            }
        };
    }, []);
    // object to handle take back product status
    var productCheckStatus = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(data) {
        return {
            ACCEPTED: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__/* .prismicText */ .yz)(data === null || data === void 0 ? void 0 : data.accepted_status, t('texts:takeBack:accepted_status')),
            REFUSED: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__/* .prismicText */ .yz)(data === null || data === void 0 ? void 0 : data.refused_status, t('texts:takeBack:refused_status')),
            WAITING: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_0__/* .prismicText */ .yz)(data === null || data === void 0 ? void 0 : data.in_progress_status, t('texts:takeBack:in_progress_status'))
        };
    }, []);
    return {
        productCheckState: productCheckState,
        productCheckStatus: productCheckStatus
    };
}


/***/ }),

/***/ 7766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZY": function() { return /* binding */ deleteChosenStore; },
  "f0": function() { return /* binding */ inStore_getStoresByOrderId; },
  "c3": function() { return /* binding */ saveChosenStore; }
});

// UNUSED EXPORTS: ACTIONS, DELETE_CHOSEN_STORE, GET_STORES_BY_ORDER_NUMBER_FAILURE, GET_STORES_BY_ORDER_NUMBER_REQUEST, GET_STORES_BY_ORDER_NUMBER_SUCCESS, SAVE_CHOSEN_STORE

// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./redux/services/inStore.ts




var getStoresByOrderId = function(orders) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.warehouseOrder */.KU.warehouseOrder,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE)),
        data: {
            orders: orders
        }
    });
};

;// CONCATENATED MODULE: ./redux/actions/inStore.ts

var ACTIONS = {
    GET_STORES_BY_ORDER_NUMBER_REQUEST: 'GET_STORES_BY_ORDER_NUMBER_REQUEST',
    GET_STORES_BY_ORDER_NUMBER_SUCCESS: 'GET_STORES_BY_ORDER_NUMBER_SUCCESS',
    GET_STORES_BY_ORDER_NUMBER_FAILURE: 'GET_STORES_BY_ORDER_NUMBER_FAILURE',
    SAVE_CHOSEN_STORE: 'SAVE_CHOSEN_STORE',
    DELETE_CHOSEN_STORE: 'DELETE_CHOSEN_STORE'
};
var GET_STORES_BY_ORDER_NUMBER_REQUEST = function() {
    return {
        type: ACTIONS.GET_STORES_BY_ORDER_NUMBER_REQUEST
    };
};
var GET_STORES_BY_ORDER_NUMBER_SUCCESS = function(stores) {
    return {
        type: ACTIONS.GET_STORES_BY_ORDER_NUMBER_SUCCESS,
        stores: stores
    };
};
var GET_STORES_BY_ORDER_NUMBER_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_STORES_BY_ORDER_NUMBER_FAILURE,
        err: err
    };
};
function inStore_getStoresByOrderId(orders) {
    return function(dispatch) {
        dispatch(GET_STORES_BY_ORDER_NUMBER_REQUEST());
        return getStoresByOrderId(orders).then(function(response) {
            return dispatch(GET_STORES_BY_ORDER_NUMBER_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_STORES_BY_ORDER_NUMBER_FAILURE(err));
        });
    };
}
var SAVE_CHOSEN_STORE = function(selectedStore) {
    return {
        type: ACTIONS.SAVE_CHOSEN_STORE,
        selectedStore: selectedStore
    };
};
function saveChosenStore(data) {
    return function(dispatch) {
        dispatch(SAVE_CHOSEN_STORE(data));
    };
}
var DELETE_CHOSEN_STORE = function(deleteOrigin) {
    return {
        type: ACTIONS.DELETE_CHOSEN_STORE,
        deleteOrigin: deleteOrigin
    };
};
function deleteChosenStore(data) {
    return function(dispatch) {
        dispatch(DELETE_CHOSEN_STORE(data));
    };
}


/***/ }),

/***/ 64063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ SAVE_PRISMIC_DOCUMENTS; }
/* harmony export */ });
/* unused harmony export ACTIONS */
var ACTIONS = {
    SAVE_PRISMIC_DOCUMENTS: 'SAVE_PRISMIC_DOCUMENTS'
};
var SAVE_PRISMIC_DOCUMENTS = function(data) {
    return {
        type: ACTIONS.SAVE_PRISMIC_DOCUMENTS,
        data: data
    };
};


/***/ }),

/***/ 63226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ addToCartUtility; }
/* harmony export */ });
var addToCartUtility = function(variantName, quantity, cart, parameters, product1, isTryOut, stock) {
    var ref, ref1, ref2;
    var productAlreadyInCart = product1 !== false && product1 !== 'undefined';
    var totalNumberItems = 0;
    cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(product) {
        totalNumberItems += product.quantity;
    });
    var maxStock = product1 ? product1 === null || product1 === void 0 ? void 0 : (ref2 = product1.product) === null || ref2 === void 0 ? void 0 : ref2.variants[0].maxStock : null;
    var message = {
        message: 'error',
        variantName: variantName,
        productInCart: productAlreadyInCart
    };
    if (!isTryOut) {
        if (productAlreadyInCart) {
            if (quantity === 0) {
                // delete
                message.message = 'delete';
            } else if (quantity > stock || quantity > maxStock) {
                // max in cart
                message.message = 'max';
            } else if (quantity < product1.quantity) {
                // remove
                message.message = 'remove';
            } else if (quantity >= product1.quantity) {
                var ref3, ref4;
                // add
                if ((parameters === null || parameters === void 0 ? void 0 : (ref3 = parameters.items) === null || ref3 === void 0 ? void 0 : ref3.maximumItemsInCart) && quantity > product1.quantity && totalNumberItems + quantity - product1.quantity > (parameters === null || parameters === void 0 ? void 0 : (ref4 = parameters.items) === null || ref4 === void 0 ? void 0 : ref4.maximumItemsInCart)) {
                    message.message = 'limit';
                } else {
                    message.message = 'add';
                }
            }
        } else {
            var ref5, ref6;
            if ((parameters === null || parameters === void 0 ? void 0 : (ref5 = parameters.items) === null || ref5 === void 0 ? void 0 : ref5.maximumItemsInCart) && totalNumberItems + quantity > (parameters === null || parameters === void 0 ? void 0 : (ref6 = parameters.items) === null || ref6 === void 0 ? void 0 : ref6.maximumItemsInCart)) {
                message.message = 'limit';
            } else {
                message.message = 'add';
            }
        }
    } else {
        message.message = 'add tryout';
    }
    return message;
};


/***/ }),

/***/ 43359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ proxySvgUrl; }
/* harmony export */ });
var proxySvgUrl = function(url) {
    return "/api/svg?url=".concat(encodeURIComponent(url));
};


/***/ }),

/***/ 75216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useScrollState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _n8tb1t_use_scroll_position__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27714);


var useScrollState = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), yPos = ref[0], setYPos = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showOnScrollUp = ref1[0], setShowOnScrollUp = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), showOnTop = ref2[0], setShowOnTop = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), showAboveFooter = ref3[0], setShowAboveFooter = ref3[1];
    (0,_n8tb1t_use_scroll_position__WEBPACK_IMPORTED_MODULE_1__/* .useScrollPosition */ .R)(function(param) {
        var prevPos = param.prevPos, currPos = param.currPos;
        setYPos(currPos.y);
        var isScrollUp = currPos.y < prevPos.y;
        var isTop = false;
        if (currPos.y >= 0 && currPos.y < 100) {
            isTop = true;
        }
        if (isScrollUp !== showOnScrollUp) setShowOnScrollUp(isScrollUp);
        isTop ? setShowOnTop(isTop) : setShowOnTop(false);
        var basketPosition = document.getElementById('basket');
        var topBasket = 0;
        if (!basketPosition) {
            return;
        }
        var boundingClientRect = basketPosition.getBoundingClientRect();
        if (boundingClientRect) {
            topBasket = boundingClientRect.top;
        }
        var bodyWithoutFooterHeight = document.body.clientHeight - document.getElementById('basket_visibility_threshold').offsetHeight;
        if (currPos.y - topBasket >= -bodyWithoutFooterHeight) {
            setShowAboveFooter(true);
        } else {
            setShowAboveFooter(false);
        }
    }, [
        showOnScrollUp,
        showOnTop,
        yPos,
        showAboveFooter
    ], null, false, 150);
    return {
        showOnScrollUp: showOnScrollUp,
        showOnTop: showOnTop,
        yPos: yPos,
        showAboveFooter: showAboveFooter
    };
};


/***/ }),

/***/ 59973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getPricingWithTaxInfo; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66026);

var getPricingWithTaxInfo = function(price) {
    var taxIncludedInPrice = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, taxRate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.2;
    var priceHt = price;
    var priceTtc = price;
    if (_constants__WEBPACK_IMPORTED_MODULE_0__/* .displayTtcAndHtPrice */ .r4) {
        if (taxIncludedInPrice) {
            priceHt = price / (1 + taxRate);
        } else {
            priceTtc = price * (1 + taxRate);
        }
    }
    return {
        priceHt: priceHt,
        priceTtc: priceTtc
    };
};


/***/ })

}]);